// The word list is taken from [colordict/colordict.github.io](https://github.com/colordict/colordict.github.io/blob/a402ec135da921771135c63b952eb9d827c995e1/stardict-anatilim-uyghur-chinese_uy-cn-2.4.2.tar.gz).

const wordList = `ئائارگۇ	阿尔高
ئائۇتۇنىت	钙轴云母
ئائۇرېئوترىتسىن	金丝菌素
ئائۇرېئومىتسىن	金霉素
ئائۇرېئۇزىدىن	金斯啶
ئائۇستىنىت	砷锌钙矿
ئائۇستېنىت	奥氏体
ئائۇكسانومېتر	生长计
ئائۇكسانوگرافىيە	生长谱法
ئائۇكسانوگرامما	生长谱
ئائۇكسوخروما	助色团
ئائۇكسوسپورا	复大孢子
ئائۇكسىمون	发育激素
ئائۇگىت	普通辉石
ئائۇۋېرنېلىقلار	奥弗涅人
ئائېبل	艾艾伯尔
ئائېترىئوسكوپ	晴度计
ئائېتسىئۇم	春孢器
ئائېراتور	充气器
ئائېروباكتېرىيە	气杆菌
ئائېرودىن	重航空器
ئائېروزول	烟雾剂
ئائېروستات	轻航空器
ئائېروستاتسىيە	浮空学
ئائېروسىدېرىت	铁陨石
ئائېروسپورىن	气孢菌素
ئائېروفاگىيە	吞气症
ئائېروگېل	气凝胶
ئابئوم	电磁欧姆
ئابالىن	阿巴林
ئاببىتسىئونىزم	废除主义
ئابرائۇم	层积石
ئابروتىن	香蒿素
ئابستراكتلاشتۇرۇش	抽象化
ئابستراكتلىماق	抽提出
ئابستسىزىن	脱落素
ئابسوليۇت	冷吸净油
ئابسىنتىن	苦艾素
ئابسۇردىزم	荒谬主义
ئابفاراد	电磁法拉
ئابلاستىن	制繁殖素
ئابورتىن	流产菌素
ئابورلار	阿博尔人
ئابولىتسىئونىزم	废奴主义
ئابىئوگېنېزىيە	无生源说
ئابىئېتىن	松香素
ئابىئېتېن	松香烯
ئابىدارما	阿毗达磨
ئابىر	节红香粉
ئابىللائۇرۇقى	阿必拉
ئابىپونلار	阿比蓬人
ئابگېنرى	电磁亨利
ئابۇسۇئالار	阿布苏厄
ئابۇكۇمالىت	阿武隈石
ئابۋولت	电磁伏特
ئابېردونلۇقلار	阿伯丁人
ئابېررانت	畸变体
ئابېل	阿贝耳
ئابېلاملار	阿贝兰人
ئاتاكامىت	氯铜矿
ئاتاكسافازىيە	组句不能
ئاتاكسىئوفوبىيە	紊乱恐怖
ئاتاكسىت	杂陨石
ئاتاكەسىپ	门里出身
ئاتالار	阿塔人
ئاتالغۇشۇناسلىق	术语学
ئاتاۋىزم	返祖现象
ئاتاۋىست	返祖体
ئاتباقى	阿提巴格
ئاتتاپۇلگىت	绿坡缕石
ئاتتراكسىيە	形态同化
ئاتراتون	阿特拉通
ئاترازىن	阿特拉津
ئاتروپامىن	阿托胺
ئاتروپىن	阿托品
ئاترىئۇم	气门室
ئاتسېتات	醋酸酯
ئاتسېتارسون	醋酰胺胂
ئاتسېتوئىن	乙偶姻
ئاتسېتوكسىم	丙酮肟
ئاتسېتول	丙酮醇
ئاتسېتومېتىر	醋酸计
ئاتسېتوپىرىن	乙酰比林
ئاتسېتىل	乙酰基
ئاتسېتىلازا	乙酰化酶
ئاتسېتىلخولىن	乙酰胆碱
ئاتسېتىلىد	乙炔化物
ئاتسېتىلېنلىشىش	乙炔化
ئاتسېتۇم	醋制剂
ئاتسېرتانىن	槭丹宁
ئاتسېفات	高灭磷
ئاتسېفاتېمېت	甲胺磷
ئاتسېنوكوئۇمارول	苊香豆醇
ئاتمان	阿特曼
ئاتموسفېرىئۇم	气象仪
ئاتمىشىنچى	第六十
ئاتومىستىكا	原子学
ئاتومىستىكىچىلار	原子学派
ئاتوپىت	氟锑钙石
ئاتوپېن	特异因子
ئاتۋوت	阿特沃特
ئاتۋۇد	阿脱武德
ئاتېئىزملاشتۇرۇش	无神论化
ئاتېلېستىت	砷酸铋矿
ئاتەشپەرەسلىك	拜火教
ئاجاتسىن	阿加新
ئاجارلار	阿扎尔人
ئاجراتقۇچ	分解器
ئاجراتمىلار	分泌物
ئاجرىتىۋالالماسلىق	目迷五色
ئاجرىتىۋالغۇچى	分离工
ئاجمالىن	阿吗灵
ئاخاتىنا	玛瑙螺属
ئاخباراتچلىق	新闻专业
ئاخباراتچىلار	新闻队伍
ئاختۇرۇلغۇچى	被搜查人
ئاخرودېكسترىن	消色糊精
ئاخروماتىن	非染色质
ئاخرومىتسىن	无色霉素
ئاخىللېئىن	蓍草碱
ئاخىللېس	阿基里斯
ئاخىمسا	不伤生
ئادارسمان	骆驼蓬
ئادامىت	水砷锌矿
ئاداپتومېتر	适应计
ئاداڭمېلار	阿当梅人
ئادخېزىۋېمېتر	粘附计
ئاددىيلىقى	简易性
ئادسوربېنت	吸附剂
ئادلۇمىدىن	山缘草定
ئادلۇمىن	山缘草碱
ئادونىدىن	春福寿酊
ئادونىس	阿多尼斯
ئادىفېنىن	解痉素
ئادىپامىد	己二酰胺
ئادىپوسېلليۇلوزا	脂纤维素
ئادىپونىترىل	己二腈
ئادىپويل	己二酰
ئاديۇتانت	普通参谋
ئادۇليارلىشىش	冰长石化
ئادېلىت	砷钙镁石
ئادېنانتېرا	海红豆
ئادېنومېرا	肝胰节
ئادېنىل	腺苷基
ئادېنىن	腺嘌呤
ئادەتلىنىش	养成习惯
ئارائىنلار	阿来因人
ئارابىتول	阿糖醇
ئارابىنوزا	阿拉伯糖
ئاراخنوئىد	蛛网膜
ئارارىبا	中裂豆木
ئاراكارى	阿拉卡
ئارامان	阿拉孟
ئارامىت	杀螨特
ئاراندالار	阿兰达人
ئاراگو	阿喇果
ئاراگونلۇقلار	阿拉贡人
ئاراۋاكان	阿拉瓦坎
ئاراۋكانلار	阿劳坎人
ئاراۋلار	阿劳人
ئاربوۋىرۇس	虫媒病毒
ئاربۇتىن	浆果苷
ئارتروسپورا	节孢子
ئارتۋىن	阿尔特温
ئارتېرىئوگرافىيە	动脉造影
ئارتېرىيىلىشىش	动脉化
ئارخاللاكسىس	初胚变异
ئارخدېئاكون	大助祭
ئارخىئېپىسكوپ	大主教
ئارخىتومىيە	单分裂
ئارخىتېكتۇرا	建筑物
ئارخىفونېما	原音素
ئارخىمېد	阿基米德
ئارخىپخانا	档案馆
ئارخىپشۇناسلىق	档案学
ئارخىپلازما	线原生质
ئارخۇس	奥尔胡斯
ئارخېئوزوي	太古代
ئاردىسىيە	紫金牛
ئاردېئالىت	磷石膏
ئاردېننىت	锰硅铝矿
ئاررېنىت	铍钽铌矿
ئارزرۇنىت	绿铜铅矾
ئارسفېنامىن	胂凡钠明
ئارسلاندەك	生龙活虎
ئارسېنوبىسمىت	羟砷铋矿
ئارسېنوسىدېرىت	菱砷铁矿
ئارسېنولامپرىت	自然砷铋
ئارسېنىد	砷化物
ئارغامچىسىمان	绳条状
ئارفۋېدسونىت	钠铁闪石
ئاركانزاس	阿肯色
ئاركانزاسلىقلار	阿肯色人
ئاركوزا	长石砂岩
ئاركوزىت	长英岩
ئاركىتلار	阿基特人
ئارماتى	阿玛蒂
ئارمادىللار	犰狳类
ئارمانگىت	砷锰矿
ئاروماتلىشىش	芳烃化
ئاروماتىكلىق	芳香性
ئارومورفوز	形态演进
ئارويل	芳酰基
ئارىئانلار	雅利安人
ئارىئېگىت	尖榴辉岩
ئارىبس	中型客车
ئارىزونىت	重钛铁矿
ئارىستوگېنېزىيە	芒状发生
ئارىفمېتىكىلاشتۇرماق	算术化
ئارىلاشتۇرغۇچى	混合者
ئارىلاشقۇچى	干涉人
ئارىلاشماسلىق	超然物外
ئارىللاشتۇرۇش	芳基化
ئارىللود	拟假种皮
ئارىلوكسى	芳氧基
ئارىلىد	酰替芳胺
ئارگىرودىت	硫银锗矿
ئارگىرول	弱蛋白银
ئارگىللان	粘粒胶膜
ئارگىللىت	厚层泥岩
ئارگىنازا	精氨酸酶
ئارگىنىن	精氨酸
ئارگېنتوزا	核蛋白银
ئارگېنتوياروزىت	银铁矾
ئارگېنتىت	辉银矿
ئارگېنتىنالىقلار	阿根廷人
ئارۇشا	马来紫珠
ئارۇنتالار	阿龙塔人
ئارۋېرنىلار	阿维尼人
ئارېئولوگىيە	火星学
ئارېكائىن	槟榔因
ئارېكادېئىن	槟榔啶
ئارېكولىن	槟榔碱
ئارېندالىت	暗绿帘石
ئارېنىگ	阿伦尼格
ئازازۇللۇق	泼妇形象
ئازاندېلار	阿赞德人
ئازبېستىن	滑石棉
ئازغىنلىق	大逆不道
ئازلاكتون	吖内酯
ئازماسلىق	不为所动
ئازوبېنزېن	偶氮苯
ئازوتسىزلىنىش	脱氮作用
ئازورلۇقلار	亚速尔人
ئازوفېنىن	偶氮芬宁
ئازولاكتون	氮内酯
ئازولاكمىن	石蕊精
ئازوللا	红浮萍
ئازومىتسىن	氮霉素
ئازومېتان	偶氮甲烷
ئازوپروتېئىن	偶氮蛋白
ئازىرىدىن	吖丙啶
ئازىنفوسمېتىل	谷硫磷
ئازىگوت	单性合子
ئازۇرىت	蓝铜矿
ئازۇلېن	甘菊蓝
ئاسارون	细辛脑
ئاستاتسىن	虾红素
ئاستاكسانتىن	虾青素
ئاستراتسىيە	越星过程
ئاستراخانىت	白钠镁矾
ئاستروسفېرا	星心球
ئاستروفوتومېترىيە	天体测光
ئاستروكومپاس	天文罗盘
ئاستروماگنېتىزم	天体磁学
ئاسترون	仿天器
ئاسترونائۇتىكا	航天学
ئاستروگنوزىيە	恒星学
ئاستون	阿斯顿
ئاستىگمومېتر	散光计
ئاستېروفىللىت	星叶石
ئاستېرىزم	三星际
ئاسرالماسلىق	无保护
ئاسرىلىشچانلىق	可维护性
ئاسسائى	阿萨依
ئاسساملىقلار	阿萨姆人
ئاسسوتسىئاتسىئونىزم	联想主义
ئاسسونانس	半谐音
ئاسسىدىئولوگىيە	海鞘学
ئاسسىرىيىلىكلەر	亚述人
ئاسسىمىلياتسىئونىست	同化论者
ئاسسېلارلار	阿塞拉人
ئاسسېمبلې	阿桑布列
ئاسسېمبلېر	汇编器
ئاسفال	沥青烯
ئاسفالتسىزلاشتۇرماق	脱沥青
ئاسكارىدول	驱蛔脑
ئاسكوما	囊实体
ئاسىفوناتلار	无管类
ئاسىمپتوتا	渐近线
ئاسپىدوسپېرمىن	白坚木碱
ئاسپىدىنول	绵马醇
ئاسپىرىن	阿司匹林
ئاسپېرگىللىن	曲霉素
ئاسۇرا	阿修罗
ئاسۋان	阿斯旺
ئاسېنوزو	亚砷酰
ئاسەيە	阿世耶
ئاشانتىلار	阿散蒂人
ئاشتاختىسى	擀面板
ئاشرامىت	静修道者
ئاشكروفتىن	钾杆沸石
ئاشلىغۇچ	浸提器
ئاشۇرۇۋەتمەسلىك	不为已甚
ئاغمىچىلىق	机会主义
ئافارلار	阿法尔人
ئافاكىيە	无晶状体
ئافالۇلار	阿法卢人
ئافانىت	隐晶岩
ئافاپتوتروپىزم	失向性
ئافتىتالىت	钾芒硝
ئافرىت	鳞解石
ئافرىقىلىقلار	非洲人
ئاففىنلىق	仿射性
ئافورىست	警句家
ئافولات	唑磷嗪
ئافۋىللىت	柱硅钙石
ئافېنالىقلار	雅典人
ئاقئوت	鬼画笔
ئاقتار	阿克塔尔
ئاقسىلسىزلاشتۇرۇش	除蛋白
ئاقسۇل	鹅口疮
ئاقلانغۇچى	被辩护人
ئاقمۇچ	白胡椒
ئاقنانچىلىق	游手好闲
ئاقىدىغان	行得通
ئاقىرىش	白化现象
ئاقچى	阿克奇
ئاكاتالازىيە	无触酶症
ئاكاتالازېمىيە	无触酶血
ئاكاتسىئىن	金合欢因
ئاكاتسېتىن	金合欢素
ئاكادىئالىت	红菱沸石
ئاكادېمىزم	学院主义
ئاكاردىت	二苯脲
ئاكاروفوبىيە	螨病妄想
ئاكاروفىلىيە	螨植共生
ئاكارولوگىيە	蜱螨学
ئاكاكاتېخىن	类儿茶酚
ئاكانتوزىيە	棘皮症
ئاكانتوزۇئىد	刺个员
ئاكانتوستىل	刺状柱
ئاكانتوسېفالالار	棘头类
ئاكانتولوگىيە	棘刺学
ئاكانتوما	棘皮瘤
ئاكتىن	肌动蛋白
ئاكتىنوئىد	放射线状
ئاكتىنوئېلېكترىك	光化电
ئاكتىنوبرانخ	辐足鳃
ئاكتىنوستوما	辐状口
ئاكتىنوسپېكتاتسىن	壮观霉素
ئاكتىنوفورا	担鳍骨
ئاكتىنومورفىيە	辐射对称
ئاكتىنومىتسىن	放线菌素
ئاكتىنومىتسېس	放线菌
ئاكتىنومىكوما	放线菌肿
ئاكتىنون	锕射气
ئاكتىنىئوخروما	海葵色素
ئاكتىنىدلار	锕系元素
ئاكتىنىدىيە	木天蓼
ئاكتىنىزم	光化性质
ئاكتىنىن	海葵碱
ئاكتىنۇلا	辐射幼虫
ئاكتىپلار	积极分子
ئاكتىپلاشتۇرغۇچ	再生器
ئاكتىۋىزم	行动主义
ئاكتۇئالىزم	现实论
ئاكتۇئالىست	现实论者
ئاكروبلاست	原顶体
ئاكروخوردىت	球砷锰矿
ئاكرولېئىن	丙烯醛
ئاكروگېن	顶生植物
ئاكرىدان	吖啶满
ئاكرىدون	吖啶酮
ئاكرىدىل	吖啶基
ئاكرىفلاۋىن	吖啶黄素
ئاكرىلوفېنون	苯丙烯酮
ئاكرىلونىترىل	丙烯腈
ئاكرىلويل	丙烯酰
ئاكرېئىن	斑蛱蝶素
ئاكسوگامىيە	轴生式
ئاكسىئوماتىكا	公理学
ئاكسىئومىلاشتۇرۇش	公理化
ئاكسىل	五眼果
ئاكسىيولوگىست	价值论者
ئاكسېلېراتور	加速风门
ئاكسېلېرانت	促染剂
ئاكسېنت	节奏重音
ئاكسېنتۇئاتسىيە	重音法
ئاككادلار	阿卡德人
ئاككوردشۇناسلىق	和弦学
ئاككوردلاشتۇرۇش	配和声
ئاككوردىئون	和弦风琴
ئاككوردىيون	手风琴
ئاككۇمۇلياتورخانا	蓄电池室
ئاككۇمۇلياتۇر	蓄电池
ئاكلانلار	阿克兰人
ئاكمىت	锥辉石
ئاكوسمىزم	无宇宙论
ئاكونىتازا	乌头酸酶
ئاكونىتىن	乌头碱
ئاكونىن	阿康碱
ئاكھالار	阿卡人
ئاكۇئاممىن	阿枯胺
ئاكۇستوئوپتىكا	声光学
ئاكۇشېركىلىق	助产学
ئاكۋىتاين	阿基坦
ئاكېرمانىت	镁黄长石
ئاكېنوبېئىت	明延岩
ئالائىت	红苔钒矿
ئالاباندىت	硫锰矿
ئالابۇغداش	三色苋
ئالابۇلىماچ	五颜六色
ئالاسكىت	白岗岩
ئالاغىر	阿拉格尔
ئالاقىلىشىشچانلىق	联络性
ئالاكرېئاتىن	丙氨肌酸
ئالالىت	绿透辉石
ئالامان	乌合之众
ئالاموزىت	硅铅石
ئالانلار	阿兰人
ئالانىل	丙氨酰
ئالانىن	丙氨酸
ئالانگىن	八角枫碱
ئالباسپىدىن	白绵马素
ئالبام	艾尔巴姆
ئالبامىتسىن	阿巴霉素
ئالبورانىت	拉长安岩
ئالبومىتسىن	白霉素
ئالبىت	钠长石
ئالبىتىت	钠长岩
ئالبىنو	白化体
ئالبىچىلار	阿尔巴派
ئالبۇمىن	清蛋白
ئالبۇمىنات	清蛋白盐
ئالبۇمىنلشتۇرۇش	蛋白化
ئالبۇمىنومېتر	清蛋白计
ئالبېدو	反照率
ئالبېدومېتر	反照率计
ئالبېرتول	阿贝树脂
ئالت	童低音
ئالتائىر	河鼓二
ئالتاي	阿尔泰
ئالتروزا	阿卓糖
ئالتىنولوگىيە	射线学
ئالتۇنگۈل	旱金莲
ئالتېئىن	蜀葵因
ئالتېرنارىيە	交链孢属
ئالدازىن	醛连氮
ئالدرىن	艾氏剂
ئالدوزىد	醛糖苷
ئالدوستېرون	醛甾酮
ئالدوفورم	阿尔多仿
ئالدوكېتېن	醛烯酮
ئالدولازا	醛缩酶
ئالدوگېكسوزا	己醛糖
ئالدىمىن	醛亚胺
ئالدىنلىق	优先级
ئالدىنىش	被诱骗
ئالغۇچ	减法器
ئالفا	阿尔法
ئالفاسكوپ	显字器
ئالفاۋېتولوگىست	字母学家
ئالفونسۇس	阿尔芬斯
ئالفۋېن	阿尔芬
ئالقاندىكى	瓮中之鳖
ئالكائىد	北斗七
ئالكارىل	烷代芳基
ئالكالوئىد	生物碱
ئالكالىمېتىر	碱量计
ئالكالېمىيە	碱血症
ئالكاننىن	紫朱草精
ئالكانولامىن	烷醇胺
ئالكوزول	醇溶胶
ئالكوكسىل	烷氧基
ئالكوگولات	乙醇化物
ئالكوگېل	醇凝胶
ئالكىلات	烷基化油
ئالكىلامىن	烷基胺
ئالكىلول	烷基醇
ئالكىلىدىن	次烷基
ئالكېنىل	烯烃基
ئاللانتوئىنازا	尿囊素酶
ئاللانتوئىنن	尿囊素
ئاللوئىئوگېنېز	异态交替
ئاللوئېروتىزم	异体色情
ئاللوبىئوزىس	异生性
ئاللوتىمورف	他形体
ئاللوتېئىزم	异神崇拜
ئاللوزا	阿洛糖
ئاللوستېرىيە	变构性
ئاللوسىندېزىس	异源联会
ئاللوفان	水铝英石
ئاللوفون	音素变体
ئاللوكاتسىيە	地址分配
ئاللوكسانات	阿脲酸盐
ئاللوكسانتىن	双阿脲
ئاللومورف	同质异晶
ئاللومون	利己素
ئاللوپلاستىكلىق	异塑性
ئاللوپۇرىنول	别嘌呤醇
ئاللوگېن	他生物
ئاللىئىن	蒜氨酸
ئاللىدوخلور	草毒死
ئاللىكسىكارب	除害威
ئاللىل	烯丙基
ئاللىلامىن	烯丙胺
ئاللىلۇرېيە	烯丙基脲
ئاللۇئائۇدىت	钠磷锰矿
ئاللۇلوزا	阿洛酮糖
ئاللېئوخېمىكس	它感素
ئاللېرگولوگىيە	变应性学
ئاللېرگىيە	变态反应
ئاللېلوتروپىزم	互引性
ئاللېلوخىمىيە	变异化学
ئاللېمونتىت	砷锑矿
ئاللېن	丙二烯
ئاللېنلار	二烯烃
ئالماشتۇرۇلىدىغانلىق	可交换性
ئالمۇتا	阿拉木图
ئالمېن	阿尔门
ئالوئىزىت	结灰石
ئالوئىن	芦荟素
ئالورلۇقلار	阿洛尔人
ئالىئوت	北斗五
ئالىئېستېرازا	脂肪酯酶
ئالىبى	阿里排
ئالىدادا	照准仪
ئالىشتىت	杂凯迪土
ئالىغايلىق	眼珠牵斜
ئالىنتاتاۋ	毛药柿
ئالىيېشىل	花花绿绿
ئالياسكا	阿拉斯加
ئاليۇموگىدروكالتسىت	铝水钙石
ئاليۇمىناتلاشتۇرۇش	铝酸盐化
ئاليۇمىنوتېرمىيە	铝热法
ئاليۇمىنوسىلىكات	铝硅酸盐
ئاليۇنوگېن	毛矾石
ئالپرېنولول	心得舒
ئالگارروبىن	角豆树素
ئالگرات	阿尔海特
ئالگومان	阿戈曼
ئالگىت	藻类体
ئالگېزىمېتىر	测痛器
ئالھازېن	阿尔哈金
ئالۇندۇم	人造刚玉
ئالۋارلار	阿拉瓦
ئالۋېئاتور	窝状叉棘
ئالۋېئولىت	槽珊瑚类
ئالېكساندىر	亚历山大
ئالېمانلار	阿列曼人
ئالېيرىئوسپورا	粉孢子
ئالېيۇتلار	阿留申人
ئالېپپولۇقلار	阿勒颇人
ئاماترىس	似绿松石
ئامارانتىت	红铁矾
ئامارىللىت	黄铁钠矾
ئامازونىت	天河石
ئامالگاماتور	混汞机
ئامانى	阿玛尼
ئامانىتىن	蝇蕈素
ئامبروزىيە	虫道真菌
ئامبرىت	灰黄琥珀
ئامبلىستېگىت	铁苏辉石
ئامبلىگونىت	锂磷铝石
ئامبولار	安博人
ئامبونلۇقلار	安汶人
ئامبىئوفونىيە	立体混响
ئامت	香水梨
ئامفىبولوگىيە	语义含混
ئامفىكارىئون	双组核
ئاممونال	阿芒拿
ئاممونىئات	氨合物
ئاممونىئاتور	氨化器
ئاممونىئوبورىت	水铵硼石
ئاممونىياك	氨草胶
ئاممونىيلىشىش	氨化作用
ئاممىن	氨络物
ئاممىۋىلىق	群众性
ئامنىئوسكوپ	羊膜镜
ئامنېزىيە	记忆缺失
ئاموباربىتال	戊巴比妥
ئامودىئاخىن	氨酚喹
ئامورتىز	价值摊
ئامورفا	紫穗槐
ئامورلار	阿摩尔人
ئامىترول	杀虫强
ئامىترىپتىلىن	阿密替林
ئامىد	氨化物
ئامىدازا	酰胺酶
ئامىدازون	氨基某腙
ئامىدلاشتۇرۇش	酰胺化
ئامىدوكالىل	氨基草酰
ئامىدوكسىم	酰胺肟
ئامىدول	阿米酚
ئامىدىزم	净土宗
ئامىرىن	香树素
ئامىلازا	淀粉酶
ئامىلودېكسترىن	淀粉糊精
ئامىلوپسىن	胰淀粉酶
ئامىلوپلاست	造粉体
ئامىناتلار	胺化产物
ئامىنازا	氨基酶
ئامىنوئاتسېتوفېنون	氨基乙酮
ئامىنوئاتسېتون	氨基丙酮
ئامىنوئالىزارىن	氨基茜素
ئامىنوئانتراخىنون	氨基蒽醌
ئامىنوئېتان	氨基乙烷
ئامىنوئېتانول	氨基乙醇
ئامىنوبىفېنىل	氨基联苯
ئامىنوبېنزالدېگىد	氨基甲醛
ئامىنوبېنزونىترىل	氨基苄腈
ئامىنوبېنزىدىن	氨基联胺
ئامىنوترىئازول	氨基三唑
ئامىنوتولۇئېن	氨基甲
ئامىنوتىئازول	氨基噻唑
ئامىنوتىئوفېن	氨基噻吩
ئامىنوسىزلاشتۇرۇش	除氨化
ئامىنوسىكلىتول	氨基环醇
ئامىنوكارب	灭害威
ئامىنوكاۋچۇكى	氨基橡胶
ئامىنوكېتون	氨基酮
ئامىنولىز	氨基分解
ئامىنومېتال	氨基金属
ئامىنومېتىل	氨甲基
ئامىنونىتروگېن	氨基氮
ئامىنوپروپانول	氨丙醇
ئامىنوپىرىدىن	氨基吡啶
ئامىنوپىرىن	氨基比林
ئامىنوپېنتان	氨基戊烷
ئامىنوپېپتىدازا	氨肽酶
ئامىنوگلۇكوزا	氨基葡糖
ئامىنوگۇئانىدىن	氨基胍
ئامىگدالا	扁桃体
ئامىگدالوئىد	杏仁岩
ئاميوتونىيە	肌驰缓
ئامپلىترون	增幅管
ئامپلىگراف	摆幅仪
ئامېتابولا	无变态类
ئامېتابولىزم	无变态性
ئامېترىن	莠灭净
ئامېتوپتېرىن	氨甲蝶呤
ئامېرىكىلىقلار	美洲人
ئامېسىت	镁绿泥石
ئانئىزوسپورا	异形孢子
ئانئىزومېتروپىيە	屈光参差
ئانابازىن	新烟碱
ئاناباپتىزم	再洗礼教
ئاناتابىن	新烟草碱
ئاناتازا	锐钛矿
ئاناتومىست	解剖学家
ئاناخرومازىيە	前期核变
ئانارترىيە	言语讷吃
ئانارخىيە	理想国
ئانافىز	远极丝
ئانافىلاتوكسىن	过敏毒素
ئانافىلاكتوگېن	过敏原
ئانافىلاكتىن	过敏素
ئاناكىملار	阿纳金人
ئاناللوبار	正变压线
ئانالىتىكلىق	解析性
ئانالىزمېتىر	分析表
ئانالىزچى	分析员
ئانالىزېر	检偏器
ئانالېپتىك	回苏剂
ئانامورفوز	增节变态
ئانامورفوزېر	失真仪
ئاناناسزارلىق	波罗园
ئاناپلازىيە	退行发育
ئانتاركتىدا	南极洲
ئانتاگونىست	拮抗体
ئانتاگونىيىلىك	对抗性
ئانتراخىنونىل	蒽醌基
ئانترارۇفىن	蒽绛酚
ئانترافلاۋون	蒽黄酮
ئانترافلاۋىن	蒽黄素
ئانتراكسولىت	碳沥青
ئانتراكوزاۋر	石炭蜥
ئانتراكوكسېن	碳沥青质
ئانترانويل	氨茴酰
ئانترانىلونىترىل	氨基甲腈
ئانتراپۇرپۇرىن	蒽红紫素
ئانتروپولوگىست	人类学家
ئانتروپومانسىيە	肠卜术
ئانتروپومورفولوگىيە	拟人学
ئانتروپونىمىيە	人名学
ئانترىتسىد	安锥灭
ئانترىلېن	亚蒽基
ئانترىپول	安锥波
ئانتلېرىت	羟铜矿
ئانتوئىنىت	水钨铝矿
ئانتودىت	石膏花
ئانتوسىئانىدىن	花色素
ئانتوسىئانىن	花色素苷
ئانتوفوبىيە	花恐怖
ئانتوفىللىت	直闪石
ئانتوكسانتىن	花黄色素
ئانتوگرافىيە	花图解
ئانتىئاتوم	反原子
ئانتىئاگرېسسىن	抗攻击素
ئانتىئاگگليۇتىنىن	抗凝集素
ئانتىئوكسىدانت	抗氧剂
ئانتىباريون	反重子
ئانتىبىئوتىك	抗生素
ئانتىتسىپاتسىيە	先现音
ئانتىتوكسىن	抗毒素
ئانتىخلور	去氯剂
ئانتىخىتارىيان	好古之人
ئانتىدېيترون	反氘核
ئانتىرېزونانس	反共振
ئانتىسىكلون	反气旋
ئانتىسىلار	安蒂西人
ئانتىسىممېترىك	反对称
ئانتىسېلېن	反假月
ئانتىسېۋوروتكا	抗血清
ئانتىفورما	背斜形态
ئانتىفونىيە	应答轮唱
ئانتىفوگگانت	防灰雾剂
ئانتىفېرتىللىزىن	反受精素
ئانتىفېرروماگىنىت	反铁磁体
ئانتىفېرروماگىنىتىزم	反铁磁性
ئانتىكارتسىنوگېنېز	抗癌发生
ئانتىكلىنورىيە	复背斜
ئانتىكوئاگۇلىن	抗凝血素
ئانتىكودون	反密码子
ئانتىكورونا	反日冕
ئانتىكۋارك	反夸克
ئانتىلوگىزم	反三段论
ئانتىلىزىن	抗溶素
ئانتىمونات	锑酸盐
ئانتىمونىد	锑化物
ئانتىمېرىدىئان	下子午线
ئانتىنوما	矛盾命题
ئانتىنېيترون	反中子
ئانتىنېيترىنو	反中微子
ئانتىپاتارىيە	角珊瑚
ئانتىپروتون	反质子
ئانتىپىر	安替比尔
ئانتىپىرىن	安替比林
ئانتىگلوبۇلىن	抗球蛋白
ئانتىگورىت	叶蛇纹石
ئانتىگېلىئون	反假日
ئانتىۋىتامىن	抗维生素
ئانتىۋېرتېكس	奔离点
ئانتيوكلۇقلار	安条克人
ئانتېئولوگىيە	反神学
ئانتېدون	海羊齿
ئانتېراكسانتىن	花药黄质
ئانتېمىئون	棕叶饰
ئانتېمىس	春黄菊
ئاندالۇزىت	红柱石
ئاندامانلار	安达曼人
ئاندرالىقلار	安德拉人
ئاندروسپورا	雄孢子
ئاندرولوگىيە	男科学
ئاندروگېن	雄激素
ئاندرېۋزىت	羟绿铜矿
ئاندرېۋس	安德鲁
ئاندوررالىقلار	安道尔人
ئاندوگېنىن	氨豆配基
ئاندىنولار	安迪诺人
ئاندېرتون	安德登
ئاندېرسون	安德逊
ئاندېزىن	中长石
ئاندېزىنىت	中长岩
ئانسسېلم	安瑟伦
ئانسىلىت	碳锶铈矿
ئانسېرىن	鹅肌肽
ئانكېرىت	铁白云石
ئاننونا	牛心果
ئاننيۇلۇس	菌圆环
ئانورتوزىت	斜长岩
ئانورتوزىتلىشىش	斜长岩化
ئانورتىت	钙长石
ئانورېكسىيە	饥不欲食
ئانومالىزم	异常性
ئانومالىست	异常论者
ئانونا	番荔枝
ئانىئون	阴离子
ئانىزالدېگىد	茴香醛
ئانىزول	茴香醚
ئانىسىدىن	茴香胺
ئانىل	缩苯胺
ئانىلىد	酰替苯胺
ئانىلىشىش	雌性化
ئانىلىقلار	雌蕊群
ئانىلىقلىشىش	心皮化
ئانىلىنات	苯胺金属
ئانىلىنو	苯胺基
ئانچىكى	轻描淡写
ئانگارالىت	安加拉石
ئانگارمونىك	非谐性
ئانگلولار	盎格鲁人
ئانگلېزىت	硫酸铅矿
ئانگىئوساركوما	血管肉瘤
ئانگىئولوگىيە	脉管学
ئانگىدرىت	硬石膏
ئانگۇلياتور	角投影器
ئانگېدرون	劣形晶岩
ئانگېلون	安吉笼
ئانگېلونىيە	安吉笼属
ئانېتول	茴香脑
ئانېستىل	麻醉烷
ئانېموسكوپ	风向仪
ئانېمولوگىيە	测风学
ئانېمومېتر	风速表
ئانېمونىن	银莲花素
ئانېۋپلوئىد	非整倍体
ئانېۋپلوئىدلىق	非整倍性
ئايبېلىق	翻车鱼
ئايتوكلار	艾撒克人
ئايدىڭكۆل	艾丁湖
ئايراۋۇق	拂子茅
ئايروخوت	气垫船
ئايروزول	气溶胶
ئايروزىن	航空肼
ئايروفوتوگرافىيە	航空照片
ئايروكالېندار	航空历
ئايرومېخانىكا	航空力学
ئايرومېدىتسىنا	航空医学
ئايرونائۇتىكا	航空学
ئايروپرىبور	航空仪表
ئايروپورت	航空港
ئايروپوچتا	航空邮政
ئايرىغۇچى	分拣员
ئايرىۋېتىش	使隔开
ئايشۇناس	月学家
ئايمارالار	艾马拉人
ئاينىشچانلىق	殊异性
ئايەتۇللا	阿亚图拉
ئاپاتىت	磷灰石
ئاپاخىت	闪辉响岩
ئاپارت	阿伯特
ئاپالايلار	阿帕莱人
ئاپانتولار	阿潘托人
ئاپاياۋلار	阿帕耀人
ئاپاچېلار	阿帕切人
ئاپتاپپەرەسسىمانلار	类葵花属
ئاپتودىزېل	汽车柴油
ئاپتومېتىر	汽车表
ئاپتى	阿普第
ئاپرىئورى	演绎地
ئاپرىئورىست	先天论者
ئاپلانات	齐明镜
ئاپلىت	细晶岩
ئاپوئېنزىم	酶蛋白
ئاپوبازىدىيە	分离担子
ئاپودىزاتسىيە	切趾法
ئاپودېماتا	表皮内突
ئاپورت	阿普提
ئاپوروكاكتۇس	扭仙人指
ئاپورىيە	阿朴啡
ئاپوزىمازا	酒化酶原
ئاپوفانتىك	直逻辑
ئاپوفورومېتر	升华仪
ئاپوفىللىت	鱼眼石
ئاپوللو	阿波罗
ئاپولوگىست	卫道士
ئاپولوگېتىكا	护教学
ئاپومورفىن	阿朴吗啡
ئاپوپلاست	质外体
ئاپوگېئوتروپىزم	背地性
ئاپىئوزا	芹菜糖
ئاپىئىن	芹实苷
ئاپىكل	芹菜脑
ئاپىگېنىن	芹菜配质
ئاپيونىت	锰明矾
ئاپپالاچىيە	阿帕拉契
ئاپېكس	奔赴点
ئاپېلسىنلار	柑橘类
ئاپەتشۇناسلىق	灾害学
ئاچالماسلىق	打不开
ئاچالچى	扳道员
ئاچاگۇئالار	阿查瓜人
ئاچقۇچلۇق	带索引
ئاچچىقىدا	一气之下
ئاچچىقچېچەك	侧金盏花
ئاچۇالار	阿丘族
ئاچېسون	阿切孙
ئاڭقىرالماسلىق	听不出
ئاڭلىغۇسىز	不堪人耳
ئاڭلىقلىق	自觉性
ئاڭلىماسلىق	如风过耳
ئاگادىر	阿加迪尔
ئاگالىت	纤滑石
ئاگامېمنون	阿伽门农
ئاگاھلاندۇرغۇچ	报警器
ئاگاۋ	阿高族
ئاگاۋوزا	龙舌兰糖
ئاگرافا	经外经
ئاگرامماتىزم	语法缺失
ئاگروتېخنىك	农技师
ئاگروتېخنىكا	农业技术
ئاگروستوگرافىيە	草本学
ئاگروستېمما	麦仙翁
ئاگرىئولوگىيە	蛮俗学
ئاگرېسسىن	攻击素
ئاگرېگات	聚集体
ئاگرېگاتلىشىش	团聚作用
ئاگلىفالار	无沟牙类
ئاگلىكون	糖苷配质
ئاگماتىن	胍丁胺
ئاگونىست	主缩肌
ئاگگليومېرانت	附聚剂
ئاگگليۇتىن	凝集素
ئاگگليۇتىنوئىد	类凝集素
ئاگگليۇتىنوگېن	凝集原
ئاگۋىلارىت	辉硒银矿
ئاگېئوتروپىزم	无向地性
ئاۋارلار	阿瓦尔人
ئاۋارۇئىت	铁镍矿
ئاۋاملاشتۇرۇش	平民化
ئاۋانلار	阿万人
ئاۋانگارتلار	先锋派
ئاۋانگاردىزم	先锋主义
ئاۋبرېتىيە	紫花荠
ئاۋتوئانتىبىئوتىك	自身抗体
ئاۋتوئانتىگېن	自身抗原
ئاۋتوبازىدىيە	单孢担子
ئاۋتوبلاست	孤立细胞
ئاۋتوبىئوتىك	自生质
ئاۋتوتروپىزم	向自性
ئاۋتوزوما	常染色体
ئاۋتوسپورا	似亲孢子
ئاۋتوفىتوگراف	印象植物
ئاۋتوكوررېلياتور	自相关器
ئاۋتوكولونىيە	似亲群体
ئاۋتولىت	同源包体
ئاۋتولىزىن	自溶素
ئاۋتومات	自动机
ئاۋتوماتسىيە	自动学
ئاۋتوماتىست	自动论者
ئاۋتومورفىزم	自同构
ئاۋتونومىزم	自主论
ئاۋتوگىپنوز	自我催眠
ئاۋدىئو	声频信号
ئاۋدىئوسپېكتروگراف	声图计
ئاۋدىئولوگىيە	听力学
ئاۋدىئومېتر	听力计
ئاۋدىئومېتىرىست	测听师
ئاۋدىئومېتىرىيە	测听术
ئاۋدىئوگرامما	听力图
ئاۋرورا	曙神星
ئاۋرۇنچىلار	奥隆奇人
ئاۋكالار	奥卡人
ئاۋكلار	奥克人
ئاۋوگادرىت	氟硼钾石
ئاۋىئاتاكىس	出租飞机
ئاۋىئاماتكا	航空母舰
ئاۋىتېن	阿维烯
ئاۋگسبۇرگ	奥格斯堡
ئاۋگىتوفىرې	辉石斑岩
ئاۋگىتىت	玻辉岩
ئاۋگۇستىن	奥古斯丁
ئاۋگۇستۇس	奥古斯都
ئاۋگېلىت	光彩石
ئاۋگېنفىلولوگىيە	眼语言学
ئاۋۇشچانلىق	繁殖力
ئاۋېستا	波斯古经
ئوئاخۇلۇقلار	瓦胡人
ئوئاكلاندلىقلار	奥克兰人
ئوئوزوئىد	卵动物
ئوئوزوما	卵小体
ئوئوسكوپىيە	卵镜术
ئوبرازلاشتۇرماق	形像化
ئوبسىدىئانىت	黑曜石
ئوبسېرۋاتسىئونالىزم	观察主义
ئوبسېرۋاتورىيە	观象台
ئوبلىۋون	奥伯灵倭
ئوبى	和服腰带
ئوبيېكتىپلاشتۇرۇش	客观化
ئوبيېكتىپچىلىق	客观主义
ئوتاقچى	除草工
ئوتاۋىت	菱镉矿
ئوتتومانلار	奥托曼人
ئوتتۇرىدىكىلەر	中间派
ئوتخورلار	食草类
ئوتخورلۇق	草食性
ئوتزوۋىزم	召回主义
ئوتسىمېن	罗勒烯
ئوتوفون	助听器
ئوتولار	奥托人
ئوتىلار	奥提人
ئوخراتوكسىن	赭曲毒素
ئوخلىيالماسلىق	好梦难成
ئوخېئولۇقلار	俄亥俄人
ئودورومېتر	气味计
ئودونتولىت	齿绿松石
ئودونتوگراف	画齿规
ئودىسسا	奥德赛
ئورائونلار	奥昂人
ئوربىترون	奥比特隆
ئورتسىنول	地衣酚
ئورتسېئىن	地衣红
ئورتوئېپىيە	正音学
ئورتوتومىيە	面正交性
ئورتوتىپ	定向型
ئورتوخلورىت	正绿泥石
ئورتودونتىست	正牙学家
ئورتودىخلوروبېنزېن	邻二氯
ئورتوسكوپ	水检眼镜
ئورتوسىلىكات	原硅酸酯
ئورتوسېراكون	直角石锥
ئورتوفېرروسىلىت	正铁辉石
ئورتوكرېزول	邻甲酚
ئورتوكلاس	正长石
ئورتوكۋارتىزىت	正石英岩
ئورتومولېكۇلا	正分子
ئورتونون	正消晕剂
ئورتونېكتىدلار	直泳类
ئورتوگراف	正射影图
ئورتوگېئوسىنكلىن	正地槽
ئورخىدولوگىيە	兰花学
ئوردىنارى	教区主教
ئوردېناتا	纵向坐标
ئوررېرىيە	七政仪
ئورفېئۇس	俄耳甫斯
ئوركنېيلىقلار	奥克尼人
ئوركېستراتسىيە	管弦乐法
ئوركېسترلاشتۇرغۇچى	配器者
ئوركېسترىئون	机械风琴
ئورمانبېگى	林务官
ئورنامېنتالىزم	装饰派
ئورنىتومىمىد	似鸟龙
ئورنىتىن	鸟氨酸
ئورولوگىست	山理学家
ئورولوگىيە	山理学
ئورىيېنتىت	锰柱石
ئورپىن	紫景天
ئورگانزا	透明硬纱
ئورگانوسول	有机溶胶
ئورگانوگېل	有机凝胶
ئورۇ	包装物
ئورۇنلارجىنايىتى	单位犯罪
ئورۇنلىغۇچى	演奏家
ئورېئو	奥里奥
ئورېل	奥廖尔
ئورېگانلىقلار	俄勒冈人
ئوزارك	奥查克金
ئوزوناتور	臭氧化器
ئوزونولىز	臭氧分解
ئوزونىد	臭氧化物
ئوزۇقسىراش	贫营养化
ئوساگېلار	奥萨格人
ئوستمېنلار	奥斯门人
ئوستېئوئىد	类骨质
ئوستېئولىت	土磷灰石
ئوستېئومېترىيە	骨测量法
ئوستېئوپاتىيە	按骨术
ئوستېئوپلاستىيە	骨成形术
ئوسسىللوسكوپ	示波器
ئوسسىللومېتر	脉动仪
ئوسسىللومېتىر	摆动仪
ئوسسىللوگرامما	示波图
ئوسسىللياتسىيە	电磁振荡
ئوسسېتلار	奥塞梯人
ئوسكانلار	奥斯坎人
ئوسمانلىلار	奥斯曼人
ئوسموفورا	发臭团
ئوفان	褐铜矾
ئوفورت	锌版画
ئوفىئولوگىيە	蛇类学
ئوفىت	蛇纹状岩
ئوقۇغۇچ	阅读器
ئوقۇلۇشچانلىق	可读性
ئوقەتچى	实业家
ئوكاياما	冈山市
ئوكتائاتسېتات	八乙酸酯
ئوكتاد	八个一组
ئوكتادېكانول	十八烷醇
ئوكتارخىيە	八王国
ئوكتامېر	八聚物
ئوكتاپېپتىن	八肽霉素
ئوكتوئىد	八字线
ئوكتود	八极管
ئوكتوپلوئىد	八倍体
ئوكتوپلوئىدلىق	八倍性
ئوكساتسىلىن	噁洒西林
ئوكسادىئازول	噁二唑
ئوكسازولىدىن	噁唑烷
ئوكسالۇرىيە	草酸尿
ئوكساممىت	草酸铵石
ئوكسامىتسىن	噁唑霉素
ئوكسامىد	草酰胺
ئوكسانىللىد	草酰替胺
ئوكسفوردلۇقلار	牛津人
ئوكسوفېنارسىن	氧苯肿
ئوكسىئاكانتىن	刺檗碱
ئوكسىتوتسىن	催产素
ئوكسىخلورىد	氯氧化物
ئوكسىدازا	氧化酶
ئوكسىدسىزلاندۇرغۇچ	还原剂
ئوكسىدسىزلانماسلىق	非还原性
ئوكسىدسىزلىغۇچى	还原器
ئوكسىدلانغۇچى	氧化者
ئوكسىدلىنىشچانلىق	可氧化性
ئوكسىسۇلفىد	氧硫化物
ئوكسىفتورىد	氟氧化物
ئوكسىندول	羟吲哚
ئوكسىنىترات	氧硝酸盐
ئوكسىگېناتور	充氧器
ئوكسىگېندان	氧气瓶
ئوككاسىئونالىزم	机缘论
ئوكيانىيىلىكلەر	大洋洲人
ئوكيانىيە	大洋洲
ئوكيېكلار	奥凯克人
ئوكېنىت	水硅钙石
ئولتۇراقلاشقۇچىلار	定居者
ئولدام	奥德姆
ئولدامىت	陨硫钙石
ئولفاكتولوگىيە	嗅觉学
ئولىمپىيە	奥林匹亚
ئولىگوتسېن	渐新世
ئولىگوسىدېرىت	少铁陨石
ئولىگوكلاس	奥长石
ئولىگومىتسىن	寡霉素
ئولىگومېر	寡聚物
ئولىگونىت	菱锰铁矿
ئولىگونۇكلېئوتىد	低核苷酸
ئولىگوگېن	寡基因
ئولىگېمىيە	血量减少
ئولىۋېلار	奥利维人
ئولىۋېنىت	橄榄铜矿
ئولېئوتسىست	油囊体
ئولېئوستېئارىن	油硬脂
ئولېئومېتىر	油比重计
ئولېيە	木犀榄属
ئومارتا	养蜂场
ئومانلىقلار	阿曼人
ئومفاتسىت	绿辉石
ئومماتوفورا	担眼器
ئومماتىن	奥马汀
ئومموخروما	眼色素
ئومۇرتقىلىقلار	脊椎动物
ئونبېشى	十夫长
ئونتولوگىيە	本体论
ئونخوسفېرا	六钩幼虫
ئوننېس	翁纳斯
ئويرات	卫拉特
ئويغىتىشچانلىق	可兴奋性
ئويغۇچ	刻录机
ئويۇقچى	砖雕工
ئوپاتسىمېتىر	暗度计
ئوپال	蛋白石
ئوپتومېتر	视力计
ئوپتوگرامما	视网膜像
ئوپرى	奥普里
ئوپرىسكىۋاتېل	喷雾器
ئوپسونىن	调理素
ئوپسىن	视蛋白
ئوپىزومېتر	曲线计
ئوپىستوگلوسسالار	后舌类
ئوپىستوگلىفالار	后沟牙类
ئوپپوزىتسىيە	对当关系
ئوپېراتسىئونالىزم	操作主义
ئوپېرون	操纵子
ئوچوئا	奥乔阿
ئوڭشالمايدىغان	不堪造就
ئوۋئۇللار	奥尔人
ئوۋابائىن	哇巴因
ئوۋارىن	卵巢素
ئوۋومۇتسىن	卵粘蛋白
ئوۋىد	奥维德
ئوۋېرئېكسپوزىتسىيە	过度曝光
ئوۋېرسپىنلىق	过自旋
ئوۋېركومپېنساتسىيە	过度补偿
ئوۋېرمودۇلياتسىيە	过调制
ئوۋېنىزم	欧文主义
ئىئاتروخىمىيە	医疗化学
ئىئوردانىيىلىكلەر	约旦人
ئىئوكسىنىل	碘苯腈
ئىئونوگرافىيە	离子谱法
ئىئونوگرامما	电离图
ئىئوۋالىقلار	艾奥瓦人
ئىبارىچىلىك	词语癖
ئىبرانىلار	希伯来人
ئىبرەتئالماق	后车之戒
ئىبوگائىن	伊菠因
ئىبېرىت	伊伯利石
ئىتائەتمەنلىك	百依百顺
ئىتاليانلار	意大利人
ئىتتروسېرىت	铈钇矿
ئىتتروكرازىت	钛钇钍矿
ئىتترىئالىت	硅钍钇矿
ئىتتورفلۇئورىت	钇萤石
ئىتتىروتانتالىت	钽钇矿
ئىتتىرىشمەك	推推搡搡
ئىتتەرگۈچ	推进器
ئىتسىيىگەك	假木贼
ئىتقوناق	狗尾草
ئىجابىيلىق	积极性
ئىجادىيەتشۇناسلىق	创造学
ئىجادىيەتچىلىك	创造主义
ئىجازەتنامە	许可证
ئىجتىمائىيلاشتۇرۇش	社会学化
ئىجتىمائىيلىق	社会性
ئىجراچى	执行员
ئىجولىت	霓霞岩
ئىختىئولوگىيە	鱼类学
ئىختىيارىيالىق	随意性
ئىخلاسمنلىك	执著心
ئىخنوگرافىيە	平面图法
ئىددىڭسىت	伊丁石
ئىدوزا	艾杜糖
ئىدوكرازا	符山石
ئىدىئوبلاست	自形变晶
ئىدىئومورفىزم	本形作用
ئىدىئومېتر	人差计
ئىدىئوگلوززىيە	自语症
ئىدىتول	艾杜糖醇
ئىدىيىچىلىك	理念主义
ئىدىيىۋىلىك	思想性
ئىدېئاللاشتۇرۇش	理想化
ئىرازېر	红外激射
ئىرقچىلىق	种族主义
ئىرون	鸢尾酮
ئىرىدوسمىن	铱锇矿
ئىرىدىن	香菖苷
ئىرىزىن	鸢尾素
ئىرۇلالار	伊鲁拉人
ئىرېلاندىيىلەشتۈرۈش	爱尔兰化
ئىرېن	鸢尾萘
ئىزاتوگېن	靛红原
ئىزدىگۈچ	搜索器
ئىزدىگۈچى	搜索者
ئىزدەشمەسلىك	不相闻问
ئىزشۇناسلىق	痕迹学
ئىزوئاللوكسازىن	异咯嗪
ئىزوئامىلېن	异戊烯
ئىزوئاگلۇتىناتسىيە	同族凝集
ئىزوئوكتان	异辛烷
ئىزوئېنزىم	同功酶
ئىزوباربالوئىن	异芦荟苷
ئىزوبازا	等基线
ئىزوبورنىل	异冰片基
ئىزوبورنېئول	异冰片
ئىزوبۇتىرىل	异丁酰
ئىزوبۇتىل	异丁基
ئىزوبۇتىلېن	异丁烯
ئىزوتاكسىيە	全同立构
ئىزوتېنىسكوپ	等张力计
ئىزوخرومات	等色线
ئىزوخرون	等时线
ئىزوخرونوگراف	等时仪
ئىزوخىنولىن	异喹啉
ئىزودرىن	异艾氏剂
ئىزودىسپېرسىيە	等分散
ئىزودىمورفىزم	同二形性
ئىزودۇرېن	异杜烯
ئىزورېئاگېنت	同型物
ئىزوسافرول	异黄樟脑
ئىزوستازىيە	地壳均衡
ئىزوسىئانىد	异氰化物
ئىزوسىئانىن	异花青
ئىزوسپورا	同形孢子
ئىزوفتوروفات	异氟磷
ئىزوفلاۋون	异黄酮
ئىزوفورون	异佛尔酮
ئىزوكارپېل	等心皮
ئىزوكراكىنگلەش	异构裂化
ئىزوكلازىت	水磷钙石
ئىزوكورىدىن	异紫堇定
ئىزوكۋېرتسىترىن	异槲皮苷
ئىزوليات	纯分离体
ئىزولياتۇر	非导体
ئىزولېيتسىن	异亮氨酸
ئىزومالتوزا	异麦芽糖
ئىزومېتروپىيە	等折光性
ئىزومېرازا	异构酶
ئىزومېرلىشىش	异构化
ئىزونىئازىد	异烟肼
ئىزوپاراففىن	异链烷烃
ئىزوپروپالىن	异乐灵
ئىزوپروپانولامىن	异丙醇胺
ئىزوپروپىل	异丙基
ئىزوپروپىلىدېن	异丙叉
ئىزوپروپېنىل	异丙烯基
ئىزوپۇلېگول	异蒲勒
ئىزوپېللېتىئېرىن	异石榴碱
ئىزوپېنتان	异丙烷
ئىزوپېنتىل	异戊基
ئىزوگامىيە	同配生殖
ئىزوگىدرىك	等氢离子
ئىزوگېمولىز	同种溶血
ئىزوگېن	等基因
ئىزوۋالېرالدېگىد	异戊醛
ئىزوۋالېرىل	异戊酰基
ئىسبىسا	伊斯比沙
ئىستىراتېگىيشۇناسلىق	战略学
ئىستىغپارخانا	忏悔室
ئىستىقباللىق	大有可为
ئىستىلىستىكا	修辞学
ئىستېمالچىلار	消费者
ئىسرائىلىيىلىكلەر	以色列人
ئىسسېئون	伊塞昂
ئىسقىرتقا	太平鸟
ئىسكىرىپكا	小提琴
ئىسكىرىپكىچى	小提琴手
ئىسلام	伊斯兰
ئىسلاندىيىلىكلەر	冰岛人
ئىسلاھاتچىلىق	改良主义
ئىسلىغۇچ	熏烟器
ئىسلىنىش	二手烟
ئىسيانچى	造反者
ئىسپانكا	臂挟帽
ئىسپىراپكا	病假条
ئىسپىرتومېر	酒精计
ئىشتانپايپاق	连脚裤
ئىشرەتخانا	下等去处
ئىشكىلدىت	绢蛇纹石
ئىشلىتىلىشچانلىق	可用性
ئىشلەتمەسلىك	打入冷宫
ئىشلەپچىقارغۇچى	生产者
ئىشۋازلىق	事务主义
ئىشەنگەك	耳朵软
ئىغۋاچى	造谣者
ئىقتىدارلىقلىق	能行性
ئىقتىسادشۇناسلىق	经济学
ئىقتىسادۋازلىق	经济主义
ئىكسىئون	伊克希昂
ئىككىيۈزلىمىچى	两面派
ئىكونوسېنتىر	像中心
ئىكونولوگىيە	圣像学
ئىكونومېترىيە	量影术
ئىلاستىكلىقى	可塑性
ئىلاھىم	艾罗欣
ئىلتىجا	正祭序经
ئىلسېماننىت	蓝钼矿
ئىللىت	伊利石
ئىلليۇسىئونىزم	错觉主义
ئىللەتسىز	尽善尽美
ئىلمىيلىق	学术性
ئىلمېنورۇلىت	黑金红石
ئىلمېنىت	钛铁矿
ئىلوتلار	希洛人
ئىلوتىتسىن	依诺卷新
ئىلىيىلىكلەر	伊利亚人
ئىلگىرىكىدەكلا	日仍然
ئىلگىرىلىمەسلىك	裹足不前
ئىلگىرىلەتمەك	向前推进
ئىلۋائىت	黑柱石
ئىلېزىت	集晶锰矾
ئىمام	伊玛目
ئىمامەت	教长国
ئىماگىزم	意象主义
ئىمكانىيەتچىلەر	可能派
ئىممانېنتىست	内在论者
ئىمموبىلىزم	不动主义
ئىممۇنوئادسوربېنت	免疫吸剂
ئىممۇنوئاسسىيە	免疫测定
ئىممۇنوئېلېكتروفورېز	免疫电泳
ئىممۇنوتېراپىيە	免疫疗法
ئىممۇنوخىمىيە	免疫化学
ئىممۇنودىئاگنوز	免疫诊断
ئىممۇنودىففۇزىيە	免疫扩散
ئىممۇنوفلۇئورېسسېنسىيە	免疫荧光
ئىممۇنولوگىيە	免疫学
ئىممۇنولىز	免疫溶解
ئىممۇنولىزىن	免疫溶素
ئىممۇنوگېمولىز	免疫溶血
ئىممۇنوگېن	免疫原
ئىممۇنىتېتلىق	免疫性
ئىممېرسىئونىزم	浸礼主义
ئىموگولىت	伊毛缟石
ئىمىدازولىل	咪唑基
ئىمىدازولىن	咪唑啉
ئىمىدوگېن	亚胺基
ئىمىنونىتروگېن	亚胺型氮
ئىمىپرامىن	丙咪嗪
ئىمپاكتور	冲击器
ئىمپاكتىت	冲击石
ئىمپرېسسىئونىزم	印象主义
ئىمپسونىت	脆沥青
ئىمپورتچى	进口商
ئىمپېرىسسىئونىزم	印象派
ئىمېرىنىت	钠透闪石
ئىناقسىزلىق	关系不和
ئىنتروئىت	进阶经
ئىنتروسپېكسىئونىزم	内省主义
ئىنتروگرېسسىيە	种质渗入
ئىنتۇئىتىئونىزم	直觉主义
ئىنتېرروگاتور	询问机
ئىنتېرستادىئال	间冰段
ئىنتېرفېرون	干扰素
ئىنتېرفېرونوگېن	干扰素原
ئىنتېرفېروگرامما	干涉图
ئىنتېرمىگراتسىيە	相互迁栖
ئىنتېرناتسىئوناللاشماق	国际化
ئىنتېرپروگلوتتىد	节间腺
ئىنتېرپرىنتېر	转换机
ئىنتېرپولياتسىيە	插值法
ئىنتېرپولياتور	转发器
ئىنتېرۋېنتسىئونىزم	干涉主义
ئىنتېللېكتۇئالىزم	理智主义
ئىنتېگراف	积分仪
ئىنجىلىزم	福音主义
ئىنجىلچىلىق	圣经主义
ئىنداكونىتىن	印乌头碱
ئىندامىن	吲达胺
ئىندانترون	靛蒽醒
ئىندانترېن	阴丹士林
ئىندوفېنىن	靛吩啶
ئىندولوگىست	印度学家
ئىندولوگىيە	印度学
ئىندولىل	吲哚基
ئىندولىن	吲哚满
ئىندوگېن	吲哚根
ئىندىئانلار	印第安人
ئىندىن	大后天
ئىندىگوزول	溶靛素
ئىندۇرىت	殷多来脱
ئىندۇكتومېتر	电感计
ئىندۇكتىۋىزم	归纳主义
ئىندۇكسىيىلىك	感应式
ئىندۇكسىيىلەش	施电感
ئىندېربورىت	变水硼石
ئىندېكسلاشتۇرۇش	指数化
ئىنسانشۇناسلىق	人类学
ئىنستىتۇتسىئونالىزم	立法主义
ئىنسپىراتسىئونىست	灵感论者
ئىنسۇلىن	胰岛素
ئىنسۇلىنازا	胰岛素酶
ئىنسېكتوۋېردىن	虫绿素
ئىنفانتاچە	印凡塔式
ئىنفراپروتېئىن	变性蛋白
ئىنقىلابىيلىشىش	革命化
ئىنكابلوك	因加百录
ئىنكارىي	否定性
ئىنكارچىلىق	虚无主义
ئىنكالار	印加人
ئىنكلىنومېتىر	磁倾计
ئىنوسىلىكات	链硅酸盐
ئىنوگېن	肌收缩原
ئىنىتسىئاتور	引发剂
ئىنيولىت	板硼钙石
ئىنگرىئانلار	因格拉人
ئىنگىبىتور	抑制剂
ئىنۇلازا	菊粉酶
ئىنۇلىن	旋覆花素
ئىنۋېرتېر	逆变器
ئىنۋېنسىيە	创意曲
ئىپادىچىلىك	表现主义
ئىپازىن	草怕津
ئىپسونىت	残沥青
ئىگنىترون	引燃管
ئىگوروتلار	怡戈罗人
ئىگىلىگۈچى	占据者
ئىۋانېنكو	伊凡宁柯
ئىۋرىق	洗手瓶
ئىۋېس	爱佛斯
ئىېتسېنىلار	爱西尼人
ئۆتكۈزمەسلىك	不可人性
ئۆتۈشچانلىق	透射率
ئۆتۈشچانلىقى	透射比率
ئۆتۈكچى	黄守瓜
ئۆتۈنگۈچى	让与人
ئۆتەلمەسلىك	过不去
ئۆتەلىمەك	过得去
ئۆردەكتۇمشۇق	鸭嘴兽
ئۆزلەشتۈرۈشچانلىق	消化率
ئۆزىمىز	我们自己
ئۆزىنىمۇ	知己知彼
ئۆزىڭىز	你本人
ئۆزگىرىشچانلىقى	转化率
ئۆزگەرتكۈچى	改变者
ئۆزگەرمەسلىك	不变性
ئۆزەمچىلىك	自我感觉
ئۆزەڭ،ۆزىڭىز	你自已
ئۆزەڭلار	你们自已
ئۆسكىلەڭ	高个子
ئۆسۈملۈكخورلار	食植类
ئۆسۈمچە	附属丝
ئۆكتىچىلەر	反对派
ئۆكتەبرىستلار	十月党人
ئۆلچەمشۇناس	计量学家
ئۆلچەمشۇناسلىق	计量学
ئۆلچەملەشتۈرگۈچى	标准化员
ئۆلۈمتۈك	蔫呼呼
ئۆلۈۋالغۇچى	自杀者
ئۆمۈچۈكسىمانلار	蛛形类
ئۆنچە	禾束堆
ئۆپكىسىزلەر	无肺类
ئۆپكىلىكلەر	有肺类
ئۆچكىساقال	山羊胡子
ئۆچۈرۈلۈشچانلىق	可擦性
ئۆگەنگۈچى	学习者
ئۇئىتتېرىك	惠特里克
ئۇئىنتالار	犹因他人
ئۇبىسېمىخىنون	泛半醌
ئۇبىكىتارىئان	基在论信
ئۇبىكىتىزم	基遍在论
ئۇتىلىتارىزم	实利性质
ئۇد	乌德琴
ئۇدارسىز	无节拍
ئۇرات	尿酸盐
ئۇراتسىل	尿嘧啶
ئۇرانات	铀酸盐
ئۇرانوتورىئانىت	方铀钍石
ئۇرانوتورىت	铀钍矿
ئۇرانوسفېرىت	纤轴铋矿
ئۇرانوسىرتسىت	钡铀云母
ئۇرانوسپىنىت	砷钙铀矿
ئۇرانوفان	硅钙铀矿
ئۇرانولوگىيە	天文学
ئۇرانىت	铀云母
ئۇرانىنىت	晶质铀矿
ئۇرباتسىد	福美甲胂
ئۇرتىكارىيە	荨麻疹
ئۇرغۇشۇناسلىق	重音学
ئۇروبىلىنوگېن	尿胆素原
ئۇروكىنازا	尿激酶
ئۇرولوگىست	泌尿学家
ئۇرولوگىيە	泌尿科学
ئۇروپورفىرىن	尿卟啉
ئۇروگاسترون	尿抑胃素
ئۇرىكازا	尿酸酶
ئۇرىكولىز	尿酸分解
ئۇرىنومېتر	尿比重计
ئۇرچۇقسىمان	纺锤形
ئۇرۇئېرىترىن	尿红质
ئۇرېئومېتر	尿素计
ئۇرېتانو	氨酯基
ئۇرېتروسكوپ	尿道镜
ئۇرېتىدىن	尿丁啶
ئۇرېدوسپورا	夏孢子
ئۇرېدىنولوگىيە	锈菌学
ئۇرېدىنىيە	夏孢子堆
ئۇرېيلېن	次脲基
ئۇرېيىت	陨铬石
ئۇزارتقۇچ	延长器
ئۇزارتقۇچى	延长者
ئۇزارىن	乌扎林
ئۇزاقلىق	长期性
ئۇزىتىش	传导率
ئۇزىرىماق	长起来
ئۇستالف	干淋溶土
ئۇستىلاگو	干氧化土
ئۇستۇلت	干老成土
ئۇستېرت	干变性土
ئۇسسىنگىت	紫胞石
ئۇسسۇلچى	舞蹈家
ئۇسقۇچ	攫取勺
ئۇشابتى	乌沙比
ئۇفولوگىيە	飞碟学
ئۇقماسلىق	殊不知
ئۇلاشماس	不连续
ئۇلاشماسلىق	不连续性
ئۇلاقسىز	无联接
ئۇلانماس	不连接
ئۇلترائىزم	过激论
ئۇلتراسونوگراف	超声谱仪
ئۇلترامىكروسكوپ	超显微镜
ئۇلترامىكرومېتىر	超测微计
ئۇلتراۋىرۇس	微小病毒
ئۇلترون	乌尔特管
ئۇلماننىت	锑硫镍矿
ئۇلمىن	棕腐质
ئۇلىشالمالىق	赶不上
ئۇلىغۇچى	连接员
ئۇلپان	乌尔班
ئۇلۇغۋارئىرادە	豪情壮志
ئۇلۋوسپىنېل	钛尖晶石
ئۇمانگىت	红硒铜矿
ئۇماچلىغۇچ	打浆机
ئۇماچلىغۇچى	打浆工
ئۇمبېللىفېرون	伞形酮
ئۇمبېللۇلون	伞桂酮
ئۇمىۋالنىك	盥洗盆
ئۇنىتارىئانىزم	一位论
ئۇنىتارىزم	神格论
ئۇنىفورمىتارىئانىزم	均变论
ئۇنچىۋالا	怎么样
ئۇنگېماخىت	碱菱铁矾
ئۇنۋېرساللاشتۇرۇش	通用化
ئۇيغاق	毫无睡意
ئۇيۇتقۇچ	聚结器
ئۇيۇتماق	胶凝化
ئۇيۇش	胶凝作用
ئۇيۇشقاقلىق	凝聚力
ئۇيۇشۇش	肌肤不仁
ئۇپانىشاد	奥义书
ئۇپۇقچەمبىر	地平圈
ئۇچقۇ	飞行器
ئۇچقۇلاق	三叶草
ئۇچقۇنلاتقۇچ	火花塞
ئۇچقۇچىلار	飞行人员
ئۇچلىغۇچ	卷笔刀
ئۇچۇرشۇناسلىق	信息学
ئۇچۇرچانلىق	信息性
ئۇچۇشچان	易挥发
ئۇگلىگىت	锆钙钛矿
ئۇۋاتقۇچ	粗碎轧机
ئۇۋاقلاشتۇرغۇچى	破碎工
ئۈرۈمچى	乌鲁木齐
ئۈزگۈچ	断续器
ئۈزگۈچىلەر	游走类
ئۈزۈلدۈرمەسلىك	细水长流
ئۈزۈلۈكسىزتوك	持续电流
ئۈزۈمزارلىق	葡萄园
ئۈزۈمسىمان	葡萄状
ئۈزۈملۈك	葡萄地
ئۈزۈمگۈل	四季海棠
ئۈستقۇرۇلما	上层建筑
ئۈلپەتچىلىك	够交情
ئۈمىدسىرلىك	悲观主义
ئۈمىدسىزلەن	垂头丧气
ئۈنۈمشۇناسلىق	工效学
ئۈگۈت	待磨谷物
ئېئوسفورىت	磷铝锰矿
ئېئۇخلورىن	碱铜矾
ئېئۇدالېن	优达烯
ئېئۇكسېنىت	黑稀金矿
ئېئۇلىت	易熔辉石
ئېبۇللىئومېتر	沸点计
ئېتالون	标准器
ئېتامبۇتول	乙胺丁醇
ئېتامىۋان	乙迷奋
ئېتانسىزلاشتۇرۇش	脱乙烷
ئېتانولامىن	乙醇胺
ئېتانولىز	乙醇分解
ئېتترىنگىت	钙矾石
ئېتسدىزون	蜕皮激素
ئېتنولوگىيە	人种学
ئېتنومۇزىكولوگىيە	民族乐学
ئېتود	练习曲
ئېتوكسى	乙氧基
ئېتوكسىد	乙醇盐
ئېتوكسىل	羟乙基
ئېتوپروپ	灭克磷
ئېتوگرامما	习性谱
ئېتىئوفېنكارب	杀虫丹
ئېتىئولات	抑草威
ئېتىئون	乙硫磷
ئېتىئوپورفىرىن	初卟啉
ئېتىراپنامە	确认书
ئېتىرىمول	乙菌定
ئېتىشقۇچى	枪战手
ئېتىمېما	文字演绎
ئېتىنىل	乙炔基
ئېتېفون	乙烯利
ئېتېم	伊特姆
ئېخىنوخروما	棘皮色素
ئېخىنومىتسىن	棘霉素
ئېخىنوپسىن	蓝刺头素
ئېخىنىت	棘皮胆
ئېدمونتون	埃德蒙顿
ئېدىتلىق	井井有条
ئېدىسون	爱迪生
ئېدىنگتونىت	钡沸石
ئېدۇئىلار	埃杜维人
ئېدۋاردېئانلار	爱德华派
ئېدېنىت	浅闪石
ئېربون	抑草蓬
ئېرستېد	奥斯特
ئېروزىئونىست	侵蚀说者
ئېروس	爱神星
ئېرىئوخالتسىت	水氯铜矿
ئېرىئودىكتيول	网叶木酚
ئېرىئونىت	毛沸石
ئېرىتروئىدىن	刺桐定
ئېرىترودېكسترىن	显红糊精
ئېرىتروزا	赤藓糖
ئېرىتروزىدېرىت	红钾铁盐
ئېرىتروزىنتسىت	锰纤锌矿
ئېرىتروسكوپ	红视装置
ئېرىتروفلېئىن	围涎树碱
ئېرىتروكرۇئورىن	类血红素
ئېرىترولېئۇكېمىيە	红白血病
ئېرىترومىتسىن	红霉素
ئېرىتروپتېرىن	红蝶呤
ئېرىتروپسىن	眼红素
ئېرىترىتول	赤藓醇
ئېرىتكۈچىلىشىش	溶剂化
ئېرىسىپېلوترىكس	红皮杆菌
ئېرىشچان	可熔性
ئېرىكىت	硅磷铈石
ئېرىگۈچ	熔融体
ئېرگوتامىن	麦角胺
ئېرگوتوكسىن	麦角毒素
ئېرگوتىئونېئىن	麦硫因
ئېرگوستېرول	麦角甾醇
ئېرگوكرىستىن	麦角嵴亭
ئېرگوكورنىن	麦角考宁
ئېرگونوۋىن	麦角诺文
ئېرگوگرام	测力图
ئېرېمولوگىيە	沙漠学
ئېرېپسىن	肠肽酶
ئېرەكتە	大丈夫
ئېرەنسىزلىك	掉以轻心
ئېزىقتۇرۇشچانلىق	诱惑性
ئېستراگول	草蒿脑
ئېستېگرامما	埃斯特图
ئېسكۇلىن	七叶灵
ئېسكۇلۇس	七叶树
ئېسكۇلېتىن	七叶树亭
ئېسىلىشىۋالماق	无理强辩
ئېشاپپې	埃夏泼
ئېشىنىت	易解石
ئېغىرلاتقۇچ	加重器
ئېفرايمىتلار	以法莲人
ئېففۇزىئومېتر	隙透计
ئېففېكتور	效应器
ئېفىرات	醚化物
ئېفىرىزاتسىيە	醚催作用
ئېفىكلار	埃菲克人
ئېفېر	天体要素
ئېفېرمېرىدا	星历表
ئېقىندى	流出物
ئېكاد	境范型
ئېكتادېنىئۇم	外胚附脲
ئېكتوستروما	外子座
ئېكتومېرا	外裂球
ئېكتوپلاست	外质膜
ئېكتوگونىيە	外生效应
ئېكتوگېنىيە	外生现象
ئېكدېمىت	氯砷铅矿
ئېكرىبېللاتلار	无筛器类
ئېكزېمىلاشقان	湿疹化
ئېكزېمپلارىزم	范型论
ئېكسارخ	宗主教
ئېكستراپولياتسىيە	外推法
ئېكستېنسىمېتر	伸长计
ئېكسسىتونىكا	激子学
ئېكسوتوكسىن	外毒素
ئېكسودېرما	外皮层
ئېكسوفورىيە	外隐斜视
ئېكسوكرىنولوگىيە	外分泌学
ئېكسومورفىزم	外变质
ئېكسوگېنوت	外基因子
ئېكسپلوزىمېتىر	爆炸计
ئېكسپورتچى	出口商
ئېكسپېدىتور	协调员
ئېكلوگىت	榴辉岩
ئېكوسفېرا	生态圈
ئېكوفېنوتىپ	生态显型
ئېكونومىت	和谐派
ئېكگونىن	芽子碱
ئېكۋادور	厄瓜多尔
ئېكۋىلار	埃魁人
ئېكۋىلىن	马烯雌酮
ئېكۋىلېنىن	马萘雌酮
ئېكۋىپروبابىلىزم	等几率论
ئېلائىئوپلاست	造油体
ئېلائىدىن	反油酸精
ئېلائېئولىت	脂光石
ئېلاتېرىئۇم	喷瓜质
ئېلاتېرىن	喷瓜素
ئېلاستومېتر	弹力仪
ئېلاستومېتىر	弹性计
ئېلاستوپلاستىكلىق	弹塑性
ئېلاستىن	弹性蛋白
ئېلاسموسائۇر	薄片龙
ئېللاگىتاننىن	鞣花丹宁
ئېللىپسومېتر	椭度计
ئېللىپسوگراف	椭圆规
ئېللېستادىت	硅磷灰石
ئېلىستېر	埃尔斯特
ئېليۇترىئاتور	淘选器
ئېلپازولىت	钾冰晶石
ئېلپىدىت	斜钠锆石
ئېلېدوئىزىن	爱力多生
ئېلېكامپان	土木香
ئېلېكترستاتىكا	静电学
ئېلېكترلەشتۈرمەك	电气化
ئېلېكتروئوكۇلوگرامما	眼电图
ئېلېكتروئېنسېفالوگرامما	脑电图
ئېلېكتروبىئولوگىيە	生物电学
ئېلېكتروخىمىيە	电化学
ئېلېكترودىئالىز	电渗析
ئېلېكترودىنامىكا	电动力学
ئېلېكترودېكانتاتسىيە	电滗析
ئېلېكترورادىئاتسىيە	电致辐射
ئېلېكتروسول	电溶胶
ئېلېكتروسىنتېز	电合成法
ئېلېكتروسېمونت	电制水泥
ئېلېكتروفوتوگرافىيە	电子摄影
ئېلېكتروفور	起电盘
ئېلېكتروكوئاگۇلاتسىيە	电凝法
ئېلېكتروكورتىكوگرامما	皮质电图
ئېلېكتروكىنېتىكا	动电学
ئېلېكترولىزاتور	电解物
ئېلېكترومودۇلياتسىيە	电调制
ئېلېكترومىگراتسىيە	电迁移
ئېلېكتروميوگرافىيە	肌电图学
ئېلېكتروميوگرامما	肌电图
ئېلېكترومېخانىكا	机电学
ئېلېكترونىكا	电子学
ئېلېكتروپاتولوگىيە	电病理学
ئېلېكتروگرافىت	电炉石墨
ئېلېكتروگرامما	电位记录
ئېلېكتروگېن	光电分子
ئېلېكترېت	驻极体
ئېلېمول	榄香醇
ئېلېمىتسىن	榄香素
ئېماسكۇلياتور	阉割器
ئېماناتسىئونىزم	流射说
ئېمانومېتر	射气仪
ئېماگرامما	埃玛图
ئېمبرىئولوگ	胚胎学家
ئېمبولومېرىزم	并椎式
ئېمبولىت	氯溴银矿
ئېممونسىت	绿铁碲矿
ئېموتىۋىزم	情绪论
ئېمودىن	大黄素
ئېمىتكۈچى	哺乳者
ئېمپرېسسىت	粒碲银矿
ئېمپلېكتىت	硫铜铋矿
ئېمۇلسىن	苦杏仁酶
ئېمۇلسىيىلەشتۈرگۈچ	乳化器
ئېمېتىن	依米丁
ئېمېرالدىن	祖母绿定
ئېنارخىستلار	安纳分子
ئېنارگىت	硫砷铜矿
ئېنالىت	变铀钍矿
ئېنانتىئومورفىزم	对映形态
ئېنتسېلىيە	扁果菊
ئېنتوموئۇروخروما	虫尿色素
ئېنتوموستراكالار	切甲类
ئېنتوموسپورىئۇم	虫形孢属
ئېنتېروكىنازا	肠激酶
ئېنتېروگاسترون	肠抑胃素
ئېنتېروگىدروتسېل	肠水腔
ئېنددوفاللۇس	内阳茎
ئېندلىخىت	砷钒铅矿
ئېندوتوكسوئىد	类内毒素
ئېندوتوكسىن	内毒素
ئېندوتىئون	因毒磷
ئېندودونتىيە	牙髓病学
ئېندودېرمىلىشىش	内胚层化
ئېندوزوما	核内体
ئېندوستوما	内珠孔
ئېندوسكوپ	内窥镜
ئېندوسمومېتر	内渗仪
ئېندوكاردىت	心内膜炎
ئېندوكاردىيە	心内膜
ئېندوكاننىبالىزم	族内相食
ئېندومورف	内容体
ئېندومورفىزم	自同态
ئېندوگېنون	内基因子
ئېنستاتىت	顽火辉石
ئېنسېفالىن	脑啡肽
ئېنولات	烯醇化物
ئېنولازا	烯醇化酶
ئېنىقسىزلىق	不定性
ئېنىقلانغۇچى	中心词
ئېنىقلىۋالماق	探口风
ئېنىگماتىت	三斜闪石
ئېنگىدرىت	包水岩矿
ئېنېدىئول	烯二醇
ئېنېرگىزم	奋力主义
ئېنېرگىيىچىلىك	唯能论
ئېيبوئېيىلىكلەر	埃维厄人
ئېيبوئېيە	埃维亚
ئېيتروفىك	番樱桃酚
ئېيتروفىكاتسىيە	富养化
ئېيخروئىت	翠砷铜矿
ئېيخروماتىن	常染色质
ئېيدىدىمىت	双晶石
ئېيدىمونىيە	理性生活
ئېيفېل	埃菲尔
ئېيقئۈزۈمى	乌饭树
ئېيكولىت	负异性石
ئېپاپوفىز	上骨凸
ئېپاۋلېمېنت	埃泼勒茫
ئېپوكسىد	环氧化物
ئېپوكسىلىشىش	环氧化
ئېپىئانتىنىت	羟铀矿
ئېپىبازىدىيە	上担子
ئېپىبلاست	外胚叶
ئېپىدوت	绿帘石
ئېپىدوتلىشىش	绿帘石化
ئېپىدوتىت	绿帘岩
ئېپىدېرموفىتىن	表皮癣菌
ئېپىدېرمىلىشىش	表皮化
ئېپىدېمىئولوگىيە	流行病学
ئېپىزونا	浅成带
ئېپىستىلبىت	柱沸石
ئېپىسكوپ	修会教士
ئېپىسىكلوئىد	外摆线
ئېپىلوگ	收场白
ئېپىماگما	外岩浆
ئېپىمورفوزىيە	再生形态
ئېپىمېرازا	表异构酶
ئېپىمېرون	后侧片
ئېپىنىن	麻黄宁
ئېپىپلازما	造孢余质
ئېپىگرافىست	碑铭学家
ئېپىگرافىيە	碑铭学
ئېپىگرامماتىست	警句作者
ئېپېئىرا	周转圆
ئېچىتقۇچى	发酵人员
ئېچىرقاش	饥饿感
ئېڭىش	下坡路
ئېگالىتارىئانىزم	平等主义
ئېگلېستونىت	褐氯汞矿
ئېگىنېتلار	埃吉纳人
ئېگەرچى	马具师
ئېگەرچىلىك	鞍工术
ئېۋانسىت	核磷铝石
ئېۋاپورىت	蒸发岩
ئېۋتېنىست	优境学家
ئېۋتېنىكا	优境学
ئېۋدىئالىت	异性石
ئېۋرنادسكىت	水铜矾
ئېۋروبىن	优洛宾
ئېۋرودول	优玫红醇
ئېۋرودىن	优玫红
ئېۋفوربىيە	猩猩木
ئېۋفېنىكا	优型学
ئېۋكائىرىت	硒铜银矿
ئېۋكائىن	优加因
ئېۋكاتروپىن	优加托品
ئېۋكاريوتا	真核生物
ئېۋكرازىت	钍铈矿
ئېۋكلىد	欧几里德
ئېۋلىتتورال	真沿岸带
ئېۋمىتسېتلار	真菌类
ئېۋمىدرىن	优米德林
ئېۋمېلانىن	真黑素
ئېۋنوتوزاۋۇر	正南龟
ئېۋوليۇتا	渐屈线
ئېۋونىمىن	卫矛素
ئېۋپاۋارىن	优帕佛林
ئېۋپاۋېرىن	锂霞石
ئېۋگېنىتسىست	优生学家
ئېۋگېنىكا	优生学
ئېۋېنكلار	埃文克人
ئېۋېنلار	埃文人
ئەبجەش	阿不交西
ئەبرام	王指柑
ئەجەللىك	卡脖子
ئەخلاقسىزلىق	不道德
ئەدەبىياتشۇناس	文艺学家
ئەدەبىياتشۇناسلىق	文艺学
ئەرجەنزە	混血儿
ئەرزىمەيدىغان	鸡毛蒜皮
ئەرزىمەيدۇ	不敢当
ئەرزىيەتچى	信访人
ئەركىتاي	天之骄子
ئەركەكزەدەك	男性意象
ئەرمۇدۇن	白蜡树
ئەرەبىستان	阿拉伯
ئەرەمەيلەر	阿拉米人
ئەزمە	婆婆妈妈
ئەزگۈلۈك	天高地厚
ئەزگۈچى	压迫者
ئەزەلىيچىلەر	先验论者
ئەستەر،ئەستەرلىك	配衬料
ئەسقاتمايدىغان	不中用
ئەسكەرتكۈچى	提示人
ئەسكەرى	阿斯卡理
ئەسلىتىشچانلىق	可联想性
ئەسلىيەلمەسلىك	倒摄遗忘
ئەشئەرى	阿什艾利
ئەشرەف	阿斯拉
ئەقىلىچلىك	唯理论
ئەكسىيەتچىلەر	反动派
ئەلاچلىق	至上论
ئەلاگۈل	马兜铃
ئەلكېزەر	神洲行
ئەلھۆكمىلىللا	生死有命
ئەملىگۈچى	接种员
ئەمچەكسىز	无乳房
ئەمگۈچى	吮吸者
ئەمەلىيلىك	实用性
ئەمەلىيەتچى	实践者
ئەنجىۋىن	早生白
ئەندىزچىلىك	模式论
ئەنسارلار	安萨尔
ئەنكاپلىغۇچ	深槽镘刀
ئەيخۇتۇەن	挨户团
ئەيمەنمەي	横行无忌
ئەينەكلىشىش	玻璃样变
ئەينەكچى	玻璃工
ئەيىبلىگۈچى	公诉人
ئەپسانىشۇناسلىق	神话学
ئەپسانىلەشمەسلىك	非神话化
ئەپلاتون	柏拉图
ئەپلاتونچىلار	学院派
ئەپيۇنخانا	吸毒店铺
ئەگكۈچ	弯曲器
ئەۋرىشىملەشتۈرۈش	韧化处理
ئەۋزەللەشتۈرۈش	最优化
ئەۋەتكۈچى	寄件人
بائۇكسىت	铝土矿
بابلىق	适宜性
بابوۋچىلار	巴贝夫派
بابىلار	巴布教派
بابىلون	巴比伦
بابىلونلۇقلار	巴比伦人
بابىنگتونىت	硅铁灰石
بابىنېت	巴俾涅
باتارېيىچى	铸电版工
باتاكلار	巴塔克人
باتاۋىلار	巴塔维人
باتراخوتوكسىن	蛙毒素
باتسىتراتسىن	杆菌肽
باتسىللوز	杆菌病
باتسىللىت	杆雏晶束
باتناشماق	闹别扭
باتۋالار	巴特瓦人
باتۋىللىت	黄褐块炭
باجاۋلار	伯乔族
باجخانا	税务所
باجۇرىلار	巴朱里人
بادارىلار	巴达里人
باداگالار	巴达加人
باددېلېيىت	斜锆石
بارات	巴拉特节
باراتالار	巴拉塔人
بارارىت	氟硅铵石
باراسانا	巴拉萨那
بارالار	伊巴拉人
باربالوئىن	坝巴苷
باربان	燕麦灵
باربىتال	巴比妥
باربىزون	巴比松
باربېرتونىت	水镁铬石
بارخات	黄菠萝
باركليىت	红刚玉
باركېۋىكىت	棕闪石
بارلار	巴尔人
بارماكو	巴马科
بارمۇت	巴茅斯
باروتروپىيە	正压性
باروكلىنىكلىق	斜压性
بارومىل	气压毫巴
باروۋىكليۇچاتېل	气压开关
بارىت	重晶石
بارىترون	重电子
بارىتوكالتسىت	斜钡钙石
بارىتون	巴里通琴
بارىزىلىت	硅铅矿
بارىلىت	硅钡铍石
بارېلار	巴雷人
بارېگې	巴雷热纱
بازارشۇناسلىق	市场学
بازارلاشتۇرۇش	城镇化
بازالتېس	黑色炻器
بازالىت	玄武岩
بازالىتسىمان	玄武岩状
بازاليۇمىنىت	羟矾石
بازانىت	碧玄岩
باززىت	硅钪矿
بازىدىئوفورا	担子体
بازىدىئوكارپ	担子果
بازىمېسوستاسىس	粗玄基质
بازۇكىچى	火箭筒手
باستنېزىت	氟碳铈矿
باستىيە	巴斯蒂亚
باستېرلار	巴斯特人
باسسالار	巴塞人
باسسورىن	黄蓍胶糖
باسسېتىت	铁铀云母
باسكلار	巴斯克人
باسكولوگىيە	巴斯克学
باسمىخانا	印刷所
باسمىچىلىق	印刷业
باسىلىكا	巴西利卡
باسۇتولار	巴苏陀人
باشاقلىقلار	禾本科
باشسىزلار	无头类
باشقۇرۇغۇچى	管理者
باغداد	巴格达
باغلىغۇچ	耦合器
باغلىغۇچى	关联词
باغۋەنچىلىكشۇناس	园艺学家
باقتۇرۇلغۇچ	被送养人
باقمىچلىق	养殖业
باقىمەندىلىك	终身制
باكترىتىكون	杆菊石壳
باكتۇن	白克顿
باكتېروئىد	类菌体
باكتېرىئوتسىن	细菌素
باكتېرىئوتوكسىن	细菌毒素
باكتېرىئوز	细菌病害
باكتېرىئوستات	制菌剂
باكتېرىئولىز	溶菌作用
باكتېرىئولىزىن	溶菌素
باكتېرىئوپۇرپۇرىن	菌紫素
باكتېرىتسىدىن	杀菌素
باكتېرىكتوما	菌小体
باكتېرېمىيە	菌血症
باكۇل	杆锥菊石
باكېرىت	瓷硼钙石
بالاخىلار	巴拉希人
بالافون	巴拉琴
بالانتېلار	巴兰特人
بالانسلىشىش	相平衡
بالبوئا	巴波亚
بالتلار	波罗的人
بالتىمور	巴尔的摩
بالغۇن	水柏枝
بالقانلىقلار	巴尔干人
باللوننې	巴勒耐舞
باللىستوسپورا	掷孢子
باللىمېنا	巴利米纳
بالمېر	巴耳末
بالنىتسا	摒波病房
بالنېئوتېراپىيە	浴疗学
بالىفولىت	纤钡锂石
بالىياتقۇسىزلار	无胎盘类
بالچېچەك	香蜂花
بالۇگالار	巴吕加人
بامبارالار	班巴拉人
بامبېرگا	班伯加
بامىت	巴米特
بانات	巴娜蒂
بانتۇئىست	班图学家
بانتۇستان	班图斯坦
بانتۇلار	班图人
بانجو	班卓琴
باندائىت	磐梯岩
باندور	班多尔琴
باندىلىت	氯硼铜矿
باندۇرا	班杜拉琴
بانكنوت	银行券
بانكىشۇناسلىق	银行学
بانكېر	金融家
بانىيە	班尼亚
بانىۋالار	伯尼瓦人
بانگاش	班加什族
بانگالور	班加罗尔
بايالار	巴亚人
باياناتنامە	备忘录
بايتسىلار	拜齐人
بايقىماسلىق	冷不防
بايكونۇر	拜科努尔
بايكېرىت	贝地蜡
بايلېيىت	碳镁铀矿
بايمان	碎米荠
باينوئالار	拜诺亚人
بايېرىت	三羟铝石
بايېس	贝叶斯
باپباراۋەر	对对等
باگگارالار	巴加拉人
باھاشۇناسلىق	价格学
باھامالار	巴哈马
باھامالىقلار	巴哈马人
باھامىت	巴哈马岩
باھانامە	鉴定书
باۋارىيە	巴伐利亚
باۋرېلار	鲍里人
باۋشىك	巴吾西克
باۋلېلار	鲍勒人
ببېنزامارون	苯苦杏酮
بدام	普通扁桃
برائۇنىت	褐锰矿
براخىئوپودالار	腕足动物
براخۇيلار	布拉灰人
برادلېيىت	磷钠镁石
برادىسپورا	缓慢孢子
برادىكاردىيە	心搏徐缓
برادىكىنىن	缓激肽
برازىلىئانىت	磷铝钠石
برازىلىن	巴西灵
براسسىكاستېرول	菜籽甾醇
براسسىن	芸苔菁
براكېت	布喇开
براندتىت	砷锰钙石
براگ	布拉格
براۋالار	布拉瓦人
بروئۇنىزم	布朗主义
بروتوكرىستال	融蚀斑晶
بروخانتىت	水胆矾
برودۋېي	百老汇
بروملىت	钡霰石
بروموئاتسېتون	溴丙酮
بروموئالكان	溴代烷
بروموئۇراتسىل	溴尿嘧啶
بروموخلورومېتان	溴氯甲烷
بروموخلوروپرېن	溴氯丙烯
بروموسىكلېن	溴杀烯
بروموفوس	溴硫磷
بروموفېنوكسىن	杀草全
بروموكسىنىل	溴苯腈
برومويودىد	溴碘化物
بروموپىكرىن	溴化苦
برومىد	溴化物
برومىرىت	溴银矿
برونتوتېرلار	雷兽类
برونخىئولا	细支气管
برونخىيە	小支气管
برونزىت	古铜辉石
برونە	屏蔽装甲
بروۋنمىللېرىت	钙铁石
برىتونلار	布立吞人
برىلليانت	金刚石
بريۇستېر	布需斯特
برۇتالىزم	粗犷主义
برۇتسىت	水镁石
برۇتسىن	番木鳖碱
برۇتسېللىن	布氏菌素
برۇشىت	透钙磷石
برۇكىت	板钛矿
برۈنلار	布吕恩人
برېئىتائۇپتىت	红锑镍矿
برېئۇننېرىت	铁菱镁矿
برېۋستېرىت	锶沸石
بلاستوزوئوئىد	芽生体
بلاستوسپورا	芽生孢子
بلاستوفىتىك	变余辉岩
بلاستوپساممىت	变余砂岩
بلاستوپسېفىتلىق	变余砾状
بلاستوگېنېز	种质遗传
بلاستىتسىدىن	灭瘟素
بلاستېنىئوسپورا	双管孢
بلاففېرت	勃拉费特
بلاكېئىت	红铁碲矿
بلايرمورىت	淡方钠岩
بلوئېدىت	白钠镁石
بلېفاروپلاست	生毛体
بلېممىلار	布伦米人
بوئۇرنونىت	车轮矿
بوئېئوتىيە	彼奥提亚
بوبىيېررىت	白磷镁石
بوتاكۆز	勿忘草
بوتاللاكىت	羟氧铜矿
بوتانىكا	植物学
بوتسمان	水水长
بوتى	带帮拖鞋
بوخرالار	博赫拉人
بوخەيلىكلەر	渤海人
بودولار	博多人
بودېنىت	伯顿石
بوراتسىت	方硼石
بورانالار	波拉纳人
بورنىت	斑铜矿
بورنىل	冰片基
بوروئارسېنات	硼砷酸盐
بوروسىلىكات	硼硅酸盐
بورولار	波罗人
بوروگىدرىد	氢硼化物
بورىدلار	硼化物
بورىككىت	磷钙铁矿
بورىن	甲硼烷
بورۇكالار	博鲁卡人
بورېسكوپ	管道镜
بوزتورغاي	凤头百灵
بوساسلار	波萨斯人
بوسنىيە	波斯尼亚
بوشاتقۇچ	释放器
بوغچىلىغۇچ	包装拆器
بوغۇزلىۋالماق	抹脖子
بوغۇملۇقلار	有环节类
بوكسچى	拳击手
بولالىماق	称得起
بولتسمان	波尔茨曼
بولتونىت	波尔顿石
بولدىن	波耳定
بولوئىزم	反战主义
بولونىيىلىكلەر	波伦亚人
بولىدىغان	说得过去
بومازا	棉花绒
بومباردون	邦巴尔东
بومىت	勃姆石
بونتوكلار	蓬托克人
بوندولار	邦多人
بونىلار	波尼人
بونىنىت	玻安岩
بونگولار	邦戈人
بويار	波雅尔
بويتاقلىق	鳏夫身份
بويتاقچىلىق	打光棍儿
بويل	波义耳
بوگات	薄伽特
بوۋېرى	鲍厄里
بوۋېنىت	透蛇纹石
بىئافرانلار	比夫拉人
بىئاكلار	比阿克人
بىئانخىت	锌铁矾
بىئوئاكتىۋلىق	生物活性
بىئوئاكۇستىكا	生物声学
بىئوئېنېرگىيە	生物能
بىئوئېنېرگېتىكا	生物能学
بىئوترانسفورماتسىيە	生物转化
بىئوتىن	生物素
بىئوتىپ	生物型
بىئوخروما	生物色素
بىئوخرونىكا	生物年代
بىئودىن	拜欧代因
بىئورىتىم	生物节律
بىئوزوما	生命小体
بىئوس	生物活素
بىئوسىنتېز	生物合成
بىئوفازا	生物相
بىئوفورا	生原体
بىئوفىلتراتسىيە	生物过滤
بىئوكوللوئىد	生物胶体
بىئولوگ	生物学家
بىئولوگىيىلەشتۈرۈش	生物学化
بىئولىتىت	生物岩类
بىئولىزلاش	生物分解
بىئوليۇمىنېسسېنسىيە	生物发光
بىئوماتېرىياللار	生物材料
بىئوماتېماتىكا	生物数学
بىئوماسسا	生物量
بىئوماگىنىتىزم	生物磁学
بىئومېتر	生物计
بىئومېخانىكا	生物力学
بىئومېرا	生物层段
بىئوناۋىگاتسىيە	生物航行
بىئوگرافېر	传记作者
بىئوگېرمىت	生物岩
بىئوگېن	生命素
بىئۇرېت	缩二脲
بىئېرى	比埃里
بىبلىئوتېراپىيە	阅读疗法
بىبلىئوگىيە	图书学
بىبىلوگىيە	版本学
بىتوۋنىت	倍长石
بىتېرمىترون	双端管
بىخەتەرلىكى	保险系数
بىدئەتچىلەر	异端派
بىدېماترون	毕代玛管
بىردىنبىرچى	唯一者
بىرلىشىشلىك	幺正性
بىرىكتۈرگۈچ	并接者
بىرىكشچانلىقى	粘结性
بىرىكىشچانلىقى	亲和性
بىسايالار	比萨扬人
بىسترومىت	锑镁矿
بىسمارسېن	铋砷剂
بىسمارك	俾斯麦
بىسمۇتات	铋酸盐
بىسمۇتوتانتالىت	钽铋矿
بىسمۇتىت	泡铋矿
بىسمۇتىد	铋化物
بىسمۇتىل	氧铋基
بىسمۇتىنىت	辉铋矿
بىسۇلفات	硫酸氢盐
بىسۇلفىت	亚硫酸盐
بىسېكترىسا	等分角线
بىسەرەمجان	乱七八糟
بىشارىنلار	比沙林人
بىشوفىت	水氯镁石
بىشۇ	衬里革
بىكاربونات	碳酸氢盐
بىكارغا	掰白白
بىكخاكونىتىن	白乌头碱
بىكسبيىت	方铁锰矿
بىكسىن	胭脂树素
بىكوللار	比科尔人
بىكىت	玉髓假晶
بىكىنى	比基尼
بىكىنىلار	比基尼人
بىلدۈرمەستىن	暗地里
بىللار	比尔人
بىللىئېتىت	黄钡铀矿
بىلىرۇبىن	胆红素
بىلىرۇبىنۇرىيە	胆红素尿
بىلىرۇبىنېمىيە	胆红素血
بىلىسىئانىن	胆蓝素
بىلىفۇسسىن	胆褐素
بىلىپروتېئىن	胆蛋白质
بىلىۋېردىن	胆汁绿
بىماترون	毕玛管
بىمەنىچىلەر	荒诞派
بىناكارلىق	建筑业
بىناپاكرىل	乐杀螨
بىندخېيمىت	水锑铅矿
بىنورمال	次法线
بىنوكسالات	草酸氢盐
بىيېكسىيە	双向单射
بىپالىئۇم	笄蛭涡属
بىگېرىت	辉铋铅矿
بيۇروكراتىيە	官僚体系
بۆرىقۇيرۇق	狼尾草
بۆرەكسىمان	肾脏形
بۆلگۈنچىلىك	分裂主义
بۆلگۈچ	除法器
بۆلۈشۈۋالغۇچىلار	分割派
بۆلۈنمەسلىك	不可分性
بۆلۈنگۈچى	被除数
بۇئىيالار	布依雅人
بۇتادىئېن	丁二烯
بۇتاكائىن	丁基卡因
بۇتاندىئول	丁二醇
بۇترىللىد	菊海鞘
بۇتريوگېن	赤铁矾
بۇتوكسىد	丁氧金属
بۇتوكسىل	丁氧基
بۇتوپىرونوكسىل	避蚊酮
بۇتىت	铜水绿矾
بۇتىرال	缩丁醛
بۇتىرولاكتون	丁内酯
بۇتىرىنازا	酷脂酶
بۇتىلاتلىشىش	丁基化
بۇتىندىئول	丁炔二醇
بۇتگېنباخىت	毛青铜矿
بۇتېئىن	紫铆因
بۇتېنىل	丁烯基
بۇخارالىقلار	布哈拉人
بۇخىدلار	布希德人
بۇدۇكالار	布杜卡人
بۇدۇمالار	布杜马人
بۇرغىلىنىشچانلىق	可钻性
بۇركېئىت	碳酸钠矾
بۇرنېت	棕黑粗呢
بۇروۋاي	油井架
بۇساق	车叶草
بۇسۇلفان	白消安
بۇغۇن	墙壁胡蜂
بۇفاگىن	蟾蜍精
بۇففېرلىنىش	缓冲作用
بۇفوتالىن	蟾蜍他灵
بۇفېت	小吃部
بۇفېر	缓冲器
بۇكائۇۋالار	布考阿人
بۇككىنخام	白金汉
بۇل	旋翼叶毂
بۇلتفونتېئىنىت	氟硅钙石
بۇلغارلار	保加尔人
بۇلغارىيە	保加利亚
بۇلغانما	被污染物
بۇلغىما	污染物
بۇلۇلار	布鲁人
بۇمپومېتر	不平仪
بۇمپېر	注销器
بۇنزېنىت	绿镍矿
بۇنودونتالار	丘齿类
بۇنچىۋالا	这么些
بۇيا	苦豆子
بۇيرۇتقۇچى	定作人
بۇيرۇقۋازلىق	命令主义
بۇچىت	玻化岩
بۇژۇلدىماق	嘶嘶嘶响
بۇگىنېسلار	布吉斯人
بۈرەندە	鞋底切刀
بېئاۋېرىت	铜铅铁矾
بېئۇدانتىت	砷菱铅矾
بېبوپ	比博普
بېبېئېرىن	贝比碱
بېتائىن	甜菜碱
بېتافىت	贝塔石
بېتاكسانتىن	甜菜黄素
بېتانىن	甜菜苷
بېتخوۋىنچە	贝多芬
بېتسىلېئولار	贝齐寮人
بېتلېخېم	伯利恒
بېتلېخېملار	伯利恒人
بېتچېلور	布切勒
بېتۇلىنول	桦木醇
بېتېلگېيز	参缩四
بېجالار	贝贾人
بېجىرگۈچى	经手人
بېد	贝艾德
بېرائۇنىت	簇磷铁矿
بېربامىن	小檗胺
بېربېرلار	柏柏尔人
بېربېرى	豪猪刺
بېربېرىلار	伯贝利人
بېربېرىن	小檗碱
بېرتراندىت	羟硅铍石
بېرتىئېرىت	辉锑铁矿
بېرزېلىئىت	黄砷榴石
بېرلىنىت	块磷铝矿
بېرنۇللى	伯努利
بېرىل	绿柱石
بېرىللونىت	磷钠铍石
بېرىنگىت	白令岩
بېزىگۈچى	装饰者
بېسانسون	贝桑松
بېككۋېرېلىت	深黄铀矿
بېككېئول	岗松醇
بېككېلىت	铈磷灰石
بېللىنگېرىت	水碘铜矿
بېلورۇسىيە	白俄罗斯
بېلىقئوتى	金鱼藻
بېلىقسىمانلار	鱼形类
بېلگا	比尔加
بېمبالار	本巴人
بېمېنتىت	蜡硅锰矿
بېمېگرىد	贝美格
بېنت	护创膏布
بېنتامىزم	边沁主义
بېنتىئوكارب	杀草丹
بېنجامىنىت	银铅铋矿
بېنزائۇرىن	苯并金精
بېنزادوكس	胺酸杀
بېنزال	苯甲亚基
بېنزالازىن	苄连氮
بېنزالدوكسىم	苯甲醛肟
بېنزالدېگىد	苯甲醛
بېنزامىدوكسىم	苄胺肟
بېنزامىن	苯扎明
بېنزانتراتسېن	苯并蒽
بېنزانترون	苯并蒽酮
بېنزتىئازۇرون	噻草隆
بېنزوئاتسېئانترىلېن	苯并醋蒽
بېنزوئاكرىدىن	苯并吖啶
بېنزوتروپىن	苯托品
بېنزوترىخلورىد	三氯甲苯
بېنزوتىئازول	苯并噻唑
بېنزوتېترازىن	苯并四嗪
بېنزوخرومون	苯并色酮
بېنزوخىنولىن	苯并喹啉
بېنزوسىكلوئوكتېن	苯并辛因
بېنزوسىننولىن	苯并噌啉
بېنزوفلاۋون	苯并黄酮
بېنزوفلۇئورېن	苯并芴
بېنزوفېنىد	苯甲酸酯
بېنزومات	苯螨特
بېنزونىترىفتورىد	苄川三氟
بېنزوپىناكولون	苯频哪酮
بېنزوپۇرپۇرىن	苯并红紫
بېنزوگلۇكوللار	苯乙二醇
بېنزىلاتلىشىش	苯甲基化
بېنزىمىدازول	苯并咪唑
بېنزىندېن	苯并茚
بېنزىنومېتىر	汽油表
بېنېخىنوكس	敌菌踪
بېيدېللىت	贝得石
بېيېرىت	碳饿钙石
بېگونخە	秋海棠
بەتتەم	不是味儿
بەتشۇناسلىق	版面学
بەتلىمەك	压子弹
بەدىئىيلىك	艺术性
بەدەۋىلەر	贝都因人
بەردەنكە	单响枪
بەرقۇت	天鹅绒
بەزگەكشۇناس	疟疾学家
بەشاتار	连发枪
بەلىزار	金鱼草
بەلگىشۇناسلىق	符号学
بەلگىلەشتۈرۈش	符号化
بەلگىلەنمىگەن	规定以外
بەلۇجىستان	俾路支
بەلۇجىلار	俾路支人
بەنگۇڭتىڭ	办公厅
بەيخېچې	白河车
بەيدىيىلەر	拜迪亚人
بەيياۋزى	白药子
بەگتونى	伯克脱尼
تائاففېئىت	铍镁晶石
تائۇرىن	牛磺酸
تائۇمازىت	硅灰石膏
تائېنىت	镍纹石
تااپشۇرۇۋالالماسلىق	收不到
تابېرنانتىن	马茶碱
تاتارلار	鞑靼人
تاتارلاشماق	鞑靼化
تاختايچى	板条工
تاختىمۈشۈك	捕鼠器
تاخومېتر	转速计
تاخومېتىر	转速表
تاخىستېرول	速甾醇
تاخىكاردىيە	心搏过速
تاخىمېتر	视距仪
تاخىگرافومېترىيە	图示速测
تاراتىزاق	芝麻菜
تاراناكىت	磷钾铝石
تارانچى	塔兰其
تاراپاكائىت	黄铬钾石
تاربۇش	塔布式帽
تارترازىن	酒石黄
تارترامىد	酒石酰胺
تارغاقچى	制梳者
تارقاتقۇچ	发射机
تارقاقچىلىق	分散主义
تارىخشۇناس	史学家
تارىخۋازلىق	历史主义
تارپان	泰班野马
تارگېلىيە	敬神节
تارۇ	花叶竽
تازېتتىىن	水仙花碱
تاسادىپىيچىلىق	偶然论
تاسمانىت	含硫树脂
تاسمىگۈل	令箭荷花
تاسوسلار	萨索斯人
تاشبېلىق	杜父鱼
تاشلىغۇچى	抛掷者
تاشلىۋېتىلمەك	被遗弃
تاشيارغان	虎耳草
تاكادىئاستازا	高淀粉酶
تاكامۇل	集大成
تاكتوزول	融溶胶
تاكتىت	接触岩
تاكتىكىچى	策略者
تاكسودونتلار	列齿类
تاكسونومىيە	分类学
تاكسىت	斑杂岩
تاكسىن	紫杉碱
تاكسېما	语法元素
تاككېراي	萨克雷
تاكونىت	铁燧岩
تالاسسىنىد	海蛄虾
تالاسىمان	纤维状
تالاشقۇچى	竞买人
تالالىشىش	纤维化
تالبۇتال	塔布酮
تالزارلىق	柳条地
تالكوزىيە	滑石肺
تاللاشچانلىق	选择性
تاللوس	原植体
تالوزا	塔罗糖
تالىتول	塔罗糖醇
تالېنىت	红钇石
تامارۇگىت	斜钠明矾
تامامنانە	终结书
تامبۇر	弹布尔
تامغىشۇناسلىق	印章学
تامپېلەك	常春藤
تامچىسىمان	滴落状
تاناتسېلىن	菊蒿素
تاناتولوگىيە	死亡学
تانتالىت	钽铁矿
تانزانىت	坦桑宝石
تاننات	单宁酸盐
تاننازا	单宁酸酶
تاننوئىد	类鞣质
تاننىد	鞣酸酐
تانگيېرلىقلار	丹吉尔人
تانگېرېتىن	橘皮晶
تايانچلار	骨干分子
تايتاڭلىماق	磕磕撞撞
تايلورىت	铵钾矾
تاپتازا	干干净净
تاپشۇرۇلغۇچ	被交付人
تاپشۇرۇۋېلىش	验收试验
تاپىئولىت	重钽铁矿
تاگاتوزا	塔格糖
تاگمېمىكا	法位学
تاگىلىت	纤磷铜矿
تاگېتون	万寿菊酮
تاۋتومېر	互变异构
ترابىيە	特拉比袍
تراتسىلىقلار	色雷斯人
تراخودون	粗齿龙属
تراخىت	粗面岩
تراخىياندېزىت	粗面安岩
ترادىتسىئونالىزم	因袭墨守
تراكترىسسا	曳物线
تراكتورلاشتۇرۇش	拖拉机化
ترامبليور	分电器
ترامبوۋكا	捣实机
ترانزىترون	负跨导管
ترانزىستورلاشتۇرۇش	晶体管化
ترانسئامىنازا	转氨酶
ترانسدۇكتانت	转导体
ترانسرادار	交换雷达
ترانسرېكتىفىكاتسىيە	板极检波
ترانسفورمانت	转化株
ترانسفورمېر	变质人
ترانسفېرازا	转移酶
ترانسكرىپت	正文本
ترانسمىزومېتر	混浊度仪
ترانسمۇتاتسىئونىست	蜕变论者
ترانسمېتىلازا	转甲基酶
ترانسىلليۇمىناتور	透照器
ترانكۋىللىتيىت	宁静石
تراگاكانتىن	黄蓍胶精
تراۋماتوناستىيە	感伤性
تروئىلىت	陨硫铁
تروئېگېرىت	砷铀矿
تروتىل	梯恩梯
تروخوئىد	次摆线
تروخوترون	摆线管
تروخوفورا	担轮幼虫
تروخېئامېتر	轮转计
تروخېلمىنتلار	担轮动物
تروفوبىئوزىيە	取食共生
تروفوتروپىزم	向营养性
تروفوزوئوئىد	营养孢子
تروفوزوئىت	营养子
تروفوزوما	营养体
تروفوسفېرا	营养圈
تروفولوگىيە	营养学
تروفون	滋养螺
تروفونېما	滋养毛
تروپتومېتر	扭角仪
تروپوكوللاگېن	原胶原
تروپولون	草酚酮
تروپولوگىيە	比喻法
تروپويل	托品酰
تروپىدىن	托品定
تروپىل	托品基
تروپېئىن	托品因
ترىئاتسېتات	三醋酸酯
ترىئاتسېتونامىن	三丙酮胺
ترىئاد	三价基
ترىئازولىل	三唑基
ترىئازىنىل	三嗪基
ترىئاكونتان	三十烷
ترىئاللات	野麦威
ترىئامسىنولون	去炎松
ترىئامىلامىن	三戊胺
ترىئوكسىد	三氧化物
ترىئۇمفالىزم	凯旋论
ترىئېتانولامىن	三乙醇胺
ترىئېتىلامىن	三乙基胺
ترىبالىزم	集团主义
ترىبروموئېتانول	三溴乙醇
ترىبۇتىرىن	三丁精
ترىتومىت	硼硅铈矿
ترىتىد	氚化物
ترىتىلودونت	三列齿兽
ترىخروئىزم	三向色性
ترىخلوروئېتان	三氯乙烷
ترىخلوروئېتىلېن	三氯乙烯
ترىخلوروبېنزېن	三氯苯
ترىخلوروسىلان	三氯硅烷
ترىخلوروفېنول	三氯苯酚
ترىخلورىد	三氯化物
ترىخوتسىست	刺丝胞
ترىخودېرما	木霉属
ترىخولوگىست	毛发学家
ترىخولوگىيە	毛发学
ترىخىنوزىيە	毛线虫病
ترىخىنوسكوپ	毛线虫镜
ترىخىنېللالار	旋毛类
ترىدمورف	克啉菌
ترىدىمىت	鳞石英
ترىدېتسىل	十三烷基
ترىدېتسېن	十三烯
ترىدېكان	十三烷
ترىستېئارىن	三硬脂精
ترىسىلىكات	三硅酸盐
ترىسېكسىيە	三等分
ترىفتورىد	三氟化物
ترىفلۇرالىن	氟乐灵
ترىفورىن	嗪氨灵
ترىفىلىت	磷铁锂矿
ترىفېنىلامىن	三苯胺
ترىكوسان	二十三烷
ترىكولون	三韵乐段
ترىلائۇرىن	三月桂精
ترىلوگىيە	三部曲
ترىلېمما	三难推理
ترىممېر	整煤机
ترىمېتادىئون	三甲双酮
ترىمېتوكسى	三甲氧基
ترىمېتىل	三甲基
ترىمېتىلامىن	三甲胺
ترىمېتىلېن	三甲撑
ترىمېر	三聚物
ترىمېرلىشىش	三聚作用
ترىمېرىت	三斜石
ترىنىترامىن	三硝胺
ترىنىتروبېنزېن	三硝基苯
ترىنىترىد	叠氮化物
ترىنۇكلېئوتىد	三核苷酸
ترىيودىد	三碘化物
ترىپارسامىد	锥虫胂胺
ترىپافلاۋىن	锥黄素
ترىپالمىتىن	三棕榈精
ترىپتوفانازا	色氨酸酶
ترىپتون	胰蛋白胨
ترىپرېن	蒙六一九
ترىپسىن	胰蛋白酶
ترىپكېئىت	软砷铜矿
ترىپلان	三翼机
ترىپلوئىد	三倍体
ترىپلوئىدلىق	三倍性
ترىپلېر	三倍频器
ترىپۇگىئىت	锑铁矿
ترىپېلىننامىن	去敏灵
ترىگالىد	三卤化物
ترىگرامما	三字母组
ترىگونومېترىيە	三角学
ترىگونېللىن	胡芦巴碱
ترىگگېر	触发器
ترۇدېللىت	易潮石
ترۇكسىلىن	吐昔灵
ترېئونىن	苏氨酸
ترېئىتول	苏糖醇
ترېخالازا	海藻糖酶
ترېست	托拉斯
ترېماتوزاۋر	窗鲵类
ترېمولىت	透闪石
ترېمېتول	佩兰毒素
ترېۋورىت	镍磁铁矿
تنتومېتىر	色辉计
توباگولۇقلار	多巴哥人
توختامسىز	见异思迁
توختامنامە	合同书
توختىيالماسلىق	停不住
توختىۋالماق	停顿下来
توخلا	二齿羊
توخەت	鸡皮疙瘩
توراكوسكوپ	胸腔镜
توربانىت	藻烛煤
توربېرنىت	铜铀云母
تورتۋېتىت	钪钇石
توررىچېللى	托里折利
تورسىئومېتر	扭矩计
تورسىگرامما	扭转图
تورغايسىمانلار	莺科鸟
تورلىغۇچى	锁边工
تورمۇزلىغۇچ	制动剂
تورنادوترون	旋风管
توروتراست	钍造影剂
توروزاۋر	肿角龙属
تورىئانىت	方钍石
تورېئائۇلىت	钽锡矿
تورېئادور	斗牛士
توسۇلمىغان	非阻塞
توشقانقۇيرۇق	看麦娘
توشقانكالپۇك	兔唇花
توشۇتقۇچى	托运人
توشۇلما	托运物品
توقا	皮带扣环
توقسانىنچى	第九十
توقلا	一岁羊
توقلىنىش	充实度
توقۇمىچى	纺织工
توكاماك	托克马克
توكسافېن	毒杀芬
توكسالبۇمىن	毒蛋白
توكسوئىد	类毒素
توكسودونت	弓齿兽
توكسوپلازما	毒浆虫
توكسوپلازمىن	毒浆虫素
توكسىگېنلىقلىق	产毒素性
توكوفېرول	生育酚
تولان	二苯乙炔
تولبۇتامىد	甲磺丁脲
تولدۇرغۇچ	增充剂
تولغاقئوت	痢疾草
تولغانغۇچى	扭动者
تولىدىن	联甲胺
تولىلېن	甲代亚基
تولۇقسىز	挂一漏万
تولۇقلانماق	羞修补
تولېدان	托莱多人
تولېراگېن	耐受原
توماتىدىن	番茄定
توماتىن	番茄素
تومبولو	连岛坝
تومسونىت	杆沸石
تومسېنولىت	方霜晶石
تونزىلامىن	桑西胺
تونوسكوپ	音调镜
تونومېتىر	音调计
تونوگرامما	压力图
تونۇشماسلىق	不识相
تونۇشچانلىق	能识性
تونۇلماق	露头角
تونۇلمىغان	默默无闻
تونۇيالماسلىق	认不出来
تونېتىكا	声调学
تويۇندۇرغۇچ	饱和器
توپازولىت	黄榴石
توپلاشتۇرغۇچ	群集器
توپلاشتۇرۇش	集成化
توپلىششىچانلىق	群集性
توپلىغۇچ	集合器
توپلىغۇچى	搜集人
توپوخىمىيە	局部化学
توپولوگىست	拓扑学家
توپولوگىيە	拓扑学
توپىكال	专题邮票
توڭلاتقۇچ	制冷剂
توڭمېڭخۇي	同盟会
توگولۇقلار	多哥人
توۋارىيە	金线草
توۋىنامە	悔过书
تىئابېندازول	涕必灵
تىئادىئازول	噻重氮
تىئازولسۇلفون	噻唑砜
تىئازولىن	噻唑啉
تىئازىد	噻嗪类
تىئامىدلار	硫羰胺
تىئامىن	硫胺素
تىئامىنازا	硫胺素酶
تىئوئامىد	硫代酰胺
تىئوئۇراتسىل	硫尿嘧啶
تىئوباتسىللا	硫杆菌
تىئوباربىتۇرات	硫喷妥
تىئوبېنزالدېگىد	苯甲硫醛
تىئوخروم	硫色素
تىئودىگلىكول	硫二甘醇
تىئورىدازىن	甲硫哒嗪
تىئوسپىنېل	硫尖晶石
تىئوفلاۋىن	硫黄素
تىئوفورمالدېگىد	硫代甲醛
تىئوفوسفورىل	硫代磷酰
تىئوفوسگېن	硫光气
تىئوفېنىن	噻吩胺
تىئوكاربارسون	硫卡巴胂
تىئوكاربامازىن	硫卡巴嗪
تىئوكاربانىلىد	均二硫脲
تىئوكرېزول	硫甲酚
تىئوكسانتون	噻吨酮
تىئومېروسال	硫柳汞
تىئونازىن	硫磷嗪
تىئونىل	亚硫酰
تىئوگۇئانوزىن	硫鸟苷
تىئېماننىت	灰硒汞矿
تىئېنىل	噻嗯基
تىبلىس	南京布
تىبەتشۇناسلىق	西藏学
تىتاناۋگىت	钛辉石
تىتانكاربىد	碳化钛
تىتانوماگنېتىت	钛磁铁矿
تىتانىزم	泰坦主义
تىترىمېتر	滴定计
تىترىگەكلىك	震颤麻痹
تىتوئىزم	铁托主义
تىخىزم	偶然主义
تىدالىت	潮积岩
تىراننوزاۋر	霸王龙
تىراننۇس	灰王霸
تىرناقچىلىك	丁点儿
تىرودىت	镁锰闪石
تىروزىل	酪酰基
تىروزىنازا	酪氨酸酶
تىروللار	蒂罗尔人
تىرونلۇقلار	蒂龙人
تىرونىن	甲腺氨酸
تىروگېن	甲状腺原
تىرىت	砂砾特
تىرىتون	海卫一
تىزلانغۇچى	下跪者
تىزمىگۈل	马鞭草
تىزىملانماسلىق	未登记
تىزگىنلىگۈچى	抑制器
تىزگىنەك	遥控器
تىففانى	蒂法尼
تىقىلىش	阻塞作用
تىكسوتروپ	触变胶
تىكولوش	提科洛斯
تىلاستېر	结星针
تىلاكوئىد	类囊体
تىلاۋەت	祈祷仪式
تىلتمېتر	倾斜计
تىلسىزلار	无舌类
تىلشۇناس	语言学家
تىللامۇك	蒂拉穆克
تىللودونتلار	裂齿兽类
تىللىت	冰碛岩
تىللېيىت	粒硅钙石
تىلوزىن	泰乐菌素
تىمار	提马尔
تىمورلۇقلار	帝汶人
تىموزىن	胸腺素
تىمول	百里酚
تىمىدىن	胸腺定
تىمىل	百里基
تىمىن	胸腺碱
تىنتومېتىر	色调计
تىنتىتسىت	白磷铁矿
تىندال	廷德尔
تىندۇرغۇچ	沉淀器
تىنزېنىت	锰斧石
تىنكالونىت	八面硼砂
تىنما	淤积物
تىنچلىقپەرۋەرلىك	和平主义
تىنگىزم	实物主义
تىىنچلانماق	平稳下来
تىپشۇناسلىق	类型学
تىپوتېلېگراف	打印电报
تىپوگراف	铸排机
تىچلىقپەرۋەرلىك	和主义
تىگرولىز	虎斑溶解
تىگرېلار	提格雷人
تىگلالدېگىد	惕各醛
تىگموسىت	趋触细胞
تىگوگېنىن	剑麻皂素
تىۋېلوزا	泰威糖
تىېوسېمىكاربازىد	氨基硫脲
تيۇبۇلىن	微管蛋白
تيۇيامۇنىت	钙钒铀矿
تيەنئەنمېن	天安门
تۆتۆتلىمەك	期期艾艾
تۆرەلمىپەنشۇناسلىق	潜科学学
تۆشۈكلۈك	纹孔式
تۆشۈكلۈكلەر	有孔类
تۆمۈرتۇمشۇق	啄木鸟
تۆمۈنە	制帆用针
تۇبوكۇرارىن	筒箭毒碱
تۇبېركۇليۇز	结核病
تۇبېرىن	薯球蛋白
تۇتامسىز	莫须有
تۇتقۇچىلار	捕涝者
تۇتمىچىلىق	捕涝业
تۇجان	崖柏烷
تۇجاپلىتسىن	崖柏侧素
تۇجون	崖柏酮
تۇجېن	崖柏烯
تۇخولىت	碳铀钍矿
تۇخۇملىغۇچ	产卵器
تۇدارى	独行菜
تۇراقلىشىش	固定作用
تۇراقلىقلىق	稳定度
تۇراقلىقلىقى	稳定性
تۇرانىت	羟钒铜矿
تۇربان	头巾帽
تۇربوپومپا	涡轮泵
تۇربىدوستات	恒浊器
تۇربىدىمېتر	浊度计
تۇربۇلاتور	湍流器
تۇركۋويس	绿松石
تۇرپېت	盒果藤
تۇرپېنتىن	松脂精
تۇرۇبىلاشتۇرۇش	管道系列
تۇرۇزول	染匠油桐
تۇغۇشچانلىق	生育力
تۇلسالىقلار	塔尔萨人
تۇلىت	锰黝帘石
تۇمانسىزلاشتۇرغۇچ	去雾器
تۇمۇچۇق	旋木雀
تۇنىتسىن	外皮素
تۇنىكالار	突尼卡人
تۇنگا	穿皮潜蚤
تۇنگستات	钨酸盐
تۇنگستېنىت	辉钨矿
تۇنگۇئائىت	丁古岩
تۇياقلىقلار	有蹄类
تۇيدۇرماستىن	轻轻地
تۇيغۇنلۇق	敏悟力
تۇيمايلا	不知不觉
تۈجۈپىلەنگەن	集约化
تۈركمەن	土库曼
تۈزلىگۈچ	整值器
تۈزلۈك	平直性
تۈزۈكرەك	倒不如
تۈزەتكۈچ	校正器
تۈزەتكۈچى	修改者
تۈمەنبېگى	万户候
تۈنجۇقتۇرغۇچ	窒息器
تۈنىكىچى	白铁工
تۈنۈكىچى	箍桶匠
تۈنەك	睡眠集会
تۈپلىگۈچ	装订器
تۈپلەنمە	合订本
تۈگمىلىگۈچى	扣扣者
تۈگمەنچى	磨坊工人
تۈۋرۈكسىمان	长柱形
تۈۋرۈكچە	小木柱
تۋىستور	磁扭线
تېئانتروپىزم	神人结合
تېئوبرومىن	可可碱
تېئودولىت	经纬仪
تېئولوگ	神学家
تېئولوگىيىلەشتۈرمەك	神学化
تېئومانىيە	宗教狂
تېئومورفىزم	神形论
تېئوپانتىزم	神自现论
تېئىزم	有神论
تېئېپلېئىت	氯硼钠石
تېبائىن	蒂巴因
تېبىسلىقلار	底比斯人
تېترابروموئېتان	四溴乙烷
تېترابروموبىسفېنول	四溴双酚
تېترابروموفېنولفتالېئىن	四溴酚酞
تېترابرومىدلار	四溴化物
تېترابوراتلار	四硼酸盐
تېترابېنازىن	四苯喹嗪
تېتراتوئىد	四分面体
تېتراتېرپېن	四萜烯
تېتراخلوروئېتان	四氯乙烷
تېتراخلوروئېتىلېن	四氯乙烯
تېتراخلوروتىئوفېن	四氯噻吩
تېتراخلوروفېنول	四氯酚
تېتراخلورىدلار	四氯化物
تېتراخلورۋىنفوس	杀虫畏
تېترادان	丁卡因
تېترادىك	四阶张量
تېترادىمىت	辉碲铋矿
تېترادېتسىل	十四基
تېترادېكان	十四烷
تېترارخ	四原型
تېترازولىل	四唑基
تېترازوما	四小体
تېترازېن	四氮烯
تېتراسىكلىن	四环素
تېتراسىلىكات	四硅酸盐
تېتراسۇلفىد	四硫化物
تېترافتوروئېتىلېن	四氟乙烯
تېترافتورووگىدرازىن	四氟肼
تېترافتورىدلار	四氟化物
تېترافوسفات	四磷酸盐
تېترافېنىل	四苯基
تېترالون	萘满酮
تېترالوگىيە	四联剧
تېتراممىن	四氨络物
تېترامېترىن	似虫菊
تېترامېتىلېن	四甲撑
تېترامېر	四聚物
تېترانىترات	四硝酸酯
تېترانۇكلېئوتىد	四核苷酸
تېترايودوئېتىلېن	四碘乙烯
تېترايودىدلار	四碘化物
تېتراپىررول	四吡咯
تېتراگىدروفۇران	四氢呋喃
تېتراگىدروكسى	四羟基
تېتراگىدرونافتالېن	四氢化萘
تېتراگىدرىت	黝铜矿
تېتراگىدرىد	四氢化物
تېتراگېكساگېدرون	四六面体
تېترود	四极管
تېترودوتوكسىن	河豚毒素
تېتروكسالات	四草酸盐
تېتروكسىىدلار	四氧化物
تېترونال	四乙眠砜
تېترىل	特屈儿
تېتومېتامورفىزم	异变态
تېخمۇھەررىر	技术编辑
تېخنوسفېرا	技术圈
تېخنولوگ	工艺师
تېخنىكالىزم	技术论
تېخنىكىلىقلىق	技术性
تېخنىكۇم	专科学校
تېخنېترون	场调管
تېرالىت	企猎岩
تېراپسىدلار	兽孔类
تېرباتسىل	特草定
تېربۇترىن	去草净
تېربۇتول	芽根灵
تېرراتسېر	修梯地机
تېررورىزم	恐怖主义
تېررورچى	恐怖分子
تېرلىنگۋائىت	黄氯汞矿
تېرموئېففېكت	热电效应
تېرموئېلېكتر	温差电
تېرموئېلېكترون	热电子
تېرموباكتېرىيە	热细菌
تېرموتارازا	热天平
تېرموخرومىزم	热色现象
تېرموخىمىك	热化学家
تېرموخىمىيە	热化学
تېرمودىنامىكا	热力学
تېرموسېنزور	热感器
تېرموفىزىكا	热物理学
تېرموكارست	热喀斯特
تېرمومېتال	双金属
تېرمومېترىيە	计温术
تېرمومېتىرىيە	测温学
تېرموناستىيە	感热性
تېرموپلازما	热原体属
تېرموپېرىئودىزم	温期现象
تېرمىت	铝热剂
تېرمىناتىۋ	终止格
تېرنوۋسكىت	青钠闪石
تېروپودلار	兽脚类
تېرىخور	皮蠹虫
تېرپادىئېن	萜二稀
تېرپىنولېن	品油烯
تېرپىنېئول	萜品醇
تېرپىنېن	萜品烯
تېرپېنلار	萜烯类
تېرېبرا	攻城机
تېرېبېن	特惹烯
تېرېفتالات	对酞酸盐
تېزلىتىش	加速度
تېستوستېرون	睾丸酮
تېسسالىلىقلار	塞萨利人
تېسسېرا	特塞拉
تېسىل	起绒刺果
تېشىلىشچانلىق	可穿孔性
تېشېماخېرىت	碳铵石
تېشېنىت	沸绿岩
تېفروئىت	锰橄榄石
تېفروزىن	灰叶素
تېكتوخىنون	甲基蒽醌
تېكتورىدىن	鸢尾定
تېكتورىگېنىن	鸢尾配质
تېكتوزوما	构造相层
تېكتوسىلىكات	架硅酸盐
تېكتوفاتسىيە	构造相
تېكتونىت	构造岩
تېكتىتېس	玻陨石
تېكستۇئالىز	诠释学
تېكستۇئالىست	诠释学家
تېكنازېن	四氯硝基
تېلفائىرىيە	蚝坚果
تېللۇرىت	黄碲矿
تېللۇرىد	碲化物
تېلوبلاست	端细胞
تېلوتروف	端营养型
تېلودېندرىئون	终树突
تېلوسىناپسىس	衔接联会
تېلىن	泰伦琴
تېلگارمونىيە	电传琴
تېلۋار	灭草隆
تېلېئوزاۋر	长口鳄
تېلېدىئاگنوز	电测诊断
تېلېدىفون	录放话机
تېلېرادىئو	电视广播
تېلېسېيسمولوگىيە	远测震学
تېلېفونلىشىش	互通电话
تېلېفونىست	话务员
تېلېفونىيە	电话学
تېلېكىنو	电视电影
تېلېمېتىر	遥测计
تېلېمېخانىكا	遥控力学
تېلېپاتىست	传心术士
تېلېپاتىيە	传心术
تېلېگېزىت	传真报纸
تېماتىست	主题作家
تېمنوسېفالىدالار	切头类
تېمىنسىمان	披针形
تېمىنىزم	腾明理论
تېمپورالىزم	暂时主义
تېمپورالىست	暂时论者
تېمپون	时间元
تېمپېراتۇرىسى	辐射温度
تېنتاكۇلوزوئىد	触手个员
تېنتاكۇلىت	竹节石
تېندېر	煤水车
تېندېرومېتر	柔软度计
تېننانتىت	砷黝铜矿
تېنويل	噻吩甲酰
تېنىئودونتالار	纽齿类
تېنىدىئۇم	螺旋丝
تېنىل	噻吩甲基
تېنېبرېسسېنسىيە	磷光熄灭
تېپلوئوم	热欧姆
تېپلوخود	内燃机船
تېپلوۋوز	内燃机车
تېپىلغۇسىز	求之不得
تېڭىرقىغان	直眉瞪眼
تېۋتونىزم	条顿风格
تەتقىقاتخانا	研究院
تەجرىبىخانا	实验室
تەجرىبىسىزلەر	无经验者
تەجرىبىچى	实验者
تەدبىرچى	决策人
تەدرىجىيچىلىك	渐进主义
تەربىيىلەنگۈچى	受教育者
تەرلىك	吸汗垫布
تەرمىشۇناسلىق	文摘学
تەسلىمچىلىك	投降主义
تەسلىمچىلەر	投降派
تەسىرلىنىشچانلىق	易感性
تەسىرلەنگۈچى	易感者
تەسۋىرلىگۈسىز	不可言状
تەسۋىرچىلىك	模写论
تەشۋىقاتچى	宣传员
تەقسىماتچىلىق	分产主义
تەقسىملىنىشچانلىق	可分配性
تەقلىدلىگۈچ	仿真器
تەكرارلىق	多重性
تەكرارلىنىشچانلىق	可重复性
تەكشىلىگۈچى	铲平工
تەلۋىتال	胡枝子
تەمتىرىمەي	好整以暇
تەملەشتۈرگۈچ	增味剂
تەمىنلىگۈچى	供应者
تەمەش	明子木
تەنقىدچى	批评家
تەنقىدچىلىك	批判主义
تەيجىچۈەن	太极拳
تەپتارتماستىن	明目张胆
تەپسىرلەش	一览表
تەپەككۇرشۇناسلىق	思维学
تەڭكەشسىزلىك	不谐和
تەڭپۇڭسىز	不平衡
تەڭپۇڭسىزلىق	不平衡性
تەڭگىتەمرەتكە	牛皮癣
تەڭگىقوتۇر	钱儿癣
تەھدىتلىك	威胁性
تەھرىرشۇناسلىق	编辑学
تەۋرىنىشسىز	无波动
تەۋرەتگۈچ	摆动器
تەۋرەنمە	摇摆地
تەۋرەنگۈچى	摇动者
تەۋسىيەنامە	建议案
جاتاكا	本生故事
جار	震击器
جاراڭڭىدە	砰地一声
جارجات	乔其纱
جاز	爵士舞
جاسەي	包包菜
جاغجاقئوت	兰刺头
جاك	挺针片
جامېسونىت	羽毛矿
جانباز	决斗士
جانلاندۇرغۇچ	复新物
جانلاندۇرۇۋەتمەك	画龙点睛
جانلىقلىق	灵活性
جاپانىمۇ	同甘共苦
جاڭغىرشۇناسلىق	江格尔学
جاھانچىلىق	世界主义
جاۋابسىز	无应答
جاۋابنامە	答辩书
جاۋىسلسداق	话匣子
جاۋېلىن	标枪西貒
جوسېفىنىت	镍铁矿
جونسترۇپىت	氟硅铈矿
جىبى	几毕鸟
جىددىيلەشمەسلىك	别紧张
جىدىيلەشمەك	白热化
جىشيانىت	蓟县矿
جىمجىتلا	一动不动
جىنايەتشۇناسلىق	犯罪学
جىنسسىزلىشىش	无性化
جىنكېۋىزى	补骨脂
جىننېس	吉尼斯
جىنچاتقال	扶芳藤
جىپ	吉普车
جۇدوشۇناس	柔道家
جۇرۇپاتىت	硅钙镁石
جۇزغۇن	沙拐枣
جۇغراپىيىشۇناس	地理学家
جۇلاب	玫瑰露
جۇلالانماق	色彩闪变
جۇلىئانىست	儒略信徒
جۇلىئېنىت	毛青钴矿
جۇنكېرىزم	容克主义
جۇپاتى	巴西酒椰
جۇڭگوشۇناس	中国通
جۇڭگوشۇناسلىق	中国学
جۇڭگوچىلاشتۇرۇش	中国化
جۇگلون	胡桃酮
جۈملىمۇجۈملە	逐字逐句
جۈگەرى	草蜀黍
جېزېكىت	柱晶磷矿
جېففېرسونىت	锰锌辉石
جېففېرىزىت	水蛭石
جېفېرسونچىلار	杰斐逊派
جېكسۇن	杰克逊
جېمىر	异食癖
جەريانسىزلاشتۇرۇش	非过程化
جەزبۇزار	银莲花
جەزچى	黄铜匠
جەسەتخانا	太平间
جەمئىيەتشۇناسلىق	社会学
جەنۇبلۇقلار	南方人
خائۇئېرىت	褐硫锰矿
خائۇسماننىت	黑锰矿
خابازىت	菱沸石
خاتالىقسىز	无差错
خاتىرلىگۈچى	录写器
خاتىرىلىگۈچى	记录员
خاراتسىن	轮藻精
خاراتىنلار	哈拉廷人
خاراكترون	字标管
خاراكتېرلىشىش	性格化
خاراكتېرولوگىيە	性格学
خارستىگىت	铍柱石
خارمىن	哈尔碱
خارىيىلەر	卡利亚人
خارۇسپىكلار	脏卜师
خاستىنگسىت	绿钠闪石
خاكسار	卡克萨尔
خالدېيلار	迦勒底人
خالكوترىخىت	毛赤铜矿
خالكوتسىت	辉铜矿
خالكوستىبىت	硫铜锑矿
خامىت	含米特
خانكسىت	碳酸芒硝
خانكوككىت	铅黝帘石
خانلىق	君主国
خانولار	哈诺人
خانىسلار	哈内斯人
خانپەرەسلەر	保皇派
خانۇنولار	哈努诺人
خاچېتتولىت	铀烧绿石
خاگىئوكراتسىيە	圣徒政治
خاگىئولىت	圣迹石碑
خاگىئوگرافىيە	圣徒传记
خاۋىكول	蒌叶酚
خجېلمىت	钙钽钇矿
خروئىن	海洛因
خروماتوگراف	色谱仪
خروماتوگرافىيە	色谱法
خروماتىتسىزم	半音应用
خروماتىد	染色单体
خروماتىكا	颜色学
خروماتىن	染色质
خروماسكوپ	色质镜
خروماممىن	氨络铬
خروموتروپ	铬变素
خرومودىنامىكا	色动力学
خروموزومولوگىيە	染色体学
خروموفورا	发色团
خروموفىل	叶色素
خرومومىتسىن	色霉素
خرومومېتىر	比色计
خرومونېما	染色线
خروموپروتېئىن	有色蛋白
خروموپلاست	有色体
خروموگراف	比色仪
خرومىتىت	铬铁岩
خرونوترون	计时管
خرونوتروپىزم	变时现象
خرونوسكوپ	计时器
خرونوسكوپىيە	计时镜学
خرونولوگ	年代学家
خرونومېتر	天文钟
خرونومېترىيە	计时学
خرونون	双时间元
خرونىستور	长时计
خرىزوئېرىئول	柯厄醇
خرىزوفىل	金叶素
خرىزوكوللا	硅孔雀石
خرىزولىت	纤蛇纹石
خرىزوپتېرىن	金黄蝶蛉
خرىساروبىن	柯桠素
خرىسوئىدىن	柯衣定
خرۇستاللوئىد	拟晶体
خلامىدىيە	衣原体
خلوئانتىت	复砷镍矿
خلورالازا	氯醛酶
خلورالىد	氯醛交酯
خلورامفېنىكول	氯霉素
خلورامىد	氯酰胺
خلوراپاتىت	氯磷灰石
خلوربرومۇرون	氯溴隆
خلوربېنسىد	氯杀螨
خلورتىئامىد	草克乐
خلوردىمېفورم	杀虫脒
خلورسىكلىزىن	氯环哌嗪
خلورفېنىرامىن	扑尔敏
خلورفېنۋىنفوس	毒虫畏
خلوركوسان	氯化石蜡
خلورمادىنون	氯地孕酮
خلورمانگانوكالىت	钾锰盐
خلوروئاتسېتوفېنون	氯代乙酮
خلوروئاتسېتون	氯丙酮
خلوروئاتسېتونىترىل	氯乙腈
خلوروئازودىن	氯阿唑丁
خلوروئازىد	叠氮化氯
خلوروئاكرولېئىن	氯丙烯醛
خلوروئالكان	氯代烷烃
خلوروئېتىل	氯乙烷
خلوروبرومومېتان	氯溴甲烷
خلوروبرومىد	氯溴化物
خلوروبۇتانول	氯代丁醇
خلوروبېنزالدېگىد	氯甲醛
خلوروتالونىل	百菌清
خلوروتىئونىت	钾氯胆矾
خلورودىن	哥罗丁
خلوروسىلىكان	氯硅烷
خلوروسىنكات	氯锌酸盐
خلوروسپىنېل	绿尖晶石
خلوروفائېئىت	褐绿泥石
خلوروفام	氯笨胺灵
خلوروفان	磷绿萤石
خلوروفورمىل	氯甲酰基
خلوروفىل	叶绿素
خلوروفىللازا	叶绿素酶
خلوروفىللوگېن	叶绿素原
خلوروفىللىت	绿叶石
خلوروفىللىن	叶绿酸
خلوروفىلىت	氯钙石
خلوروفېناك	伐草克
خلوروفېنسۇلفىد	敌螨丹
خلوروفېنپروپمېتىل	燕麦酯
خلوروفېنېتول	杀螨醇
خلوروكرۇئورىن	血绿蛋白
خلوروكرېزول	氯代甲酚
خلوروكسىفىت	绿铜铅矿
خلوروكسىلېنول	氯二甲酚
خلوروكسىن	氯喔星
خلوروماگنېزىت	氯镁石
خلورومېتر	氯量计
خلورومېتىل	氯甲基
خلورومېلانىت	暗绿玉
خلورويودىد	氯碘化物
خلوروپاللادات	氯钯酸盐
خلوروپروپامىد	氯磺丙脲
خلوروپروپان	氯丙烷
خلوروپروپېن	氯丙烯
خلوروپرېن	氯丁二烯
خلوروپلاست	叶绿体
خلوروپىكرىن	氯化苦
خلوروپېنتان	氯戊烷
خلوروگىدروخىنون	氯氢醌
خلوروگىدروكاربون	含氯烃
خلوروگىدرىن	氯乙醇
خلوروگېنىن	绿配质
خلورىت	绿泥石
خلورىتلاشتۇرۇش	亚氯酸化
خلورىتوئىد	硬绿泥石
خلورىدلار	氯化物
خلورىمىد	氯代亚胺
خلورىن	叶绿三酸
خلورىناتور	氯化器
خلورپىد	黄潜蝇
خلورېللا	小球藻
خلورېمىيە	氯血症
خوتتېنتوتلار	霍屯人
خوتۇقتۇ	呼图克图
خوتۇنى	媳妇儿
خودوسكوپ	描述仪
خوراشچانلىق	易损性
خوردىلىقلار	脊索动物
خورسفوردىت	锑铜矿
خورىئوتېت	卵壳器
خوللېرىت	霍勒里斯
خولمكۋىستىت	锂蓝闪石
خولىزم	整体主义
خولىنېستېرازا	胆碱酯酶
خولېستان	胆甾烷
خولېستانول	胆甾烷醇
خولېستېرىل	胆甾醇基
خولېستېرىن	胆固醇
خولېستېن	胆甾烯
خولېگلوبىن	胆绿蛋白
خوندروئىتىن	软骨素
خوندروزامىن	软骨糖胺
خوندروزىن	软骨胶素
خوندرولوگىيە	软骨学
خوندروپروتېئىن	软骨质白
خوندرىئوسفېرا	线粒体球
خوندرىئوما	线粒体系
خوندرېنخىما	软骨实质
خوپپېر	漏斗车
خىئاستولىت	空晶石
خىبىتولار	希比托人
خىتوزامىن	壳糖胺
خىتىن	壳多糖
خىتىنوزا	壳多糖酶
خىتىنوزوئالار	几丁虫类
خىراكس	海拉克斯
خىراللىق	手征性
خىروپودىيە	足医术
خىلدرېنىت	磷铝铁石
خىللاگىت	钼钨铅矿
خىلمۇخىللىق	多样化
خىلوگناتلار	唇颚类
خىموترىپسىن	糜蛋白酶
خىموخىرۇرگىيە	化学外科
خىمىك	化学家
خىنازولىن	喹唑啉
خىنافتول	辛萘酚
خىنالدىن	喹哪啶
خىنالىزارىن	醌茜素
خىنسدالىت	磷铅锶矾
خىنولىل	喹啉基
خىنولىنىل	喹啉酰基
خىنونىمىن	亚胺醌
خىنىتسىن	奎尼辛
خىنىن	金鸡纳霜
خىنگىدرونلار	醌氢醌
خىيالپەرەسلىك	幻想主义
خىيالپەرەسلەر	空想派
خىيالچى	幻想家
خىۋىئاتىت	硫铅铋矿
خيالوفان	钡冰长石
خيولىت	锥冰晶石
خۇادانى	华达呢
خۇاڭخوئىت	黄河矿
خۇتتونچىلار	郝屯学派
خۇتچىنسونىت	红铊铅矿
خۇرۇلدىماق	呜呜声
خۇرېئائۇلىت	红磷锰矿
خۇرەج	新麦草
خۇسۇسىيلاشتۇرۇش	私有化
خۇسۇسىيەتداشلىق	同质性
خۇمارگۈل	醉蝶花
خۇمىرىيە	胡香脂
خۇنسا	二性子
خۇيلامچى	裱糊工
خۇۋېرىزم	胡佛主义
خۇەنشياڭتۇەن	还乡团
خېجازىلىقلار	希贾兹人
خېرالىت	磷钙钍矿
خېرېتىتلار	克勒梯人
خېلات	螯合物
خېلدېنىتلار	霍尔登派
خېلنس	何勒内斯
خېلىدونىن	白屈菜碱
خېمئاۋتوتروپىيە	化能自养
خېموتاكتىك	向化性
خېموسفېرا	光化层
خېموكلىن	化变层
خېموناستىيە	感药性
خېننىن	锥状饰物
خېيرولىن	桂竹香素
خېگارى	赫格利
خېۋلاندىت	片沸石
خەتمە	花葵属
خەسىس	铁公鸡
خەسە	上等细布
خەلقئارالىق	国际性
خەلقچىلىك	人民性
خەنزۇشۇناس	汉学家
خەۋەرلەشتۈرۈش	谓语化
دائۇبرېئېلىت	陨硫铬石
داتسىت	英安岩
داتسىيىلىكلەر	达西亚人
داتچىك	传感器
داخىئاردىت	环晶石
دادائىزم	达达主义
دادائىزمچىلار	达达派
داراپسكىت	钠硝矾
داردانىلار	达达尼人
داردلار	达尔德人
دارغىنلار	达尔金人
دارماكاكرا	转法轮
دارۋىن	达尔文
دازىلىرىئون	毛百合
داسيۇلار	达斯于人
داشقالچى	除废渣工
داشكېسانىت	氯闪石
داغسىز	白璧无瑕
دافلالار	邦尼人
دافنىن	瑞香苷
دافنېتىن	瑞香素
داكتىلوزۇئىد	指状个员
داكتىلوپورا	指状孔
داكتىلوگرافىيە	指纹学
داكوتالىقلار	达科达人
داكۋا	蔓贝壳杉
داللاسلىقلار	达拉斯人
دامارۇ	达玛鲁
داموللا	大毛拉
دانائىت	钴毒砂
دانالىت	铍榴石
دانبۇرىت	赛黄晶
داننېمورىت	锰铁闪石
دانىچىلىشىش	成粒作用
دانچىك	魔潜鸟
دانەكچى	芫荽籽
داۋسونىت	片钠铝石
داۋمانىت	道马矿
داۋىتا	戴维达
داۋىزىت	柱氯铅矿
داۋىسسون	戴维孙
ددىئاسپورومېتر	偏离计
درازوكسولون	敌菌酮
درالون	特拉纶
دراماتۇرگ	戏剧家
درامامىن	乘晕宁
دراپ	夏装呢
دراگۇن	龙骑兵
دراۋىت	镁电气石
دروزومېتر	露量计
دروسسېل	扼流圈
درىت	溢晶石
درىنكومېتىر	液耗仪
دوئىنا	多伊纳曲
دوترىكونتان	三十二烷
دودىن	多果定
دودېتسىل	十二烷基
دودېكان	十二烷
دورسېي	多尔西
دورىئانلار	多利安人
دورىپۇرۇش	走方郎中
دوزىمېتر	剂量计
دوزىمېترىك	剂量测定
دوكترىنيور	空论派
دوكسىسىكلىن	强力霉素
دوكسىلامىن	抗敏安
دوكوسان	二十二烷
دولومىت	白云石
دولىخوزاۋر	狭长蜥
دولېرىت	粗玄岩
دوماتىئۇم	虫菌穴
دومبىرا	冬不拉琴
دومكىرات	攀重器
دوملار	多姆人
دومىلە	触霉头
دومىنانت	显性者
دومېيكىت	砷铜矿
دونگولالىقلار	栋古拉人
دوپامىن	多巴胺
دوپلېر	多普勒
دوگرالىقلار	多格拉人
دوگمىچىلىق	教条主义
دوگۇر	曲棍球
دىئابولېئىت	羟铜铅矿
دىئاخىلون	铅硬膏
دىئاد	二分体
دىئارسېنىد	二砷化物
دىئازول	二吖唑
دىئازومىنو	重氮胺基
دىئاستىل	三径间式
دىئاسكوپ	透皮玻片
دىئاسپورا	硬水铝石
دىئافانوسكوپ	透窥镜
دىئافانومېتر	透明度计
دىئافراگمىلاش	制光圈
دىئال	测角盘
دىئالكىل	二烃化物
دىئاللاگ	异剥辉石
دىئالىزاتور	渗析器
دىئالىفور	氯亚磷
دىئالېكتولوگىيە	方言学
دىئالېكتىكىچى	辩证论者
دىئاماگىنىت	抗磁体
دىئامىنو	二氨基
دىئانت	遗子团
دىئانېتىكا	智力学
دىئاپازون	测音器
دىئاگراف	作图器
دىئاگراممېتر	图解器
دىئود	二极管
دىئورىت	闪长岩
دىئوسفېنول	地奥酚
دىئوسما	地奥属
دىئوكساكارب	二氧威
دىئوكسان	二氧六环
دىئوكسىدلار	二氧化物
دىئوپتازا	透视石
دىئوپترمېتىر	屈光度计
دىئوپترىكا	屈光学
دىئوپترىيە	屈光度
دىئوپتومېتر	屈光计
دىئىزوبۇتىلېن	二异丁烯
دىئۇرون	敌草隆
دىئېتانولامىن	二乙醇胺
دىئېترىخىت	铁锰锌矾
دىئېتزېئىت	碘铬钙石
دىئېتوتېراپىيە	饮食疗法
دىئېستېرازا	二酯酶
دىئېنوفىنلار	二烯属
دىئېنېسترول	双烯雌酚
دىبرومىد	二溴化物
دىبوران	乙硼烷
دىبۇكائىن	狄布卡因
دىبېنزانتراتسېن	二苯并蒽
دىبېنزىلىن	苯氧苄胺
دىتسىنودونت	二齿兽
دىتون	长三度
دىتىئوكاربامات	氨荒酸盐
دىتىئول	二硫醇
دىخروسكوپ	二向色镜
دىخلوروبۇتان	二氯丁烷
دىخلوروبېنىل	敌草腈
دىخلوروتولۇئېن	二氯甲苯
دىخلوروفېن	双氯酚
دىخلوروپېنتان	二氯戊烷
دىخلوروگىدرىن	二氯醇
دىخلورىد	二氯化物
دىخلوفلۇئانىد	抑菌灵
دىخلوفېنتىئون	除线磷
دىخوتومىيە	二歧式
دىدىموسپورا	双生孢子
دىدىمولىت	钙蓝石
دىدىپلوئىد	二二倍体
دىراك	狄拉克
دىرېكتورلۇق	董事职务
دىزېلېۋوز	柴油机车
دىستونىيە	张力障碍
دىسرىتمىيە	节律障碍
دىسفازىيە	言语困难
دىسكاريوز	核异质
دىسكانت	童高音
دىسكرازىت	锑银矿
دىسكرازىيە	体质不调
دىسكو	迪斯科
دىسكوفورا	灰波尺蠖
دىسكومپوزىتسىيە	原子位移
دىسكوگرافىيە	唱片分目
دىسكېلىئون	二飞饰
دىسىئانىد	二氰化物
دىسىئانىن	双花青
دىسىلان	乙硅烷
دىسىلىتسىد	二硅化物
دىسىلىكات	二硅酸盐
دىسپلاستىك	混合体型
دىسپېتچېر	调度员
دىسپېرسوئىد	分散胶体
دىسگېنىكا	劣生论
دىسۇلفوتون	乙拌磷
دىسۇلفىد	二硫化物
دىسېلېنىد	二硒化物
دىفتورىد	二氟化物
دىفتونگلىشىش	双元音化
دىففۇزىئومېتر	渗滤计
دىففۇزىئونىزم	传播论
دىففۇزىئونىست	传播论者
دىفلۇرون	敌蚊隆
دىفوسفات	二磷酸盐
دىفوسفولان	二嘛磷
دىفېناترىل	二苯乙腈
دىفېنامىد	草乃敌
دىفېنان	迪芬南
دىفېنىلامىن	二苯胺
دىفېنگىدرامىن	苯海拉明
دىكانول	狄加拿尔
دىكتاتور	专政者
دىكتور	播音员
دىكتورلۇق	播音专业
دىكتيوسپورا	砖格孢子
دىكتيونېما	网笔石
دىككىت	地开石
دىككىنسونىت	绿磷锰矿
دىكلوران	氯硝胺
دىكۋات	敌草快
دىكېتون	双烯酮
دىكېتوپىپېرازىن	二酮哌嗪
دىلاتومېتر	膨胀计
دىلاكتون	二内酯
دىلانتىن	大伦丁
دىللېنىيە	五桠果
دىلېمما	两难推理
دىممېر	节光器
دىمورفىت	硫砷矿
دىمېتاخلون	纹枯利
دىمېترىن	苄菊酯
دىمېتىلان	敌蝇威
دىمېر	二聚物
دىمېنگىدرىنات	茶苯海明
دىمېگالىيە	两型性
دىنامىزم	物力论
دىنامىست	物力论者
دىنامېتىر	达因计
دىناگراف	验轨器
دىنسىزلىق	非宗教
دىنلاشتۇرۇش	宗教化
دىنوبۇتون	敌螨通
دىنود	打拿极
دىنوزاۋرلار	恐龙类
دىنوسېب	地乐酚
دىنوفىلىيە	好转虫类
دىنوكاپ	敌螨普
دىنوميىد	花背豚鼠
دىنىترامىن	敌乐胺
دىنىترو	二硝基
دىنىتروبېنزېن	二硝基苯
دىنگوت	直熔锭
دىنۇكلېئوتىد	二核苷酸
دىنېل	迪尼尔
دىپتېرولوگىيە	双翅学
دىپروپېترىن	杀草净
دىپساق	川续断
دىپلوئىدلىشىش	二倍化
دىپلوفازا	二倍期
دىپلېكس	同向双工
دىپنوئانلار	肺鱼类
دىپنون	二苯农
دىپىر	钙钠柱石
دىپېنتېن	二戊烯
دىپېپتىدازا	二肽酶
دىچۆلياڭ	的确凉
دىگالىد	二卤化物
دىگلۇكوزىد	二葡糖苷
دىگىتالوزا	毛地黄糖
دىگىتالىس	洋地黄
دىگىتالىن	毛地黄苷
دىگىدرات	二水合物
دىگىدروبېنزېن	二氢苯
دىگېنىت	蓝辉铜矿
دىۋىنىل	联乙烯
دىۋېرتور	偏滤器
ديوگوت	木焦油
ديېرىلار	迪利人
ديېلدرىن	狄氏剂
دۆنەن	三岁驹
دۇئالىزم	二元性
دۇئالىست	二元论者
دۇئانامە	祷告文
دۇبھې	北斗一
دۇتار	二弦琴
دۇرانگىت	橙砷纳石
دۇررىن	叶下珠苷
دۇرىنىت	暗煤素质
دۇفرېنوئىزىت	硫砷铅矿
دۇفرېنىت	绿磷铁矿
دۇلسىتول	卫矛醇
دۇمورتيېرىت	蓝线石
دۇنداسىت	白铝铅矿
دۇنىت	纯橄榄岩
دۇنياخور	守财奴
دۈدۈتلىمەك	嘟嘟声
دۈشمەنلەر	敌对分子
دۈمبىجىگەر	调料烤肝
دېئامىنازا	脱氨基酶
دېئوكسىپېنتوزا	脱氧戊糖
دېئونتولوگىست	义务论者
دېئونتولوگىيە	义务论
دېئىزم	自然神论
دېترويتلۇقلار	底特律人
دېتسىئامپېر	分安培
دېتسىبېلمېتىر	分贝计
دېتسىبېلۋولت	伏特分贝
دېتسىزىئونىزم	判决主义
دېتسىلوگارىفما	分对数
دېتېرمىنىزم	决定论
دېتېكتور	水量计
دېربىلىت	锑钛铁矿
دېرمابوما	生皮节
دېرماتولوگ	皮科学家
دېرماتوگېن	表皮原
دېرنىت	碱磷灰石
دېرېپرېسسىيە	解阻遇
دېزامىنازا	脱氨酶
دېسانت	陆战队
دېسموئىن	得梅因
دېسمولازا	碳链酶
دېسموگېن	韧带原基
دېسمىدىئولوگىيە	鼓藻学
دېسمېترىن	敌草净
دېفتومېتر	深度计
دېفلېكتومېتر	挠度计
دېفېكتولوگىيە	缺点学
دېكابوران	癸硼烷
دېكارت	笛卡儿
دېكاگىدرونافتالېن	十氢化萘
دېكرېمېتىر	减幅计
دېكستروزا	右旋糖
دېكسترىنازا	糊精酶
دېككا	台卡仪
دېكلىنومېتىر	磁偏针
دېكوللېكتور	拆散器
دېكوممۇتاتسىيە	反互换
دېكوممۇتاتور	反互换器
دېكومېتر	台卡计
دېكونسېنتراتور	反浓缩器
دېكونيۇگاتسىيە	早期解离
دېكوگېرېر	散屑器
دېلافوززىت	铜铁矿
دېلتا	三角洲
دېلفىنىدىن	飞燕草素
دېلورېنزىت	钛钇铀矿
دېلۋائۇكسىت	胶磷铁矿
دېماترون	代玛管
دېماسوس	引风机
دېناتۇرانت	变性剂
دېنزىتومېتر	光密度计
دېنندروگرافىيە	树径记录
دېيتېرانومالىيە	绿色弱视
دېيتېروزۇئىد	次芽体
دېپروگرام	解洗脑
دېپسىدون	缩酚酮
دېپولىمېرازا	解聚酶
دېپوليارىزاتور	消偏振镜
دېگۇئېلىن	鱼藤素
دېھقانلاشتۇرۇش	农民化
دېھۋانلار	德瓦尔人
دېۋرىنول	草萘胺
دېۋونشىر	德文郡
دېۋىلىت	钙铜矾
دېۋىندتىت	磷铅轴矿
دېۋېيلىت	水蛇纹石
دېۋەيلىمەك	咄咄逼人
دەخلىسىز	不可侵犯
دەرتمەن	闷气鬼
دەردمەنلىك	郁抑不快
دەرمەھەل	不假思索
دەرىجىلىگۈچ	乘方器
دەرەخشۇناس	树木学家
دەستگاھ	达斯特格
دەلدۈشلەشمەك	呆小病化
دەلىللىك	站得住
دەلىللىگۈچ	验记器
دەلىلچىلىك	实证论
دەۋالاشقۇچى	当事人
دەۋەگەر	原告人
رائۇۋۇلفىيە	萝芙木
رابدوزوما	笔石群体
رابدوفان	磷稀土矿
رابدوم	感杆束
راتسىئوناللىق	有理性
راتسېمىزاتسىيە	外消旋
راخىت	佝偻病
راخىتوملار	块椎类
رادىئانت	辐射点
رادىئوتېخنولوگىيە	辐射技术
رادىئوتېرمىكا	辐射热学
رادىئوتېلېفون	无线电话
رادىئوخروماتوگرامما	放射色谱
رادىئودونتىيە	牙放射学
رادىئوسكوپىيە	射线检验
رادىئوكاناي	扬声器
رادىئولىتسىمان	放射扇状
رادىئولىز	辐射分解
رادىئوليارىت	放射虫岩
رادىئوليارىيە	放射虫
رادىئومۇتاتسىيە	放射突变
رادىئوگالو	放射晕
رادىئوگراف	放射照片
رادىست	报务员
رادىكاللار	激进派
رادىكاللىشىش	激进化
رادىكالىزم	激进主义
رازۋېدچىك	侦察人员
راسخودومېر	流量计
راسپىت	斜钨铅矿
راففىنازا	棉子糖酶
راففىنوزا	棉籽糖
رافىد	针晶体
راكشۇناس	癌学家
رامائىزم	罗摩派
رامالار	拉马人
رامزىن	拉姆津
رامسدېللىت	斜方锰矿
رامنازىن	鼠李精醚
رامنوزا	鼠李糖
رامنوزىد	鼠李糖苷
رامنىتول	鼠李糖醇
رامنىنوزا	鼠李三糖
رامنېتىن	鼠李亭
رامىزم	拉梅主义
رامۇسىلار	拉穆希人
رانكىنىت	硅钙石
رايسلار	拉依人
رايونشۇناسلىق	地区学
رايونىزم	光射主义
راپسودىيە	狂想曲
راپونتىكۇم	祁州漏芦
راپونتىن	祁芦亭
راپونتىگېنىن	祁芦配基
راڭكوللار	朗戈尔人
راھىبچىلىق	僧侣主义
راھىبەلىك	尼姑身分
راۋاپ	热瓦甫
راۋراتسىلار	劳拉塞人
روئوزېۋېلتىت	砷铋矿
روئۇمانىت	罗琥珀
روئېبلىنگىت	铅蓝方石
روئېمېرىت	罗默矿
روبىنوزا	刺槐糖
روبىنىن	刺槐苷
روبىنھام	罗宾汉
روبىنېتىن	刺槐亭
روتاتور	旋转体
روتاۋىرۇس	轮病毒
روتلېرىن	咖马林
روتېر	路由器
روتېنون	鱼藤酮
روخىللالار	罗希拉人
رودامىن	若丹明
رودانازا	硫氰酸酶
رودانىد	硫氰酸盐
رودانىدلار	硫氰化物
رودانىن	若丹宁
رودبرىجىت	绿铁矿
رودلۇقلار	罗得岛人
رودوخروزىت	菱锰矿
رودولىت	镁铁榴石
رودوپلاست	藻红体
رودىت	铑岩石
رودىزىت	硼锂铍矿
رودىنال	罗迪纳尔
رودىنول	玫红醇
روزارامىتسىن	蔷薇霉素
روزالىنىن	蔷薇苯胺
روزانىلىن	品红碱
روزىككىئىت	斜自然硫
روزېلىت	砷钴钙石
روزېمارىيە	迷迭香
روساسول	罗少梭汁
روسسوئانتىت	闪长班岩
روسسىئىت	水钒钙石
روكېلائۇرا	齐膝大氅
رولخانا	操舵室
روللاردا	演员表
رومالسىمان	披巾式
رومانتىتسىزم	浪漫精神
رومانتىزم	浪漫主义
رومانتىكلاشتۇرۇش	空想化
رومبوكلاس	板铁矾
رومبوگېن	菱形体
رومبىد	长斜方形
رومېئو	罗咪欧
رومېئىت	锑钙石
رونگالار	隆加人
رويزىئوتى	结缕草
روپپىت	重烧绿石
روۋامىتسىن	罗瓦霉素
روۋېئىت	硼锰钙石
رىئانودىن	兰尼定
رىئېبېئېكىت	钠闪石
رىبونۇكلېئوزىد	核糖核苷
رىبۇلوزا	核酮糖
رىتالىن	利他林
رىتسىيىلىكلەر	里西亚人
رىتمولوگ	韵律学者
رىتىمسىز	非节律性
رىتۋانلار	利特万人
رىخمان	利赫曼
رىدبېرگ	里德伯
رىدوست	虹色细胞
رىزات	里扎特
رىزوپتېرىن	根蝶酸
رىزىدىئاتسىيە	根壶科
رىفامىتسىن	利福霉素
رىقابەچى	竞争对手
رىملاشتۇرۇش	罗马化
رىملىقلار	罗马人
رىنخولىت	有齿石
رىنكىت	林克矿
رىننېئىت	钾铁盐
رىنوسپورىدىيە	鼻孢子虫
رىپېنو	伴奏声部
رىچاردسون	李恰逊
رىچموندلار	里士满人
رىگېل	参缩七
ريۇكيۇلۇقلار	琉球人
رۇبائى	柔巴依
رۇبرېن	红荧烯
رۇبىتسېل	橙尖晶石
رۇبېللىت	红电气石
رۇتائېكارپىن	吴茱萸碱
رۇتىنوزا	芸香糖
رۇتۇلىلار	罗图利人
رۇسسوئىزم	卢梭主义
رۇسلىشىش	俄国化
رۇسوت	洛索素
رۇمفورد	论副特
رۇمىكىس	鲁梅克斯
رۇگېنسكى	卢庚斯克
رۋاندالىقلار	卢旺达人
رېئاكتولوگىيە	反应学
رېئاكتىپ	喷气式
رېئاكسىيىلىشتۈرگۈچ	反应器
رېئاكسىيىلىك	反应性
رېئاكىن	虞美人碱
رېئاللانماق	自我实现
رېئاللىشىش	现实化
رېئالپاكىت	既成事实
رېئالچىلىق	唯实论
رېئوسكوپ	检电器
رېئومېتر	流变计
رېئىنكارناتسىئونىست	再生论者
رېباب	瑞巴琴
رېبېك	瑞别克琴
رېتسېپتور	感受器
رېتسېپسىئونىزم	领受主义
رېتولۇقلار	列托人
رېتېنوئىد	类鱼藤酮
رېدجاڭلار	列章人
رېددىلار	利迪人
رېددىنگىت	磷锰锂矿
رېدىنگتونىت	铁铬矾
رېدۇكتازا	还原酶
رېدۇكتون	还原酮
رېزورناتور	谐振器
رېزىنوگرافىيە	树脂照相
رېزېرفورد	卢瑟福
رېفراكتومېتر	折射计
رېفلېكتومېتر	反射计
رېفلېكسولوگىيە	反射学
رېفلېكسىزم	反射论
رېكابىتلار	勒卡布人
رېكاپىتۇلياتسىئونىست	重演论者
رېكومبىنانت	重组体
رېكىلار	勒基人
رېكۇپېراتور	复位器
رېكۋىئېم	安魂曲
رېكۋىېئم	安灵曲
رېلاكسومېتر	张驰计
رېلى	断电器
رېماتىزم	风湿病
رېمىلار	勒米人
رېنتگېنمېتر	伦琴计
رېنسېلائېرىت	假晶滑石
رېننىن	凝乳酶
رېنىنوگېن	凝乳酶原
رېنگمالار	伦马人
رېينلاندلار	莱茵兰人
رېيننېككاتلار	赖内克盐
رېپلىكازا	复制酶
رېپلىكون	复制子
رېپېئاتېر	中继器
رېپېرفوراتور	复凿机
رېژىسسورشۇناسلىق	导演学
رېۋماتولوگىيە	风湿病学
رېۋولۋېر	转轮手枪
رېۋىزىئونىزم	修正主义
رېۋېلاتسىئونىست	启示论者
رەزنىگۈل	麦杆菊
رەزىنگۈل	麦秆菊
رەفقەگۈل	一品红
رەقەمسىز	非数字
رەقەملىك	数字式
رەقەملەشتۈرگۈچ	数字化仪
رەقەملەشتۈرۈش	数字化
رەنجىرسىمان	连带债务
رەڭسىزلىك	无色性
رەڭشۇناسلىق	色彩学
رەڭلىگۈچ	着色剂
رەڭلىگۈچى	着色工
رەھىمدىللىك	怜悯心
زاراتىت	翠镍矿
زاسېداتېل	陪审员
زاغراق	胖姑娘
زاكا	尿布衬
زاماسكىلىغۇچ	油灰刀
زامانىۋىلاشتۇرماق	现代化
زامزۇممىم	赞米米姆
زانيىزم	赞扎琴
زايىرلىقلار	扎伊尔人
زاپارولار	萨帕罗人
زبېيسەي	紫北塞
زوئوتېخنىكا	动物饲养
زوئوستېرول	动物固醇
زوئوسفېرا	动物圈
زوئوسپورا	游动孢子
زوئوفۇلۋىن	羽黄素
زوئولوگىيە	动物学
زوئوگامېتا	游动配子
زوئوگرافىيە	动物志
زوئىزىت	黝帘石
زورتسىكو	佐茨科
زورزىت	糟绿帘石
زورلانماق	勉为其难
زوفا	神香草
زوقلىنارلىق	好玩儿
زوماتولوگىيە	躯体学
زوماتىزاتسىيە	躯体化
زوماتىست	躯体论者
زومولنوكىت	水铁矾
زوناسىزلىق	非地带性
زونالىق	地带性
زىانلىقلىق	危害性
زىبېك	塞贝克
زىددىيەتسىزلىك	不矛盾性
زىراپە	长颈鹿
زىركونات	锆酸盐
زىركونوئىد	锆石晶形
زىركونىل	氧锆基
زىزىت	吉纪丝
زىققىنەپەس	水寒射肺
زىلاندلىقلار	泽兰人
زىموتىك	发酵病
زىموسان	酵母聚糖
زىموستېرول	酵母甾醇
زىمىن	胰酶素
زىنجانتروپلار	东非人
زىننەتلىك	重彩浓饰
زىنگېرون	姜油酮
زىنېب	代森锌
زىيارەتشۇناسلىق	采访学
زىپپېئىت	水铀矾
زىڭگېل	金吉鲈
زىگادېنىن	棋盘花碱
زىگوسپورا	接合孢子
زىگوفازا	合子期
زىگوفورا	接合藻纲
زىگوفىللۇملار	霸王植物
زىگومىتسېتا	接合菌
زۇخلورېللا	虫绿藻
زۇكسانتېللا	虫黄藻
زۇلمەتلىك	暗无天日
زۇنىئىت	氯黄晶
زۇگلېيە	菌胶团
زېئاتىن	玉米素
زېئاكسانتىن	玉米黄质
زېئوفىللىت	叶沸石
زېئولىتلار	沸石类
زېئۇسلار	海鲂类
زېئۇگىت	核偶细胞
زېبۇلۇنىتلار	西布伦人
زېروگېل	零凝胶
زېرىكتۈرۈۋەتمەك	讨人嫌
زېرۋانىزم	泽范教
زېزوناتور	共振器
زېفىر	细薄织物
زەبەردەس	五大三粗
زەرباب	金丝织物
زەرگەرلىك	金工活
زەرەتلىگۈچى	充电器
زەيتۇنسىمان	橄榄形
زەپىرەڭ	九重葛
زەگۈندە	防潮层
زەۋرەك	梯牧草
سائارلىقلار	萨尔人
سائىتلىقلار	塞伊斯人
سائۇرالار	索拉人
سائۇسسۇرىت	糟化石
سائۇسسۇرىتلىشىش	糟石化
سائۇلتېيرلار	苏特人
سابادىللا	苇茎百合
سابالار	萨巴人
سابېللار	萨贝尔人
ساتتۋا	萨特瓦
ساترېلىقلار	萨特雷人
ساتىراش	理发师
ساتۇرا	古讽刺剧
ساخارومېتر	糖量计
ساخرازا	转化酶
ساراتسېنلار	撒拉逊人
ساراسىمىلىك	诚惶诚恐
ساراپ	彩色披毯
ساردىسلىقلار	萨迪斯人
ساردىنىيىلىكلەر	撒丁人
سارسازان	盐生草
ساركوزىن	肌氨酸
ساركولوگىيە	移植理论
ساركومىتسىن	肉瘤霉素
سارمىئېنتىت	砷铁矾
سارگاس	马尾藻
سازاڭسمانلار	蠕形动物
سازلىقلىشىش	沼泽化
ساسارا	散柘罗
ساقاقسىزلار	无鳃类
ساقاقلىقلار	有鳃类
ساقالتاي	胡兀诮
ساقام	小小宝宝
ساقلاتقۇچى	寄存人
ساقلىغۇچسىز	无存储器
ساقىيقۇشسىمانلار	鹈形目
ساكايلار	萨凯人
ساكسوفون	萨克管
ساكسونلار	萨克森人
ساكسگورن	萨克号
ساكيامۇنى	释迦牟尼
سالارلار	萨拉人
سالامباۋ	竹筏罾
سالمات	萨尔马特
سالمىن	鲑精蛋白
سالمىچى	套马者
سالىت	次透辉石
سالىتسىلامىد	水杨酰胺
سالىتسىلىد	水杨内酯
سالىگېنىن	水杨醇
سالۋاتىئونىست	救世军
سالۋىئانىن	鼠尾草苷
ساماخىتا	三摩四多
سامارسكىت	铌钇矿
سامبودى	三菩提
سامبۇسا	油煎包子
سامسا	烤包子
سامماتا	三末多
سامنىتلار	桑尼特人
ساموئالىقلار	萨摩亚人
ساموتېرى	萨摩兽
ساموسلۇقلار	萨摩斯人
سامپسائېلار	萨姆塞人
سامپۇتا	三补吒
سانائەتچى	工业家
ساناقلىقلا	屈指可数
ساناۋبەر	筋骨草
سانبورنىت	硅钡石
سانتافېلىقلار	圣菲人
سانتاللار	圣塔尔人
سانتالول	檀香脑
سانتالىن	紫檀素
سانتالېن	檀香烯
سانتىلار	桑蒂人
سانتېنون	檀烯酮
ساندىئالار	桑迪阿人
ساندۋىچ	三明治
سانسكرىتلاشتۇرۇش	梵文化
سانمارتىنىت	钨锌矿
سانىتار	卫生员
سانىدىن	透长石
سانىدىنىت	透气岩
سانگىرلار	桑义赫人
سانگۇينارىن	血根碱
سايئوپا	柴窝堡
ساياھەتچىلىك	旅游业
سايلىغۇچ	表决器
سايمائىت	赛马矿
ساپانامە	资质证书
ساپلاشتۇرغۇچ	净化器
ساپوتوكسىن	毒皂角苷
ساپونىلار	萨坡尼人
ساپونىن	皂角苷
ساپوگېنىن	皂苷配基
ساھىبخانلىق	地主之谊
ساۋاتلىق	识文断字
ساۋاننالىقلار	萨凡纳人
ساۋويلۇقلار	萨瓦人
ستائۇروسكوپ	十字镜
ستائۇرولىت	十字石
ستابىسمومېتر	斜视计
ستابىلاتور	全动平尾
ستابىلىت	斯太比利
ستابىلىۋولت	稳压管
ستاتئوم	静电欧姆
ستاتكۇلون	静电库仑
ستاتوسفېرا	平流层
ستاتىستىكىزم	统计主义
ستاتىستىكىشۇناس	统计学家
ستاتىستىكىچى	统计员
ستاتىكون	视像管
ستاتېر	始动机
ستاخىئوزا	水苏糖
ستاخىدرىن	水苏碱
ستارلىت	蓝锆石
ستارىت	斯塔尔特
ستاسفۇرتىت	纤硼石
ستالاكتىت	钟乳石
ستاننات	锡酸盐
ستراتىگرافىيە	地层学
ستروب	频闪灯管
ستروبلۇس	孢子叶球
ستروفا	左旋舞
ستروفانتىدىن	羊角拗定
ستروفانتىن	羊角拗质
ستروفوئىد	环索线
ستروماتولىت	垫藻岩
ستروماتىن	基质蛋白
سترومېيېرىت	硫铜银矿
سترونتىئانىت	菱锶矿
سترونگىلوز	圆线虫病
سترىخنىن	马钱子碱
سترىخىنىن	士的宁
سترىپپېر	汽提器
سترىگولنىكلار	剪发派
سترۇۋىت	鸟粪石
سترېنگىت	红磷铁矿
سترېپتامىن	链霉胺
سترېپتوترىتسىن	链丝菌素
سترېپتوزا	链霉糖
سترېپتوكىنازا	链激酶
سترېپتومىتسىن	链霉素
سترېپتونىگرىن	链霉黑素
سترېپتىدىن	链霉定
سترېپسىتېن	绞线期
ستسىللارېنىن	绵枣儿苷
ستسىلىتول	青蟹肌醇
ستسىنتىللوسكوپ	闪烁镜
ستسىنتىللياتور	闪烁器
ستسىنتىگرافىيە	闪烁摄影
ستسىنتىگرامما	闪烁图
ستسېنوگرافىيە	透视法
ستوكس	斯托克斯
ستوكېزىت	硅钙锡矿
ستولزىت	钨铅矿
ستوماتولوگىيە	口腔学
ستونلاشتۇرۇش	栏目化
ستوۋائىن	期妥乏因
ستىبنىت	辉锑矿
ستىبوفېن	锑波酚
ستىبىئوتانتالىت	钽锑矿
ستىبىئوكولۇمبىت	铌锑矿
ستىبىئوپاللادىنىت	锑钯矿
ستىبىت	辉沸石
ستىبىكونىت	黄锑矿
ستىختىت	铬鳞镁矿
ستىراتسىتول	苏合香醇
ستىراتسىن	苏合香英
ستىرىلامىن	苯乙烯胺
ستىرېنلىشىش	苯乙烯化
ستىشوۋىت	超石英
ستىفنات	收敛酸盐
ستىكىنلىقلار	斯梯肯人
ستىلوتىپىت	柱形矿
ستىلولىت	石笔杆
ستىلىزم	文体主义
ستىلىست	文体家
ستىلىستىكىچى	修辞学者
ستىمولىن	刺激素
ستىگماستېرول	豆甾醇
ستۇدېنت	大学生
ستۇرىن	鲟精蛋白
ستېئاتىت	块滑石
ستېئارامىد	硬脂酰胺
ستېئاروتېن	硬脂萜
ستېئارون	硬脂酮
ستېئارويل	硬脂酰
ستېئاپسىن	胰脂酶
ستېئىن	斯特思
ستېرادىئان	球面度
ستېررېتتىت	水磷铝石
ستېركوبىلىن	粪胆素
ستېركورىت	磷钠铵石
ستېرىلىزاتور	消毒器
ستېرىنبېرگىت	硫铁银矿
ستېرېئوبلاستۇلا	实囊胚
ستېرېئوتروپىزم	向触性
ستېرېئوخىمىيە	立体化学
ستېرېئوسكوپ	体视镜
ستېرېئولوگىيە	立体视学
ستېرېئومېترىيە	立体几何
ستېرېئوپرويېكسىيە	立体投影
ستېرېئوگرامما	实体图
ستېرېسكوپ	立体镜
ستېرېگون	球面全角
ستېللاراتور	仿星器
ستېنوتېرمىك	狭温性
ستېنوفورا	栉水母门
ستېيگېرىت	水钒铝矿
ستېۋىئوزىد	蛇菊苷
ستېۋېنگراف	斯提文图
سخۇللار	斯虎尔人
سخېموخروما	结构色
سخېمىلاشتۇرۇش	图表式
سزايبېلىئىت	硼美石
سفائېرىت	球磷铝石
سفاتسېلوما	痂圆孢属
سفالېرىت	闪锌矿
سفىنگوزىن	鞘氨醇
سفىنگولىپىدلار	鞘脂类
سفىگمومانومېتىر	血压计
سفىگموگرامما	脉搏曲线
سفېروئىد	椭球体
سفېرىكلىك	球面性
سكاتتېرومېتر	散射仪
سكاتول	粪臭素
سكاتولوگىيە	粪便学
سكافىت	船菊石
سكاكخىت	氯锰矿
سكاۋتىت	片柱钙石
سكراپېر	印刷刮板
سكلارېئول	硬尾醇
سكلودوۋسكىت	硅镁铀矿
سكلېروبلاست	生骨细胞
سكلېروبلاستېما	生骨组织
سكلېروتوما	生骨节
سكلېروتىنىئوزىيە	核盘菌病
سكلېرودېرمىت	灰质簇
سكلېروگېن	硬化原
سكوتوخروموگېن	暗产色菌
سكوتوفوبىن	畏黑素
سكوتومېتىر	暗点计
سكوتوپىيە	暗适应
سكوتېر	海番鸭
سكورودىت	臭葱石
سكورىفىكاتسىيە	铅析法
سكولىت	石穴管
سكولىن	斯科林
سكولېتسىت	钙沸石
سكومبرىن	鲭精蛋白
سكوپارىن	金雀花素
سكوپولامىن	莨菪胺
سكوپولىن	莨菪灵
سكوپولېتىن	莨菪亭
سكوپىن	莨菪品
سكىئاسكوپ	视网膜镜
سكىئالىت	残影体
سكىدىلار	斯基迪人
سكۇتتېرۇدىت	方钴矿
سكۋالېن	角鲛油萜
سلاۋلار	斯拉夫人
سلاۋىكىت	菱镁铁矾
سلۇببىلار	斯鲁比人
سماراگدىت	绿闪石
سمالتىت	砷钴矿
سمولىسىزلاشتۇرماق	脱树脂
سمولىلاشتۇرۇش	树脂化
سمىتسونىت	菱锌矿
سمىرنالىقلار	士麦拿人
سمىلاگېنىن	菝葜配基
سمىلونىن	菝葜宁
سمېكتىت	蒙皂石
سنوپتىكا	天气学
سنېل	斯涅耳
سوئۇسافون	苏萨大号
سوتسىئولوگ	社会学家
سوتېرىئولوگىيە	救世神学
سودالىت	方钠石
سوددىت	硅铀矿
سودىگەرلىك	买卖业
سوربوزىد	山梨糖酐
سوربونىست	山梨糖
سوربىت	索氏体
سوربىتول	山梨酸醇
سوروسىلىكات	俦硅酸盐
سوغۇقراق	冷丝丝
سوقۇشتۇرغۇچ	对撞机
سولاتسىيە	溶胶化
سولارىمېتر	日射表
سولازودىن	茄解啶
سولازونىن	茄解碱
سولاقخانا	看守所
سولامچىخانا	私会房
سولانلار	索伦人
سوليارىزاتسىيە	负感作用
سولۇنىت	索伦石
سولۋات	溶剂化物
سوماتوبلاست	原体细胞
سوماتوتروپىزم	向体性
سومالىلىقلار	索马里人
سوناتا	奏鸣曲
سوناگراف	语图仪
سونورالىقلار	索诺拉人
سونىكا	声能学
سوگازوئىد	固气溶胶
سوۋبان	杂酸藜
سوۋتان	教士服
سوۋىلۇن	赤霞珠
سوۋېتلاشتۇرۇش	苏维埃化
سوۋېتچە	苏联式
سىئال	硅铝层
سىئالوئادېنىت	涎腺炎
سىئانازىن	草净津
سىئانوبېنزىن	苯甲腈
سىئانوفىتسىن	蓝藻蛋白
سىئانوكرىستاللىن	蓝晶素
سىئانوپلاست	蓝色素粒
سىئانىت	蓝晶石
سىئانىدىن	花青素
سىئونىد	玻璃海鞘
سىئۇئايلار	西乌艾人
سىئۇسىلار	西乌西人
سىئېنالىقلار	锡耶纳人
سىئېگېنىت	硫镍钴矿
سىباھن	塞斑恩
سىبېرىيە	西伯利亚
سىتتېرن	齐特尔琴
سىتراتلىشىش	柠檬酸化
سىترال	柠檬醛
سىترامالازا	柠苹酸酶
سىترومىتسېتىن	柠檬菌素
سىترونېللال	香茅醛
سىترونېللول	香茅醇
سىتروپتېن	柠檬油精
سىترىلىدېن	柠檬叉
سىترىنىن	橘霉素
سىترۇللىن	药西瓜脂
سىترۇلىن	瓜氨酸
سىترېن	柠檬烯
سىتسىلىيىچە	西西里式
سىتسېللار	西塞尔人
سىتكالىقلار	锡特卡人
سىتوتوكسىن	细胞毒素
سىتوخروم	细胞色素
سىتوخىمىيە	细胞化学
سىتودېندرىت	细胞树突
سىتوزىن	胞嘧啶
سىتوستوما	细胞口
سىتوستېرول	谷甾醇
سىتوكىنېز	细胞分裂
سىتول	齐托尔琴
سىتولىز	细胞溶解
سىتومورفوز	细胞变态
سىتوگامىيە	细胞融合
سىتىزىن	金雀花碱
سىتىيىلىكلەر	西徐亚人
سىتۇئاتسىئونىزم	情境主义
سىجىل	一气呵成
سىدنون	斯德酮
سىدنېيلىقلار	悉尼人
سىدونلۇقلار	西顿人
سىدۇرون	环草隆
سىدېروستات	定星镜
سىدېروسىلىكوزىيە	铁矽尘肺
سىدېروفىللىت	针叶云母
سىدېروناترىت	纤钠铁矾
سىدېرىت	菱铁矿
سىرتلانلار	鬣狗类
سىرتولىت	曲晶石
سىرتوپىيە	节鞭幼体
سىركۇلىن	环杆菌素
سىركۇمفېرېنتور	垂准罗盘
سىركېئىلىت	钛锆钍矿
سىرما	拖地袍
سىرېنېلىقلار	昔兰尼人
سىزما	标绘图
سىزىقلاشتۇرغۇچ	线性机
سىزىگىيە	并孢子
سىستاتىئونىن	胱硫醚
سىسترون	顺反子
سىستولىت	钟乳体
سىستوپتېر	气囊蕨
سىستىتسېركوئىد	似囊尾蚴
سىستىن	胱氨酸
سىستېئامىن	巯乙胺
سىستېئىن	半胱氨酸
سىستېماتىزم	体系建筑
سىستېمىچانلىق	系统性
سىسسوئىد	蔓叶线
سىسسېتونلار	西塞顿人
سىسكىيون	黄符石
سىسېرسكىت	灰铱锇矿
سىغىمچانلىقى	容纳能力
سىفونارىيە	菊花螺
سىفونوزوما	管水母柄
سىفىستوما	螅状幼体
سىفىلولوگىيە	梅毒学
سىفىلوگرافىيە	梅毒论
سىفىنوزوئوئىد	管状个员
سىكازىن	苏铁素
سىكامورا	假挪威槭
سىككىملىقلار	锡金人
سىكلازا	环化酶
سىكلازوتسىن	环唑星
سىكلامىن	仙客来苷
سىكلوئالكىل	环烷基
سىكلوئوكتاتېترائېن	环辛四烯
سىكلوئوكتان	环辛烷
سىكلوئولېفىن	环烯烃
سىكلوئىدا	旋轮线
سىكلوباربىتال	环巴比妥
سىكلوبوترا	环床草
سىكلوبۇتادىئېن	环丁二烯
سىكلوبۇتان	环丁烷
سىكلوبۇتېن	环丁烯
سىكلوتېما	韵律层
سىكلودىئولېفىن	环二烯烃
سىكلودىئېنلار	环二烯类
سىكلودېكسترىن	环糊精
سىكلوسىستېما	环状系
سىكلوسىلىكات	环硅酸盐
سىكلوسېرىن	环丝氨酸
سىكلوفوسفامىد	环磷酰胺
سىكلوپروپان	环丙烷
سىكلوپوئىد	剑蚤幼体
سىكلوپېنتادىئېن	环戊二烯
سىكلوپېنتان	环戊烷
سىكلوپېنتانون	环戊酮
سىكلوگېكسان	环己烷
سىكلوگېكسانول	环己醇
سىكلوگېكسانون	环己酮
سىكلوگېكسىل	环己烷基
سىكلوگېكسېن	环己烯
سىكلوگېپتادىن	环丙庚哌
سىكلوگېپتانون	环庚酮
سىكلېترىن	环虫菊
سىكلېرىت	磷锂锰矿
سىكونلار	樽海绵类
سىكېرىزم	求真主义
سىلفا	埋葬虫
سىلكرېت	硅结岩
سىللابىكا	领音学
سىللىلىقلار	锡利人
سىللىمانىت	硅线石
سىللېنىت	软铋矿
سىلوكسان	硅氧烷
سىلوكسىكون	硅碳氧
سىلوكسېن	硅氧烯
سىلىتسىدلار	硅化物
سىلىغۇچى	抚摸者
سىلىقلاتقۇچى	润滑剂
سىلىكا	二氧化硅
سىلىكاتور	硅化容器
سىلىكوتىتانات	硅钛酸盐
سىلىكوۋولفرامات	硅钨酸盐
سىلىندروئىد	椭圆柱
سىلىندىرىت	圆柱锡石
سىلىندېرچى	磨坯工
سىلۋىكۇلتۇرا	造林学
سىلۋىكۇلتۇرىست	造林学家
سىلېتزلار	西勒茨人
سىلېن	麦瓶草
سىماروزا	磁麻糖
سىمازىن	西玛津
سىمبىئوتىكا	共生学
سىمتاراش	修蹄刀
سىمرىت	铝硅钡石
سىمفونىيىلەشتۈرمەك	交响化
سىممېترىكسىزلىك	不对称性
سىمولىت	水磨土
سىمونىيە	买卖圣职
سىمپاتىن	交感素
سىمپسونىت	钽铝石
سىمپلېزىت	砷铁矿
سىمپلېكتىت	后成合晶
سىمچى	铁丝匠
سىمۇلاتور	模拟器
سىمۋوللاشتۇرۇش	象征化
سىمېئونلار	西缅人
سىنئالغۇ	录像机
سىنادېلفىت	羟砷锰矿
سىنالبىن	芥子白
سىنالغان	千锤百炼
سىنالماق	受考验
سىنانتروپ	中国猿人
سىناپات	芥子酸盐
سىناپتوزوما	突触体
سىناپتولوگىيە	突触学
سىناپتون	偶线复体
سىناپتىكۇل	合隔桁
سىناپوسېماتىزم	生物拟态
سىناپىن	芥子碱
سىناگۇئالار	锡纳瓜人
سىنتاكسىسچى	句法家
سىنتروپ	同向体
سىنتومىتسىن	合霉素
سىنتېتازا	合成酶
سىنتېتىزم	综合主义
سىنتېتىست	综合派
سىنتېكسىس	同熔作用
سىنخروباللىستىك	同步补偿
سىنخوفېن	辛可芬
سىنخولوئىپون	辛咖因酸
سىنخونامىن	辛可明
سىنخونىدىن	辛可尼丁
سىنخونىن	辛可宁
سىنخىزىت	菱铈钙矿
سىندىكات	辛迪加
سىندىكالىزم	工团主义
سىندىلىقلار	信德人
سىندىپىئويدىيە	共双倍体
سىنرابدوزوما	群笔石体
سىنقويغۇ	放像机
سىنكات	锌酸盐
سىنكاريون	合子核
سىنكلىنورىئال	复向斜
سىنكوبوترىئوگېن	锌赤铁矾
سىنكوكوپىئاپىت	锌叶绿矾
سىنكىت	红锌矿
سىنكېنىت	辉锑铅矿
سىننابار	千里光蛾
سىننامال	肉桂叉
سىننامالدېگىد	肉桂醛
سىننامويل	肉桂酰
سىننامىل	肉桂基
سىننېما	联丝体
سىنوبۇفاگىن	华蟾蜍精
سىنولوگىيە	犬类学
سىنونىم	同物异名
سىنونىمىكا	同义词学
سىنوپتوفورا	同视机
سىنوپل	铁石英
سىنوپىت	铁铝英石
سىنوپىيە	华铁丹
سىنىسترىن	海葱糖
سىنىغۇچى	试验员
سىنىفىكاتور	天宫主星
سىنىپىيلىك	阶级性
سىنچاي	饭前茶
سىنگالىت	硼铝镁石
سىنگاپورلۇقلار	新加坡人
سىنگۇليارىزم	唯一论
سىنگېكسىل	顺己基
سىنگېنىت	钾石膏
سىنۇسوئىد	正弦曲线
سىنېئول	桉树脑
سىنېرولون	瓜菊酯酮
سىنېرىن	瓜菊酯
سىنېرگىد	助细胞
سىنېفلۇئوروگرامما	荧光电影
سىنېماتىكا	电影术
سىياسەتشۇناسلىق	政治学
سىياسەتچى	政治家
سىپايىلىق	文雅风度
سىپروتېرون	环孕酮
سىپرىئان	赛普里安
سىپرىتزېر	溅珠泡水
سىپرىن	青符山石
سىپسىلىق	光溜溜
سىڭدۈرگۈچ	浸渍器
سىڭىشچانلىق	渗透性
سىگانلار	吉卜赛人
سىگانلاشماق	吉普赛化
سىگماتىزم	共点性
سىگناتۇرا	药效形象
سىگنالىزاتور	信号器
سىگېكساتىن	环己锡
سىۋالىقلار	西瓦人
سىۋېتومېر	色度计
سىۋېتون	香猫酮
سيانوترىچىت	绒铜矿
سيانوكاربون	氰基烃
سيانوكوبالامىن	氰钴胺
سيانومېترىيە	氰量法
سيانوگاز	氰钙粉
سيوگرېنىت	水镁铁石
سيېنىت	正长岩
سپاتسىستور	宽阔管
سپاتسېر	间隔器
سپادائىت	红硅镁石
سپارتاكلاشماق	斯巴达化
سپازموفىلىيە	痉挛素质
سپازمونېما	痉挛腺
سپانگولىت	氯铜铝矾
سپلىنت	马炮骨瘤
سپودۇمېن	锂辉石
سپوروزوئىت	孢子小体
سپورومورف	包状体
سپوروپلازما	孢原质
سپوندىل	海菊蛤
سپونگىئوسىت	胶质细胞
سپونگىئولوگىيە	海绵学
سپونگىل	针海绵
سپونگىيە	马海绵
سپىدومېتىر	速度表
سپىرامىتسىن	螺旋霉素
سپىروخېتا	螺旋体
سپىرومېتر	呼吸量计
سپىرونولاكتون	螺甾内酯
سپىروپېنتان	螺戊烷
سپىرىللا	螺旋菌
سپىرېما	染色质钮
سپىكۇلا	细尖刺
سپىكۇلىن	针骨素
سپىلوزىت	绿点板岩
سپىلىت	细碧岩
سپىناستېرول	菠菜甾醇
سپىندل	杆状信标
سپىنننېر	旋转动作
سپىنوخروما	棘色素
سپۇررىت	灰硅钙石
سپېتسىئالىست	军队技师
سپېررىلىت	砷铂矿
سپېرماتوتسىست	精原细胞
سپېرماتوكسىن	精子毒素
سپېرماتىفور	精子托
سپېرماتىن	精液蛋白
سپېرماگونىئۇم	性孢子器
سپېرمىدىن	亚精胺
سپېرمىزم	精源学说
سپېرمىست	精源学者
سپېسسارتىت	锰铝榴石
سپېكتروخىمىيە	光谱化学
سپېكترولوگىيە	神灵学
سپېكتروگرافىيە	摄谱学
سپېكتروگرامما	光谱图
سپېكۇلارىت	镜铁矿
سپېلېئولوگىيە	洞穴学
سپېنسېرىت	斜磷锌矿
سۆرىگۈچ	牵引器
سۆرەلمىپالاسلىق	懒洋洋
سۆزلىمەسلىك	万马齐喑
سۆزلىيەلمەسلىك	说不来
سۆزلەشكۈچ	通话器
سۆزنەك	赤白浊
سۆكىگۈل	倒挂金钟
سۆيۈنچە	吉利钱
سۇئېۋىلار	苏维威人
سۇبئاتومىكا	亚原子学
سۇبئالپ	亚高山
سۇبئوكسىد	低氧化物
سۇبانۇنلار	苏巴嫩人
سۇبتراكتور	减色器
سۇبتراكسىيە	减除法
سۇبتىلىن	枯草菌素
سۇبرېفراكسىيە	亚折射
سۇبستانتىۋلىق	实体性
سۇبستانسىئالىزم	实体主义
سۇبفتورىد	低氟化物
سۇبفراكسىيە	亚分数
سۇبكلاسسىفىكاتسىيە	小分类
سۇبلىماتور	升华器
سۇبلىماتوگرافىيە	升华谱法
سۇبلېيكېمىيە	亚白血病
سۇبوردىناتىئونىزم	从属主义
سۇبيېكتىۋىزم	主观主义
سۇبگالىد	低卤化物
سۇبېرىن	软木脂
سۇتايئولار	苏泰俄人
سۇدانلاشتۇرۇش	苏丹化
سۇدانلىقلار	苏丹人
سۇدېتېلىقلار	苏台德人
سۇرات	苏拉特
سۇرامىن	苏拉明
سۇرساسسىت	锰帘石
سۇرىناملىقلار	苏里南人
سۇرىيىلىكلەر	叙利亚人
سۇرۋىۋالىزم	生存主义
سۇسالار	苏撒人
سۇسپېنزوئىد	悬胶体
سۇسۇلار	苏苏人
سۇغۇرتىلاتقۇچى	投保人
سۇغۇرتىلانغۇچى	被保险人
سۇكسىنامويل	氨羰丙酰
سۇكسىنامىد	琥珀酰胺
سۇكلات	苏克莱
سۇلتام	磺内酰胺
سۇلتون	磺内酯
سۇلفئارسېنىد	硫砷化物
سۇلفابېنزامىد	苯酰磺胺
سۇلفاتازا	硫酸酯酶
سۇلفاتلار	硫酸盐
سۇلفاتىئازول	磺胺噻唑
سۇلفادىئازىن	磺胺嘧啶
سۇلفامويل	氨磺酰
سۇلفامىد	硫酰胺
سۇلفامىل	胺磺酰基
سۇلفانىلىل	磺胺酰
سۇلفاپىرازىن	磺胺吡嗪
سۇلفاپىرىدىن	磺胺吡啶
سۇلفاگۇئانىدىن	磺胺胍
سۇلفوبروموفتالېئىن	磺溴酞钠
سۇلفوبورىت	硼镁矾
سۇلفوبىسمۇتىت	硫泡铋矿
سۇلفوخلورىنات	氯磺化
سۇلفوستىبىد	硫锑化物
سۇلفوسېلېنىد	硫硒化物
سۇلفولاشتۇرماق	磺酸化
سۇلفولان	环砜烷
سۇلفوناتور	磺化器
سۇلفونامىد	磺酰胺
سۇلفوگالىت	氟盐矾
سۇلفىتلىشىش	亚硫酸化
سۇلفىدىلار	硫化物
سۇلفىمىد	硫酰亚胺
سۇلفىنىل	亚磺酰基
سۇلفگىدرىل	氢硫基
سۇلفېنىل	次磺酰基
سۇلكالار	苏尔卡人
سۇلپىئونال	二乙眠矾
سۇلۋانىت	硫钒铜矿
سۇمالار	苏玛人
سۇمباۋالىقلار	松巴哇人
سۇمدۇملار	森顿人
سۇمرالار	苏姆拉人
سۇمولار	苏摩人
سۇمېرلار	苏美尔人
سۇمېرولوگىيە	苏美尔学
سۇنبۇلە	室女宫
سۇندالىقلار	巽他人
سۇنماس	颠扑不破
سۇينەك	甲床炎
سۇيىقەستچى	阴谋者
سۇيۇقلاندۇرغۇچ	液化剂
سۇپرائورگانىزم	超生物体
سۇپرالاپسارىئان	前定论者
سۇپرالاپسارىئانىزم	前定论
سۇپېرئانتىگېن	超抗原
سۇپېرئىزولياتسىيە	超绝缘
سۇپېررېشاتكا	超晶格
سۇپېررېگېنېراتسىيە	超再生
سۇپېرسونىكا	超声学
سۇپېرسىركۇلياتسىيە	超环量
سۇپېرسىممېترىيە	超对称性
سۇپېرفېكۇنداتسىيە	超受精
سۇپېرماتىست	至上派者
سۇپېروكتاۋا	八度音栓
سۇپېرپلاستىكلىق	超塑性
سۇپېرگالاكتىكا	超星系团
سۇپېرگرادىئېنت	超梯度
سۇپېرگېلىكس	超螺线
سۈركىلىشچانلىق	可磨性
سۈركىگۈچ	涂抹器
سۈرۈشتۈرمە	质询案
سۈرۈشتۈرۈلگۈچى	质询对象
سۈزۈلدۈرۈش	透明化
سۈكەنچى	箕斗工
سۈگەن	入料斗
سۋابىت	砷灰石
سۋاتلار	斯瓦提人
سۋازىلار	斯瓦齐人
سۋىنبۇرن	斯温伯恩
سۋېدېنبورگىت	锑钠铍矿
سۋېپ	灭草灵
سېئاتللىقلار	西雅图人
سېئامانىت	磷硼锰石
سېئولىت	泡沸石
سېئىدلار	塞德人
سېبوللىت	纤维石
سېتان	鲸蜡烷
سېتاۋلون	塞他弗伦
سېتتېر	架车座
سېتسىدىئولوگىيە	瘿生物学
سېتوتولىت	鲸耳石
سېتىل	鲸蜡基
سېتىن	鲸蜡素
سېدار	金花树
سېدرول	雪松醇
سېدرېن	雪松烯
سېدوگېپتوزا	景天庚糖
سېرائۇنوگراف	雷电计
سېرات	铈酸盐
سېراتوزاۋر	角鼻龙
سېراتوفىل	角叶蚤
سېرارگىرىت	角银矿
سېرازىن	樱胶素
سېراماگىنىت	陶瓷磁体
سېرامىد	神经酰胺
سېراندىت	桃针钠石
سېربىيە	塞尔维亚
سېرتاتسىيە	粉管竞生
سېرداب	墓穴狭室
سېرراتۇلا	麻花头属
سېركچى	杂耍演员
سېروئىد	蜡样色素
سېروتونىن	血清素
سېروسسىت	白铅矿
سېرولوگىيە	血清学
سېرولىت	蜡蛇纹石
سېرىت	铈硅石
سېرىتسىت	绢云母
سېرىتسىتلاشتۇرۇش	绢云母化
سېرىگرافىيە	绢网印花
سېريۇز	碳酸铅白
سېرپىئېرىت	锌铜矾
سېرپېنتىن	蛇纹石
سېرپېنتىنلىشىش	蛇纹石化
سېرپېننتىن	蛇纹岩
سېرۇلىگنول	蓝木醇
سېرۇلىگنون	兰木醌
سېرۇلېئولاكتىت	钙绿松石
سېرۋىس	塞尔维斯
سېرېبرالىزم	大脑主义
سېرېبروزىد	脑苷脂
سېرېرا	谷神星
سېرېرلار	塞雷尔人
سېرېزىن	纯地蜡
سېرېلوزا	西瑞糖
سېزارولىت	泡铅锰矿
سېزامول	芝麻酚
سېزامىن	芝麻明
سېزشچانلىق	感受性
سېغىنغاق	相思鸟
سېغىنچېچەك	点地梅
سېفائېلىن	吐根酚碱
سېفارانتىن	千金藤素
سېفالوسپورىن	先锋霉素
سېفالومېتر	头测量仪
سېفالىن	簇虫头体
سېفېئىد	造父变星
سېكبۇمېتون	密草通
سېكرېتارىيات	书记团
سېكرېتارىيە	促分泌素
سېكسولوگىست	性学家
سېكسىزم	性别主义
سېكسۇئالىزم	性欲主义
سېككوتىن	赛柯汀
سېكۇئانىلار	西夸尼人
سېكۇليارىزم	现世主义
سېلاخىن	鲨白化素
سېلادونىت	绿磷石
سېللائىت	氟镁石
سېللوئىدىن	胶棉屑
سېللوبىئوزا	纤维二糖
سېللودېكسترىن	纤维糊精
سېلليۇلازا	纤维素酶
سېلليۇلوئىد	假象牙
سېلليۇلوزا	纤维素
سېلليۇلوزان	纤维聚糖
سېللۇلوئىد	赛璐珞
سېللۇلىت	赛路里斯
سېلوبلاستۇلا	有腔囊胚
سېلوستات	定天镜
سېلىشتۇرغۇچ	比较器
سېلۇروزاۋر	虚骨龙
سېلېبرانت	主礼神父
سېلېستىت	天青石
سېلېكتورالىزم	选票主义
سېلېكسىئونىزم	选择学说
سېلېنوبىسمۇتىت	硒铋化物
سېلېنوسېمىكاربازىد	氨基硒脲
سېلېنوفېنول	苯硒酚
سېلېنوكسىد	硒亚砜
سېلېنولوگ	月球学家
سېلېنولوگىيە	月球学
سېلېنىدلار	硒化物
سېمىئوپال	半蛋白石
سېمىتلار	闪米特人
سېمىتلىشىش	闪米特化
سېمىتىكا	闪米特学
سېمىكاربازون	缩氨基脲
سېمىكاربازىد	氨基脲
سېمىكۋىئېتىزم	半寂静教
سېمپېرۋىرىن	长生草碱
سېنات	元老院
سېنارمونتىت	方锑矿
سېناكل	静修所
سېنتراللازىت	白钙沸石
سېنترالىت	中定剂
سېنترالىزېر	中心化子
سېنترالىست	集权论者
سېنتروزوما	中心体
سېنتروكلىنال	向心倾斜
سېنترىفۇگ	离心机
سېنتىمېنتاللىق	感伤情调
سېنتېللا	积雪草
سېنسىبىلىزاتور	敏化剂
سېنسىتومېتىرىيە	感光学
سېنسۇئالىزم	官能主义
سېنوزوئولوگىيە	新动物学
سېنوزىت	钙钇饵矿
سېنېتسىئونىن	千里碱
سېنېتسىفولىدىن	千里叶定
سېنېتسىفولىن	千里叶碱
سېنېتسىفولىنىن	千里叶宁
سېنېتسىن	千里因
سېنېگىن	远志精
سېيسمولوگىيە	地震学
سېيلومېتىر	云幂仪
سېپاراتىزم	分离主义
سېپتۇپلېت	七连音
سېپتېت	七重奏
سېۋادىن	瑟瓦定
سەبدەگۈل	万寿菊
سەبى	天真烂慢
سەرخىللاشتۇرۇش	最佳化
سەزگۈرلەشتۈرمەك	增敏化
سەزگۈلۈك	知觉性
سەللە	缠头布
سەمىتئۆرۈك	塞买提杏
سەمىمىيەتلىك	开城布公
سەنئەتچى	艺术家
سەنسەن	小羊皮属
سەيلىچى	徘徊者
سەيىد	赛义德
سەييارىسىمان	行星式地
سەپسەتىچىلىك	空谈主义
سەۋرسىزلىك	不耐烦
سەۋرەن	风船葛
سەۋەبىيات	因果性
سەۋەبچى	导火线
شائىرېرىت	硫卤钠石
شاتتۇككىت	斜硅铜矿
شاتلانكا	方格布
شاخشاق	水性杨花
شاخلىماسلىق	不分枝
شادوۋگرافىست	影像师
شادوۋگرافىيە	影像术
شادىمانلار	狂欢者
شارتتىدە	一股作气
شاررالار	沙拉人
شارپىت	水碳铀矿
شارۋار	灯笼裤
شاستالار	沙斯塔人
شاسسى	起落架
شافارزىكىت	红锑铁矿
شاققاقلىق	油腔滑调
شاكتا	拜力派信
شاكتىزم	拜力派
شاكېر	震教徒
شالاڭلىق	稀疏性
شالداما	围嘴儿
شالدىراق	猪鼻花
شاللېرىت	砷硅锰矿
شالۋاق	哈喇子
شالۋاقلىق	多涎反酸
شامالدۈرغۇچ	鼓风机
شامالدەك	一溜烟
شامانىزم	萨满教
شاندىت	硫铅镍矿
شايىپەتتا	菜汤泡馕
شاپ	眼子菜
شاڭخەيلىكلەر	上海人
شاگىيەلەر	沙吉亚人
شاۋانتلار	萨万提人
شتيۇۋېگرامما	施蒂威图
شرادان	八甲磷
شروكىنگېرىت	板菱铀矿
شرېدىنگېر	薛定谔
شكالوگرامما	量表程序
شلىئېرېن	异离体
شنېيدېر	施奈德
شوتلار	苏格人
شوتلاندىيىلىكلەر	苏格兰人
شورل	黑电气石
شورلومىت	钛榴石
شورىغۇچى	刺吸式
شورىگۈل	半支莲
شوشاڭ	羊毛剪
شونفېلسىت	苦橄斑岩
شونكىنىت	等色岩
شويلا	肉粘饭
شويىنگۈل	山字草
شوگائول	生姜醇
شوۋىنىزم	沙文主义
شىئوتلار	希俄斯人
شىباھ	七日丧期
شىتارى	画眉草
شىجائەتسىز	软骨头
شىجرىم	大蒜芥
شىددەت	翻江倒海
شىرمەننان	西尔馒馕
شىزوتسېل	裂体腔
شىزومىتسېت	裂殖菌纲
شىفىرشۇناسلىق	密码学
شىفىرچى	密码员
شىكالىلاش	衡准分割
شىكساماناس	式叉摩那
شىللۇكلار	希鲁克人
شىلولۇقلار	希罗人
شىلىت	白钨矿
شىلىمشىقلىق	粘液性
شىماللىشىش	北方化
شىنگون	真言宗
شىنۋارىلار	欣瓦里人
شيامېنلىقلار	厦门人
شپىنېل	尖晶石
شۆھرەتلىك	炳炳麟麟
شۇمتال	水曲柳
شۇناملار	舒纳姆人
شۇنگىت	次石墨
شۇڭقارلار	其它鹰类
شۇۋالار	舒瓦人
شۈبھىچىلىك	怀疑论
شۋارتزېمبېرگىت	氯碘铅矿
شۋېيتسارىيىلىك	瑞士人
شېتلاندلىقلار	设得兰人
شېخېمىتلار	谢克米人
شېرانىلار	舍拉尼人
شېرىدانىت	透绿泥石
شېكلېرلار	塞克勒人
شېكەرشۈن	西坎儿旬
شېللاك	紫草茸
شېنزىلار	僧祗人
شەتلەنكە	格子布
شەرقشۇناسلىق	东方学
شەرقلەشتۈرمەك	东方化
شەرەپخانا	荣誉室
شەكلەنلەشتۈرمەك	假象化
شەنخەيگۇەن	山海关
شەيتاندەك	撒旦般地
شەپشەكلىك	卖弄风骚
شەھەرشۇناسلىق	城市科学
شەھەرلەشمەك	城市化
غارغالتا	小泊船所
غازتاپان	翻白草
غاشا	猪秧秧
غايمۇق	摆魔鸟
غوتۇلدىماق	大发牢骚
غورخار	印度野驴
غولدۇرلىماق	咕咕响
غىرقىرىماق	汩汩作响
غىچىڭلىماق	吱吱咯咯
غۇبارسىز	一尘不染
غۇنان	二岁驹
غۇيۇلداپ	风驰电掣
غەربلىكلەر	西方人
غەزۋە	鼠曲草
غەزەلخان	游荡歌手
غەمسىزلىك	无所用心
غەيرىيلىك	奇异性
غەيۇرلۇق	大刀阔斧
فائىرخىلدىت	碳钾钙石
فائۇنىست	区系学家
فائۇۋىزم	野兽派
فابرى	法布里
فابىئانىزم	费边主义
فاخلۇنىت	褐堇青石
فارادى	法拉第
فارامېتىر	发拉计
فاررىنگتونىت	磷镁石
فارماكودىنامىكا	药效学
فارماكوزىدېرىت	毒铁矿
فارماكولوگ	药理学家
فارماكولوگىيە	药理学
فارماكوپېدىكا	药剂学
فارماكوپېدىيە	制药学
فارماكوگنوزىيە	生药学
فارنېزول	法尼醇
فارىسايلار	法利赛人
فارىنگولوگىيە	咽科学
فازوترون	相加速器
فاسسائىت	深绿辉石
فاسسىئاتسىيە	绷带化
فاشىست	法西斯
فاللوئىدىن	鬼笔碱
فالىسسىلار	法利西人
فالىلار	法利人
فامفۇر	氨黄磷
فانتىلار	芳蒂人
فانگلومېرات	扇积砾
فانېروزوئىك	显生宙
فانېرىت	显晶岩
فايالىت	铁橄榄石
فايرفيېلدىت	鳞钙锰石
فاگوتسىت	吞噬细胞
فاگوزوما	吞噬小体
فاۋجازىت	八面沸石
فتالالدېگىد	苯二醛
فتالونىترىل	邻二腈
فتوراپاتىت	氟磷灰石
فتوروئالكان	氟化烷
فتوروئۇراتسىل	氟脲嘧定
فتوروئېتېن	氟乙烯
فتوروبورىت	氟硼镁石
فتوروسىلىكات	氟硅酸盐
فتورىدلار	氟化物
فتىسىئولوگىيە	结核病学
فرائۇنگوفېر	夫琅和费
فرازېئولوگىيە	文体措辞
فراك	大礼服
فراكسىن	梣皮苷
فراكسېتىن	梣皮亭
فرانس	弗兰茨
فرانسۇزلاشتۇرۇش	法国化
فرانكلار	法兰克人
فرانكلىن	副兰克林
فراگموبازىدىيە	多隔担子
فراگموسپورا	多隔孢子
فروندېلىت	锰绿铁矿
فرىئۇلىلىقلار	弗留利人
فرىئېدېلىن	无羁萜
فرىتىللارىيە	波折百合
فرىززېن	触发杆
فرىزېمېتر	凝固计
فرىسلار	弗里西人
فرىگورىمېتىر	冰冻仪
فرۇكتوزان	果聚糖
فرۇكتوزىد	果糖苷
فرۇكتولىز	果糖分解
فرېئون	氟利昂
فرېنتونلار	弗伦顿人
فرېنوزىن	羟脑苷脂
فرېنولوگىيە	颅相学
فرېيبېرگىت	银黝铜矿
فلاكوئۇرتىيە	刺篱木
فلاننېل	棉法兰绒
فلانېل	法兰绒
فلاگېللات	鞭毛虫
فلاۋانون	黄烷酮
فلاۋونول	黄酮醇
فلاۋوپروتېئىن	黄素蛋白
فلاۋوپۇرپۇرىن	黄红素
فلوئېما	韧皮部
فلوباتاننىن	红粉丹宁
فلوروبېنزوفېنون	苯根皮酚
فلوروگلۇتسىنول	根皮酚
فلورىدا	佛罗里达
فلورىزىن	根皮苷
فلورېتىن	根皮素
فلورېنسا	佛罗伦萨
فلورېنسىت	磷铝铈矿
فلوكسۇرىدىن	氟尿核苷
فلولىمات	氧化乐果
فلوگوپىت	金云母
فلىنكىت	褐伸锰矿
فلۇئوروخروما	荧色物
فلۇئوروفورا	荧光团
فلۇئومېتۇرون	伏草隆
فلۇئېللىت	氟铝石
فلۇرومېتر	量粉计
فلېئومىتسىن	腐草霉素
فلېبولوگىيە	静脉学
فلېبولىت	静脉石
فلېكسومېتر	柔曲计
فلېكسىباكتېرىيە	屈挠细菌
فلېمىنگلار	佛兰芒人
فلېگما	冷凝液
فنسىئولا	姜片虫
فوئېنىكوخروئىت	红铬铅矿
فوبوتاكسىس	趋避性
فوتامېرا	照相机
فوتسىس	佛西斯
فوتوئاكتىۋاتسىيە	光活化
فوتوئاللېرگىيە	光变性
فوتوئىئونىزاتسىيە	光致电离
فوتوئىزومېر	光异构物
فوتوئىندۇكسىيە	光诱导
فوتوئېلېكترونىكا	光电子学
فوتوئېلېكترېت	光驻极体
فوتوبوتانىكا	光植物学
فوتوبىئولوگىيە	光生物学
فوتوبىئوگرافىيە	相片传记
فوتوتروف	光养型
فوتوتوك	光电流
فوتوتېلېفون	传真电话
فوتوتېلېگرافىيە	光遥记术
فوتودىسسوتسىئاتسىيە	光致离解
فوتورېئاكتىۋاتسىيە	光复活
فوتورېئاكسىيە	光反应
فوتوسكوپ	透视镜
فوتوسىستېما	光合体系
فوتوفورېز	光致漂移
فوتوفوسفورېسسېنسىيە	光致磷光
فوتوكاتالىزاتور	光催化剂
فوتوكىنېتىك	光动性
فوتوكۋانت	光量子
فوتوماسكا	光掩模
فوتوموزايكا	相片镶嵌
فوتومونتاژ	综合照片
فوتومىكروگرافىيە	显微摄影
فوتومېتر	光度计
فوتونابور	照相排字
فوتونپەرەسلىك	倾光性
فوتوپتومېتر	光觉计
فوتوپوليارىمېتر	光偏振计
فوتوپىگمېنت	光色素
فوتوچى	摄影员
فوتوگرافېر	照相师
فورامىنفېرا	有孔虫
فوربېس	辐布斯
فوردلاشتۇرۇش	福特化
فوردچە	福特式
فورستېرىت	镁橄榄石
فورماتلاش	格式化
فورماللىشىش	形式化
فورمالىزم	形式主义
فورمامىد	甲酰胺
فورموللاشماق	甲醛化
فورمىل	甲酰基
فورمىللاشماق	甲酰基化
فوروزۇئىد	无性个员
فورومېتىر	隐斜视计
فورون	佛尔酮
فورېسپورا	前孢子
فوزازېتىم	毒鼠磷
فوسسا	马岛狸
فوسفاتلاشتۇرۇش	磷酸化
فوسفاتىدىل	磷脂酰
فوسفاگېن	磷肌酸
فوسفوئامىنولىپىد	磷氨基脂
فوسفوئۇرانىلىت	磷铀矿
فوسفورروئېسلېرىت	重磷镁石
فوسفوروسكوپ	磷光镜
فوسفوروگراف	磷光像
فوسفورىل	磷酰基
فوسفورىلازا	磷酸解酶
فوسفورېسسېنسىيىلىك	磷光性
فوسفوسىلىكات	磷硅酸盐
فوسفوفىللىت	磷叶石
فوسفوفېررىت	铁磷锰矿
فوسفوكرېئاتىن	磷酸肌酸
فوسفوكىنازا	磷酸激酶
فوسفومولىبدات	磷钼酸盐
فوسفونىترىل	磷氮基
فوسفوپروتېئىن	磷蛋白
فوسفىت	亚磷酸盐
فوسفىد	磷化物
فوسفىنىل	苯膦基
فوسگېنىت	角铅矿
فوسېيە	福塞亚
فوكستروت	狐舞曲
فولكلورىست	民俗学者
فولىگراف	测谎器
فولپېت	灭菌丹
فومالگائۇت	北落师门
فونتانا	冯特纳
فونوخىمىيە	声化学
فونوسكوپ	验声器
فونولوگ	音位学家
فونومېتر	声强计
فونوگراف	电唱机
فونوگرافىيە	表音拼字
فونېمىتسىست	音素学家
فونېمىكا	音素学
فىبروئىن	丝心蛋白
فىبروزىت	纤维织炎
فىبروسكوپ	纤维镜
فىبروفېررىت	纤铁矾
فىبروما	纤维瘤
فىبروميوزىت	纤维肌炎
فىبروميوما	纤维肌瘤
فىبرىللاتسىيە	纤维断裂
فىتازا	植酸酶
فىتزگېرالد	斐兹杰惹
فىتسىن	无花果素
فىتوتوكسىن	毒植物素
فىتوخروما	植物色素
فىتوستېرول	植物甾醇
فىتولىت	植物岩
فىتومورف	植物形态
فىتومېتر	植物计
فىتوپتىد	植羽瘿螨
فىتوگراف	植物图解
فىتىن	植酸钙镁
فىتېرال	植物质
فىزوفورا	胞水母
فىزىكوتېئولوگىيە	自然神学
فىزېتىن	非瑟酮
فىزېلىئىت	锑铅银矿
فىسچېرىت	柱磷铝石
فىكام	噁虫威
فىكوئېرىتروبىلىن	藻红素
فىكوئېرىترىن	藻红蛋白
فىللوتسېراسلار	叶菊石类
فىللوكالىن	成叶素
فىللوما	叶原体
فىللوپورفىرىن	叶卟啉
فىللوپىررول	叶呲咯
فىللوۋىت	锰磷矿
فىللىت	千枚岩
فىلموگرافىيە	电影名录
فىلوئورومېتىر	荧光计
فىلودېندرون	喜林芋
فىلولوگ	语文学家
فىلولوگىيە	语文学
فىلونىئۇم	菲洛宁
فىلونىزم	菲洛主义
فىلىستىنىزم	实利主义
فىلىپلاشتۇرۇش	腓力普化
فىلىپلىقلار	腓力比人
فىلىپپىنلاشتۇرۇش	菲律宾化
فىلىپپىنلىقلار	菲律宾人
فىلېتىزم	宗族论
فىماتورىزىن	肿瘤色素
فىنلار	芬兰人
فىنلاندلاشتۇرۇش	芬兰化
فىنىكىيىلىكلەر	腓尼基人
فيېدلېرىت	水氯铅矿
فۇجيەنلىكلەر	福建人
فۇجەيرەھ	富查伊拉
فۇرادانتىن	呋喃丹啶
فۇرازولىدون	痢特灵
فۇرانوزا	呋喃糖
فۇراژكا	瓜皮帽
فۇرلار	富尔人
فۇرونگىت	蓉铀矿
فۇرىل	呋喃基
فۇريې	傅里叶
فۇكوئىدىن	岩藻多糖
فۇكوزا	岩藻糖
فۇكوزان	岩藻聚糖
فۇكوستېرول	岩藻甾醇
فۇكوكسانتىن	岩藻黄质
فۇلانىلار	富拉尼人
فۇلگۇرىت	闪电熔岩
فۇمارازا	富马酸酶
فۇمارىن	克灭鼠
فۇماگىللىن	烟曲霉素
فۇمىگاتسىن	烟曲霉酸
فۇمىگاتور	烟薰器
فۇندامېنتالىزم	基要主义
فېئودالىزم	封建主义
فېئوسپورا	叶褐孢子
فېبرىفۇگىن	黄常碱
فېتىشىزم	拜物教
فېدېرالىزم	联邦主义
فېربېرىت	钨铁矿
فېرتىلىزىن	受精素
فېرروئاكتىنولىت	铁阳起石
فېرروئامفىبول	低铁闪石
فېرروئاۋگىت	富铁辉石
فېرروئېلېكترىك	铁电体
فېرروباتسېللۇس	铁杆菌
فېرروتايپ	铁版照相
فېرروترېمولىت	铁透闪石
فېرروزىلىت	铁辉石
فېررولىز	铁解作用
فېرروماگىنىت	铁磁体
فېررىئېرىت	镁碱沸石
فېررىتىن	铁蛋白
فېررىتۇنگستىت	铁钨华
فېررىخروم	铁色素
فېررىسىكلېرىت	铁磷锂矿
فېررىمولىبدىت	水钼铁矿
فېررىمىتسىن	高铁霉素
فېررىناترىت	针钠铁矾
فېررىگىدرىت	水铁矿
فېررۇكسىت	氟硼钠石
فېرسمىت	铌钙矿
فېرمورىت	锶磷灰石
فېرناندىنىت	纤钡钙石
فېرومون	信息素
فېرگانىت	水钒铀矿
فېرۋانىت	水钒铁矿
فېرۋېنۇلىن	热诚菌素
فېرېنتازىن	弗兰特新
فېكدا	北斗三
فېلسوبانيائىت	斜方矾石
فېلسوفىر	霏细斑岩
فېللاندرال	水茴香醛
فېليەتون	小品文
فېلۇپلار	费卢普人
فېمىترون	场射管
فېناتسىتىن	非那西丁
فېنازافلور	抗螨唑
فېنازوتسىن	非那佐新
فېنازون	非那宗
فېناكائىن	芬那卡因
فېناكىت	硅铍石
فېنانترولىن	菲绕啉
فېنانترىدون	菲啶酮
فېنتايل	芬太尼
فېنترىئازوفوس	三唑磷
فېنترىئازىن	苯并三嗪
فېنتولامىن	酚妥拉明
فېنتىئازون	叶噻灵
فېنتىئون	倍硫磷
فېنسون	除螨酯
فېنسىكلىدىن	苯环哌啶
فېنسۇلفوتىئون	丰索磷
فېنفورمىن	苯乙双胍
فېنكاپتون	芬硫磷
فېنمېترازىن	苯甲噁嗪
فېنوباربىتال	苯巴比妥
فېنوباربىتون	苯巴比通
فېنوخىنون	苯酚合醌
فېنوسافرانىن	酚藏红花
فېنوفازا	物候期
فېنوفېنانترازىن	苯并菲嗪
فېنوكسى	苯氧基
فېنوكول	非诺可
فېنوكوپىيە	拟表型
فېنولوگىست	物候学家
فېنومېنولوگىست	现象学家
فېنونافتازىن	苯并吩嗪
فېنىئانلار	芬尼亚人
فېنىدون	菲尼酮
فېنىلتىن	苯锡基
فېنىللاشتۇرۇش	苯基化
فېنگىت	月光石
فېنۇرون	非草隆
فېنېتول	苯乙醚
فېنېتىكا	表型学
فېنېتىل	苯乙基
فېنېتىلامىن	笨乙胺
فېنېلزىن	苯乙肼
فەقىر	法吉尔
قاتگۈل	重瓣花
قارائىتلار	卡拉教徒
قاراتمىلىق	针对性
قارارنامە	决定书
قاراچىۋىن	干酪蝇
قارسىلداق	马鞭鸟
قارىتۈرۈك	土包子
قارىغايزارلىق	松树园
قارىغايسىمانلار	拟松类
قارىغۇلۇق	盲目性
قارىغۇچى	护理人员
قارىقاش	哈拉哈西
قارىلانماق	背黑锅
قازغۇچى	挖掘工
قاسساپلىق	屠宰业
قاسىرماق	嘎渣儿
قاشقايلار	卡什盖人
قاغىتۇمشۇق	门鼻儿
قالدۇرما	留置物
قالدۇرمىچىلىق	取消主义
قالدۇرۇۋالغۇچى	留置权人
قالدۇقسىز	一干二净
قالقالار	喀尔喀人
قالقانچە	小盾片
قامقاق	广布苋
قامچىلىغۇچى	鞭笞者
قانائەتچانلىق	随遇而安
قاناتلىقلىق	有翼性
قانالسىز	无通道
قاناللاشتۇرۇش	信道化
قايتىشچانلىق	可逆性
قايتىلانمىلىق	递归性
قايتۇرشچانلىق	反射率
قايمۇقماق	受蒙蔽
قاپاقئوت	蝇子草
قاپتال	马鞍侧帮
قاپىيىشۇناس	韵律家
قاچىلىغۇچ	装入器
قوبۇز	犹太齿琴
قوبۇلخانا	谒见室
قوبۇللىغۇچى	接收机
قوتانتۇمشۇق	太阳花
قورالسىزلاندۇرۇش	解除武装
قورقۇتۇۋەتمەك	吓着了
قورچاققول	手掌参
قوزغاتقۇچلۇق	带继电器
قوزغىتىشچانلىق	激发性
قوزۇقچى	标桩工
قوشئاتار	双筒枪
قوشۇلۇشچانلىق	加合性
قوناقلار	高粱类
قويمىچىلىق	商业欺诈
قويچىلىق	养羊业
قويۇقلاشتۇرغۇچ	增稠器
قويۇلدۇرغۇچ	浓缩器
قويۇۋەتكۈچى	排放者
قويۇۋەتمەسلىك	不放过
قىرائەتخان	书呆子
قىرغىز	吉尔吉斯
قىرچىلمىلىق	回缩性
قىزغاندۇرماق	招人物议
قىزغانچۇق	吃独食
قىزىتقۇچ	过热器
قىزىلكۆز	獐头鼠目
قىزىللار	红队队员
قىزىلمارال	红景天
قىزىماسلىق	不像样
قىسقىرىشچانلىق	收缩性
قىسلىشچانلىق	可压缩性
قىسىش	螯淋作用
قىلتاش	毛发水晶
قىلىقسىزلىق	恶作剧
قىممەتداش	等价物
قىممەتشۇناسلىق	价值学
قىچىشىش	搔痒感
قۇببىلىك	圆顶类
قۇتب	丘德卜
قۇترىتىلغۇچ	被策动者
قۇتقۇزغۇچى	拯救者
قۇتۇلغۇسىز	在所难免
قۇددۇسگۈل	朱顶红
قۇرتئوت	冬虫夏草
قۇرتلىماق	蝇蛆叮扰
قۇرغۇر	活见鬼
قۇرغۇيچىلار	鹰派人物
قۇرۇلمىلىقى	结构性
قۇرۇلمىچىلىق	结构派
قۇرەيشلەر	古莱西人
قۇسقۇچى	呕吐者
قۇسۇق	呕吐物
قۇشبەرگى	瓶尔小草
قۇشچىلىق	养禽业
قۇلاقكەستىلەر	狐群狗党
قۇلچىلىق	奴才主义
قۇلۇلىشۇناس	贝类学家
قۇلۇنجى	肠绞痛
قۇلۇپلانمىغان	非锁定
قۇلۇپلىغۇچ	闭锁器
قۇيرۇقلۇقلار	有尾类
قېتىشچانلىق	凝固性
قېرىشماق	作作对
قېرىمايدىغان	非老化
قېرىنتال	芜爆散丹
قېرىنداشلاردەك	情同手足
قېلىپبازلىق	公式化
قېلىپلاشتۇرۇش	规范化
قېلىپلاشماق	成个儿
قېيدىماق	闹意气
قەتەبەلەر	卡塔巴人
قەدىمچە	古色古香
قەسەمخور	发誓者
قەيسەرلەر	强硬派
قەۋس	人马宫
كائودائىزم	高台数
كائىنوزىت	钙钇铈矿
كائىنىت	钾盐镁矾
كائۇستىك	苛性剂
كائۇلوفىللىن	葳严仙碱
كائۇلوكالىن	促成茎素
كابالېتتا	卡巴列达
كابىللار	喀拜尔人
كابۇللۇقلار	喀布尔人
كابېلگرامما	海底电报
كاتابولىزم	分解代谢
كاتابىئوز	细胞衰变
كاتارىنىت	镍铁陨星
كاتافىل	芽苞叶
كاتاك	卡塔克
كاتاكالى	卡塔卡利
كاتاپلېتىت	钠锆石
كاتتيېرىت	方硫钴矿
كاترى	卡特利
كاتلېت	卡德力特
كاتوفورىت	红钠闪石
كاتولىكوس	总主教
كاتومىتسىن	卡卓霉素
كاتىئون	阳离子
كاتىباتشۇناسلىق	秘书学
كاتېتومېتر	高差计
كاتېخولامىن	儿茶酚胺
كاتېخىن	儿茶素
كاتېنارىن	悬链素
كاتېگورىيىلەشمەك	范畴化
كاخنىت	砷硼钙石
كادارىيە	卡达里亚
كادالېن	卡达烯
كادىنېن	杜松萜烯
كادۋالادېرىت	氯羟铝石
كادەرلەر	卡迪尔人
كارابىن	卡宾枪
كاراكولىت	氯铅芒硝
كاربارسون	卡巴胂
كاربامونىترىل	氨基化氰
كاربوبورىت	水碳硼石
كاربودىگىدرازىد	碳二酰肼
كاربوران	碳硼烷
كاربوسترىل	喹诺酮
كاربوسيانىن	羰化青
كاربوفۇران	虫螨威
كاربوفېنوتىئون	三硫磷
كاربوكسىلازا	羧基酶
كاربوكسىللىشىش	羧基化
كاربوكسىن	萎锈灵
كاربومىتسىن	碳霉素
كاربومېتوكسىل	甲酯基
كاربونات	碳酸盐
كاربوناتور	碳酸化器
كاربونىت	天然焦炭
كاربوگىدرازىد	卡巴肼
كاربىتول	卡必醇
كاربىل	二价碳基
كاربيوراتور	化油器
كاربۇتىلات	卡灵草
كاربۇران	铀铅沥青
كاربېتوكسىل	乙酯基
كاربېتوكسىللىشىىش	乙酯基化
كارتامىن	红花素
كارتوبىبلىئوگرافىيە	地图目录
كارتېرچى	赛艇成员
كارخانىچى	企业家
كاردانول	豆蔻醇
كاردىئولىپىن	心磷脂
كاردىئومېتر	心力计
كارروللىت	硫铜钴矿
كارستسىمانلىق	类喀斯特
كارستلىشىش	喀斯特化
كارفولىت	纤锰柱石
كارلىستلار	卡洛斯派
كارمىنىت	砷铅铁矿
كارناللىت	光卤石
كارنىتىن	肉毒碱
كارنىز	门窗帘盒
كارنېگىئېئىت	三斜霞石
كاروتېن	胡萝卜素
كاروتېنول	胡萝卜醇
كارولىنلىقلار	卡罗林人
كارىئولوگىيە	细胞核学
كارىئومون	利它素
كارىز	坎儿井
كارىنات	突胸鸟
كاريوسىستېماتىكا	核分类学
كاريوفىللېن	石竹烯
كاريولىز	核溶解
كاريوگامىيە	核配合
كارپو	海果纲
كارپوفورا	子实体
كارپوكسېنىيە	心皮直感
كارپولار	海果类
كارپىترون	卡皮管
كارۋاكرول	香芹酚
كارۋاكرىل	香芹基
كارۋون	香芹酮
كارۋېن	香芹烯
كارېنلار	克伦人
كازاكلار	哥萨克
كازولىت	硅铅铀矿
كازېئىدىن	酪蛋白素
كازېئىن	酪蛋白
كاسسىتلار	卡塞特人
كاسكارون	彩纸蛋壳
كاسىلار	卡西人
كاسىنىچى	承揽人
كاسۇئارىنا	木麻黄
كاسۋېللىت	锰脆云母
كاشان	重釉陶瓷
كاشىلىسىز	无故障
كاشۇبلار	卡舒布人
كاففالىقلار	卡法人
كاففىرلار	卡菲尔人
كاففېتاننىن	咖啡丹宁
كافېدرا	教研室
كاككۇكگۈلى	杜鹃花
كاكوتېلىن	卡可西灵
كاكوكسېنىت	黄磷铁矿
كالاش	布帮套鞋
كالام	卡拉姆
كالاڭپاي	举止鲁莽
كالاۋىنكا	迦陵频伽
كالتسىئوفېررىت	钙磷铁矿
كالتسىتونىن	降血钙素
كالتسىتىت	方解岩
كالتسىكوزىيە	灰石肺
كالتسىلۇتىت	灰泥岩
كالتسىيلىشىش	钙积作用
كالتىسىيسىزلىنىش	脱钙作用
كالسا	卡尔沙
كالستسىت	方解石
كالسىلىت	六钾霞石
كالسېكۋېسترىن	隐钙素
كالكوۋسكىت	铈钛铁矿
كاللىگرافىيە	素描线条
كاللىگرامما	象形诗
كالماگىت	钙镁示
كالورىست	热质论者
كالورىمېتر	量热器
كالورىمېترىيە	量热术
كالوكسىلون	美术属
كالىئوفىلىت	钾霞石
كالىبورىت	硼钾镁石
كالىبېر	机件型号
كالىتسىنىت	重碳钾石
كالىفورنىت	玉符山石
كالىقۇلاق	毛蕊花
كالىكانتىن	腊梅碱
كالىنىت	纤钾明矾
كالپۇللى	卡尔普里
كالۋار	卡尔瓦尔
كالۋانومېتىر	电流计
كالۋىسىلىندېر	玻璃柱琴
كالېدونىت	铅蓝矾
كالېندارچى	历算家
كالېيدوسكوپ	万花筒
كامادخاتۇ	迦摩驮都
كامارۇپا	迦摩天
كامازىنلار	卡美辛人
كامبالار	坎巴人
كامبوھ	卡姆博
كامبىست	汇兑通
كامبىسترىيە	汇兑学
كامفورون	樟脑酮
كامفورىل	樟脑基
كامفورېن	樟脑烯
كامفولىد	龙脑白
كاملېت	驼毛呢
كاممېرېرىت	铬绿泥石
كامىسارد	卡米扎尔
كامپتوتېتسىن	喜树碱
كامپتونىت	斜闪煌石
كامپىلىت	磷砷铅矿
كامچاتكىلىقلار	堪察加人
كامۇكلار	喀穆克人
كانادالىقلار	加拿大人
كانارا	挂肉棒
كانالىن	刀豆酸
كانامىتسىن	卡那霉素
كانايچىلار	吹奏乐队
كانايچە	支气管
كاناۋانىن	刀豆氮酸
كانتارىدىن	斑蝥素
كانتراكس	康特克斯
كانتىئانىزم	康德主义
كاندىلار	康提人
كانسالار	坎萨人
كانسېرىزم	癌体质
كانكرىنىت	钙霞石
كاننابىدىئول	大麻二醇
كاننابىن	大麻苷
كاننابىنول	大麻醇
كانناگۈل	美人蕉
كانونىكلىق	正则性
كانۇرىلار	卡努利人
كانېشىتلىقلار	卡尼希人
كاياك	美帆布艇
كاپالا	劫波杯
كاپتان	克菌丹
كاپروئامىد	己酰胺
كاپرولاكتام	己内酰胺
كاپرىلامىد	辛酰胺
كاپرىلىل	辛酰基
كاپزائىتسىن	辣椒素
كاپزانتىن	辣椒红
كاپسۇمىن	胶囊素
كاپومېتىر	热辐射计
كاپىتاللاشتۇرۇش	资本化
كاپىتالىست	资本家
كاپۇخىن	卡普辛
كاۋاتىنا	卡伐蒂那
كاۋاسكوپ	窥腔镜
كاۋالېرىزم	骑士作风
كاۋاپخانا	烤肉店
كاۋكازلىقلار	高加索人
كاۋېندىش	卡文迪许
كرائۇزىت	钾铁矾
كراب	起重绞车
كراتوفىر	角斑岩
كراتون	克拉通
كرادىنا	克拉地酶
كرانىئوتومىيە	穿颅术
كرانىئولوگىيە	颅骨学
كروتسىدولىت	青石棉
كروتسىن	藏花素
كروتسېئىن	藏花精
كروتون	变叶木
كروتونالدېگىد	巴豆醛
كروتىل	巴豆基
كروسسىت	铝铁闪石
كرونستېدتىت	绿锥石
كرونكىت	柱钠铜矾
كروپ	克拉蒲
كروۋن	王冠纸
كرىئوترون	低温管
كرىئوخىرۇرگىيە	低温外科
كرىئوخىمىيە	低温化学
كرىئوفىللىت	绿鳞云母
كرىئولوگىيە	冷圈学
كرىئولىتىئونىت	锂冰晶石
كرىئومېتر	低温计
كرىئوگېنىكا	低温学
كرىبېرگىت	羟磷铝矾
كرىستاللوگرافېر	晶体学家
كرىستوبالىت	方英石
كرىلو	挡泥板
كرىلىئۇم	克里林
كرىپتوزوئالار	隐居动物
كرىپتوزىت	潜隐体
كرىپتوقانال	容码信道
كرىپتوكسانتىن	隐黄质
كرىپتومېتر	遮盖力计
كرىپتومېدۇزا	隐水母
كرىپتومېرا	隐微粒
كرىپتومېلان	隐钾锰矿
كرىپتوپى	隐品碱
كرىپتوپىررول	隐吡咯
كرىپتوپېرتىت	隐纹长石
كريولىت	冰晶石
كريونىكا	人冷冻学
كرۇفومات	育畜磷
كرېئاتىنىن	肌酸酐
كرېئاتىنۇرىيە	肌酸尿症
كرېئولىت	条带碧玉
كرېدنېرىت	锰铜矿
كرېستمورېئىت	雪硅钙石
كرېماتسىئونىست	火葬论者
كرېمېرسىت	钾铵铁矿
كرېيسېر	巡洋舰
كلائۇستالىت	硒铅矿
كلادوتسېرالار	枝角类
كلادوگېنېز	系枝进化
كلادىستىكا	进化枝学
كلاركېئىت	水钠铀矿
كلاسسون	经典子
كلاسسىتسىزم	古典风格
كلامىدوسپورا	厚垣孢子
كلامپېر	钳位器
كلاپپېر	击板乐器
كلاۋا	棒状体
كلاۋاتسىن	棒曲霉素
كلاۋدېتىت	白砷石
كلاۋىخورد	击弦键琴
كلوكماننىت	六硒铜矿
كلىئاخىت	胶铝矿
كلىئونىد	穿贝海绵
كلىستوگامىيە	闭花受精
كلىفتونىت	方晶石墨
كلىمېنىد	海神石
كلىنتونىت	绿脆云母
كلىنوئامفىبول	单斜闪石
كلىنوخلور	斜绿泥石
كلىنوزوئىزىت	斜黝帘石
كلىنوستات	回转器
كلىنوفېرروزىلىت	斜铁辉石
كلىنوپتىلولىت	斜发沸石
كلىنوپىروكسېن	斜辉石
كلىنوگېدرىت	斜晶石
كلىنىت	硬礁岩
كلىنگلار	克林人
كلىۋلاندىت	叶钠长石
كلۇپېئىن	鲱精蛋白
كلېئومېدېس	克菜门德
كلېئىنىت	氯铵汞矿
كلېبېلسبېرگىت	基锑矾
كلېرودېندرون	海州常
كلېمما	接线柱
كنانتامىد	黄酰胺
كنانتوتوكسىن	黄原毒
كنانتوخروئىت	硫镉矿
كنانتودېرما	黄色皮肤
كنانتوزىيە	花黄素化
كنانتوفىل	叶黄素
كنانتوكسىلىن	花椒素
كنانتوكسىلېتىن	花椒亭
كنانتوكونىت	黄银矿
كنانتوماتوزىيە	黄瘤病
كنانتومىتسىن	链霉黄素
كنانتوپسىيە	黄视症
كنانتېئىن	胞液黄素
كنوررىيە	内模相
كنونوتلىت	硬硅钙石
كنىدوتسىل	刺丝囊突
كنىدوفورا	刺丝体
كنىدوپود	刺丝囊座
كنىلان	木聚糖
كنىلوترىيە	穿木属
كنىلوزىد	木糖苷
كنىلوستروما	根皮子座
كنىلوما	菌核荚
كنىلونىت	赛罗耐特
كنىلوپىيە	木瓣树属
كنىلىتول	木糖醇
كنىلىندېئىن	盘菌木素
كنىلىيە	木荚豆
كنىلۇلوزا	木酮糖
كنىلېن	二甲苯
كنىلېنول	二甲苯酚
كنېرولى	干热软土
كنېنات	氙酸盐
كنېنوتىم	磷钇矿
كنېنوفوبىيە	陌生恐怖
كنېنوفون	色诺芬
كنېنوفېنې	色诺芬尼
كنېنوكرىست	捕获晶
كنېنولىت	捕虏体
كنېنىلامىن	苯基胺
كنېنۇس	翘嘴鹬
كوئاگۇلازا	凝结酶
كوئاگۇلومېتر	凝度计
كوئاگېل	凝聚胶
كوئوردىناتور	协调人
كوئوردېناتوگراف	坐标仪
كوئۇرلوزا	考洛丝
كوئۇماتېترالىل	杀鼠迷
كوئۇمارون	苯并呋喃
كوئېخلىنىت	钼铋矿
كوئېرتسىمېتر	矫顽力计
كوئېزىت	柯石英
كوئېففىتسېنتى	辐射系数
كوئېلوماتلار	体腔动物
كوئېپانگېرلار	古邦人
كوبالتوكالتسىت	钴方解石
كوبالتومېنىت	硒钴矿
كوبالتىت	辉钴矿
كوتارنىن	可他宁
كوترانسدۇكسىيە	并发转导
كوتسىنېرىت	硫银铜矿
كوتوئىت	镁硼石
كوتوئىن	柯桃因
كوتىلېدون	子叶属
كوتۇننىت	氯铅矿
كوخاب	北极二
كوخروماتوگراف	共色谱
كوخروماتوگرافىيە	共色谱法
كوخىنا	介壳灰岩
كوخېنىت	陨碳铁矿
كودامىن	可达明
كودلاشتۇرغۇچى	编码员
كودىمېر	共二聚体
كودېئىن	可待因
كودېكاربوكسىلازا	辅脱羧酶
كودېكلىناتسىيە	余赤纬
كوراللىن	类珊瑚虫
كورتېل	考特尔
كوردىئېرىت	堇青石
كوررىگېنت	矫正剂
كوررېلومېتىر	相关计
كوررېلياتسىيە	相互关联
كورفىئوتلۇقلار	科孚岛人
كوركىت	磷菱铅矾
كورنۇس	山茱萸
كورنېتىت	蓝磷铜矿
كورنېرۇپىن	柱晶石
كورنېلىت	斜红铁矾
كورولۇس	卡娄拉斯
كورونادىت	铅硬锰矿
كوروناگراف	日冕仪
كورونىللىن	小冠花苷
كورىدىن	紫堇丁
كورىلار	科利人
كورىنومورفا	花蕾水螅
كورۇندوفىلىت	脆绿泥石
كورۋۇزىت	水复钒矿
كورېر	取岩芯器
كورېل	科勒尔
كورېپرېسسور	辅阻遏物
كوسكوس	蒸粗麦粉
كوسموخىمىيە	宇宙化学
كوسموسفېرا	天球仪
كوسموسوفىيە	宇宙说
كوسمولوگىست	宇宙论家
كوسموگرافىيە	宇宙志
كوسمىزم	宇宙论
كوسمىن	齿鳞质
كوسپېكتر	同相谱
كوفمان	考夫曼
كوكاربوكسىلازا	辅羧酶
كوكاكولا	可口可乐
كوكتائىت	铵石膏
كوكسىنىت	碘汞矿
كوكسچى	焦炭工
كوككوباتسىللۇس	球杆菌
كوككولوبا	海葡萄果
كوككولىت	粒辉石
كوكۋىمبىت	针绿矾
كولراس	科尔劳斯
كولسكىت	鳞蛇纹石
كوللاگېن	骨胶原
كوللاگېنازا	骨胶酶
كوللوئىدلاشتۇرغۇچ	胶化器
كوللوفان	胶磷矿
كوللىرىتىد	饼海胆
كوللېكتىپلاشتۇرۇش	集体化
كوللېكتىۋىزم	集体主义
كوللېنسىت	胶细胞
كوللېنىيە	聚环藻
كولوتسېفاللار	截头类
كولورازىن	可乐津
كولورىمېترىست	色度学家
كولوفونىت	褐榴石
كولوفېن	松节烃
كولىستىن	粘杆菌素
كولپوسكوپ	阴道镜
كولچىتسىن	秋水仙碱
كولۇبرىن	可伦布林
كولۇمبىت	铌铁矿
كولۇمبىيە	哥伦比亚
كولېئوپتېرولوگىيە	鞘翅学
كولېمانىت	硬硼钙石
كوماتۇلىد	毛头星
كومبۇرىمېتر	燃烧计
كومسسىيون	寄卖行
كومشا	傻呵呵
كوممۇتاتورخانا	交换机室
كوممۇنىستپەرەس	亲共派
كوممېنتارىيە	系统注释
كوممېنسالىزم	偏利共栖
كومىندا	康孟达
كومپتون	康酱顿
كومپرېسسومېتىر	压缩计
كومپوت	蜜饯碟
كومپوزېرترون	作曲器
كومپيوتېر	计算机
كومپيۇتېرلىشىش	计算机化
كومېدىيىدەك	喜剧状地
كونالبۇمىن	伴白蛋白
كونتاكتسىز	无接触
كونترائوكتاۋا	大字一组
كونتراكتومېتر	收缩仪
كونتروللىغۇچ	控制器
كونترولچى	管帐员
كونتىنېنتالىزم	大陆主义
كونتېينرلاشتۇرماق	集装箱化
كونتېينېر	集装箱
كوندوم	阴茎套
كوندۇكتور	乘务员
كونستانتىن	君士坦丁
كونستىتۇتسىئونالىزم	立宪主义
كونسۇلات	执政府
كونسېرن	康采恩
كونسېرۋاتىزم	保守主义
كونسېرۋاچى	罐头工人
كونسېكراتسىيە	成圣体
كونسېلور	主教助理
كونفورماتور	计形器
كوننارىت	水硅镍矿
كوننېكسىئونالىزم	连结主义
كوننېلىت	铜氯矾
كونولىت	畸形岩体
كونىئولوگىيە	微尘学
كونىتسېئىن	毒芹侧碱
كونىخالتسىت	砷钙铜矿
كونىدېندرىن	松柏碱
كونىرىغان	隔年皇历
كونىسكوپ	尘粒镜
كونىفېرىن	松柏苷
كونىكىت	针磷铁矿
كونىمېتىر	尘度计
كونىن	毒芹碱
كونىگ	柯尼希
كونيۇگات	共轭元
كونيۇگازا	轭合酶
كونيۇگاللار	结合藻目
كونچىك	分栏线
كونگرۇئىزم	灵验论
كونگسبېرگىت	汞银矿
كونگلۇتىنىن	胶固素
كونگىدرىن	毒芹羟碱
كونگېستىن	海葵毒素
كونۋاللارىن	铃兰苷
كونۋاللامارىن	铃兰苦苷
كونۋولۋۇلىن	旋花苷
كونۋولۋېر	卷积器
كونۋېكتور	对流器
كونۋېنسىئونالىزم	因袭主义
كونېززىن	锥丝碱
كويسانلار	科伊桑人
كويۇكونلار	科尤孔族
كوپالىت	黄脂石
كوپروستان	粪甾烷
كوپروستانول	粪甾烷醇
كوپروپورفىرىن	粪卟啉
كوپولىمېر	共聚物
كوپىيىزم	模仿主义
كوپېراتىپ	合作社
كوپېرنىك	哥白尼
كوۋارىئاتسىيە	协方差
كوۋرىيە	子母贝
كىبىرلەنمەك	妄自尊大
كىتاببازلىق	本本主义
كىتابخۇمار	藏书癖
كىدرازىن	角苷脂
كىرتوتسېراتىت	弓角石
كىرخانا	洗涤间
كىرخگوف	其尔霍夫
كىرمەڭ	请勿入内
كىروۋىت	镁水绿矾
كىرپىباش	鹅观草
كىرپىكسىمان	睫毛状
كىرگۈزگۈچ	输入机
كىرەلىمەك	可进入
كىسسار	基瑟琴
كىلتاڭ	门插关儿
كىللارنېي	基拉尼
كىلوئامپېرمېتىر	千安表
كىلوبائۇد	千波特
كىلوبىت	千比特
كىلورېنتگېن	千伦琴
كىلومېگاسىكل	千兆周
كىلونيۇتون	千牛顿
كىلوپارسېك	千秒差距
كىلوۋولتمېتر	千伏计
كىلوۋولتمېتىر	千伏表
كىلىماتولوگىست	气候学家
كىلىماتولوگىيە	气候学
كىلىماتومېتر	气候表
كىلىماتوگرافىيە	气候志
كىمبېرلىت	金伯利岩
كىموگراف	记波器
كىموگرافىيە	记波法
كىموگرامما	记波图
كىمىياگەر	炼金术士
كىمىياگەرلىك	炼金术
كىمېرا	嵌合体
كىندەلەر	肯德人
كىنزىگىت	榴云岩
كىنوشۇناسلىق	电影学
كىنوچىلىق	电影业
كىنىنوگېن	激肽原
كىنۇرېنىن	犬尿氨酸
كىنېتوزوما	毛基体
كىنېتىن	激动素
كىنېزىئولوگىيە	运动学
كىنېزىتېراپىيە	运动疗法
كىنېزىكا	身势学
كىچىكلەشتۈرۈش	小型化
كىچىكىدىنلا	起小儿
كىۋىيېتىزم	无为主义
كيېسېرىت	水镁矾
كۆرمەسلىك	看不见
كۆرۈشتۈرگۈچى	引见人
كۆرۈنىدىغانلىق	可见性
كۆزىتىشچانلىق	可观察性
كۆزەتكۈچىلەر	观潮派
كۆزەينەكچى	眼镜师
كۆشىمەيدىغانلار	非反刍类
كۆشىگۈچىلەر	反刍动物
كۆكتاتشۇناس	蔬菜学家
كۆكتاتشۇناسلىق	蔬菜学
كۆكتاتچىلىق	蔬菜园艺
كۆكرەكلىك	护胸甲
كۆكلەم	春牧场
كۆكيۆتەل	百日咳
كۆكچە	可口奇
كۆلەملەشتۈرۈش	规模化
كۆممىقوناقلىق	玉米地
كۆمۈرلىشىش	煤化作用
كۆمەچ	皮面饼
كۆيدۈرىدىغان	热辣辣
كۆيدۈرۈۋېىتىش	销毁处理
كۆيۈشچانلىق	燃烧性
كۆپىيىشچانلىق	生殖性
كۆپۈش	体膨胀
كۆپۈشچانلىق	膨胀性
كۆپۈكلىشىش	空泡气蚀
كۆپۈكلەشتۈرگۈچ	起泡剂
كۆپەيتكۈچ	乘法器
كۆپەيگۈچى	被乘数
كۆچۈرگۈچ	抄录器
كۆچۈرۈلۈشچانلىق	可移植性
كۆچۈشچانلىق	迁移率
كۆڭۈلگەئالماسلىق	毫不介意
كۇئاپاۋلار	瓜坡人
كۇباشۇناس	古巴通
كۇبانىت	方黄铜矿
كۇبوئىدال	墓穴小室
كۇبىزم	立体派
كۇتناخورىت	镁锰解石
كۇردلار	库尔德人
كۇرناكوۋىت	水镁硼石
كۇرىت	板铅铀矿
كۇرىن	箭毒素
كۇرۇبالار	库鲁巴人
كۇرۇمبالار	库尤巴人
كۇرۋومېتر	曲线仪
كۇساييانلار	库赛埃人
كۇسپارىن	库柏因
كۇسپىدىن	枪晶石
كۇشىتلار	库什人
كۇكېئىت	锂绿泥石
كۇكېرزىت	含藻岩
كۇلتىۋاتور	中耕机
كۇلتۇرا	培养基
كۇلتۇرولوگىست	文化学家
كۇلدوسكوپ	陷凹镜
كۇلومب	国际库仑
كۇلونمېتر	库仑计
كۇلۇپ	俱乐部
كۇماران	香豆满
كۇمارون	香豆酮
كۇمارىن	香豆素
كۇماسولار	库马索人
كۇمالىن	香豆灵
كۇمانلار	库曼人
كۇمبېرلاندلىقلار	坎伯兰人
كۇممىنگتونىت	镁铁闪石
كۇمىنالدېگىد	枯茗醛
كۇمىنوئىن	枯茗偶姻
كۇمۇلانت	累计矩
كۇمۇلېن	累积烯
كۇمېنىل	异丙苯基
كۇنالار	古那人
كۇنزىت	紫锂辉石
كۇينۇكلىدىن	奎宁环
كۇيچېلار	盖切人
كۇپروبىسمۇتىت	辉铜铋矿
كۇپروسكلودوۋسكىت	硅铜铀矿
كۇپروكوپىئاپىت	铜叶绿矾
كۇپرېن	铜蛋白
كۇپفېررون	铜铁灵
كۇپفېرىت	镁直闪石
كۇۋەيتلىكلەر	科威特人
كۇەيبەر	快板儿
كۈتمەسلىك	意料不到
كۈتى	勘堪戡坎
كۈركۈمگۈل	郁金香
كۈرەشچان	精卫填海
كۈزلەك	秋牧场
كۈشكۈرتكۈچى	教唆者
كۈمۈشئوت	银粉背蕨
كۈچىنىشسىزلەشتۈرمەك	去应力
كۈچۈكلەنمەك	摇尾乞怜
كۈچەپ	死劲儿
كۋادراتلىغۇچ	平方器
كۋادىلار	夸地人
كۋارتسوئىد	类石英
كۋارتسىت	石英岩
كۋاسسىن	苦木素
كۋانتومېتىر	光量计
كۋىسكۋېئىت	硫沥青
كۋىنتانت	五分仪
كۋېبېك	魁北克
كۋېبېكلىكلەر	魁北克人
كۋېراندىلار	盖兰迪人
كۋېرتسىتاننىن	栎丹宁
كۋېرتسىترون	栎皮粉
كۋېرتسىمېرىترىن	栎袂春
كۋېرتسېتاگىترىن	栎草素
كۋېرتسېتاگېتىن	栎草亭
كۋېرېچولار	盖勒丘人
كۋېنسلاندلىقلار	昆士兰人
كۋېچۇئالار	克丘亚人
كېئاتىت	热液石英
كېتازىن	甲酮连氮
كېتال	酮缩醇
كېتامىن	克他命
كېتلار	克特人
كېتول	乙酮醇
كېتولازا	酮醇酶
كېتېن	乙烯酮
كېرائۇنوگرامما	雷击图
كېراتوگىئالىن	透明角质
كېراتىن	角蛋白
كېرسانتىت	云斜煌岩
كېرما	比释动能
كېرمېزىت	红锑矿
كېرنىت	四水硼砂
كېرىل	煤油烷基
كېرەكسىزلىك	无用性
كېسىمخانا	仲裁厅
كېسىندى	下脚料
كېسەلچانلىق	感病性
كېفلىن	开弗林
كېلاڭچۇر	克朗球
كېلتلار	克尔特人
كېللىن	克拉果素
كېلىشىمنامە	议定书
كېلەچەكشۇناسلىق	未来学
كېمپفېرول	堪非醇
كېمپىت	氯羟锰矿
كېنترولىت	硅铅锰矿
كېنتلىقلار	肯特人
كېنستېدتىت	铁紫矾
كېنوزوئوئىد	空个员
كېيېر	键控器
كېپلېر	开普勒
كېچىكتۈرگۈچ	延时器
كېچىكمەسلىك	为时不晚
كېچەلمەسلىك	舍不得
كېچەيۇكۈندۈز	日以继夜
كېڭەشكۈچى	商议者
كېڭەيتىۋېتىش	扩大化
كېڭەيمىچىلىك	扩张主义
كېڭەيگۈچى	膨胀者
كەتمەن	坎土曼
كەرالالار	喀拉拉人
كەررېفور	家乐福
كەرگۈچ	张开器
كەسلەنچۈكسىمانلار	蜥形类
كەسىرلەشتۈرۈش	分数化
كەسىپكارلار	从业人员
كەسىپلەشكەنكەنت	专业村
كەلتۈرۈشچانلىقى	可约性
كەمسىتىلمەك	受人轻蔑
كەمچىللىكمۇ	瑕瑜互见
كەنئانىلار	迦南人
كەيىپسىز	无精打采
كەپتەرسىمانلار	鸽形类
كەپلىگۈچ	填塞器
كەچۈرگەيلا	请别介意
لائاۋېنىت	褐锰锆石
لائۇبماننىت	羟绿铁矿
لائۇتارىت	碘钙石
لائۇتىت	辉砷铜矿
لائۇدانوزىن	劳丹素
لائۇدانىن	劳丹碱
لائۇدىئانىزم	劳德主义
لائۇرالدېگىد	月桂醛
لائۇرويل	月桂酰
لائۇرىئونىت	羟氯铅矿
لائۇرىت	硫钌锇矿
لائۇرىل	月桂基
لائۇرىن	月桂精
لائۇزېنىت	六水铁矾
لائۇمونىت	浊沸石
لابرادورىت	拉长石
لابوراتورىيە	化验室
لاتاپەت	脂粉气
لاتىنلار	拉丁人
لاخۇلىلىقلار	拉胡利人
لاخېرلار	拉克人
لاخېزىن	饭匙倩碱
لاداقلىقلار	拉达克人
لاردېرېللىت	硼铵石
لارسېنىت	硅铅锌矿
لارىنگوفون	喉听诊器
لارىنگولوگىست	喉科学家
لازۇرىت	青金石
لازۇلىت	天蓝石
لاكتازا	乳糖酶
لاكتالبۇمىن	乳清蛋白
لاكتام	内酰胺
لاكتوئۇرىيا	乳糖尿
لاكتوفوسفات	乳磷酸盐
لاكتوفېررىن	乳铁蛋白
لاكتونازا	内酯酶
لاكتوگلوبۇلىن	乳球蛋白
لاكتىكلاشتۇرۇش	乳酸转化
لاكتىن	内亚胺
لاكتېنىن	乳烃素
لاكروئىكسىت	锥晶石
لاككازا	虫漆酶
لاككول	虫漆酚
لاكمۇئىد	间二酚蓝
لاكچى	涂清漆工
لامباست	害草净
لامبدا	拉姆达
لامىنا	肉小叶
لامىنارىيىسىمانلار	拟昆布类
لامپادىت	铜钴锰矿
لامپروفىر	煌斑岩
لامپروفىللىت	闪叶石
لامېللازوما	层片体
لاناركىت	黄铅矾
لانتانا	马缨丹
لانتوپىن	兰梭品
لانخوكارپۇس	矛豆荚
لاندلېر	兰特勒舞
لانوستېرول	羊毛甾醇
لانولىن	羊毛脂
لانولىنلىشىش	羊毛脂化
لانىئارىئۇس	黑伯劳
لانگبانىت	硅锑锰矿
لاياقەتنامە	合格证
لايىقلاشتۇرغۇچ	匹配器
لاپاخول	拉帕醇
لاپلار	拉普人
لاچىندانە	白豆蔻
لاڭميۇر	朗缪尔
لاگ	测程仪
لاگرانژې	拉格朗日
لاۋازىماتچى	管理员
لاۋروۋىت	钒辉石
لاۋرېنسىت	陨氯铁
لاۋسونىت	硬柱石
لاۋىلىق	熔岩原
لوئادومېتر	落地秤
لوئۇگلىنىت	丝硅镁石
لوتوزىن	百脉根苷
لوخارلار	罗哈尔
لودھالار	洛达人
لوراندىت	红铊矿
لورانسكىت	钇钽矿
لورېتتوئىت	黄氯铅矿
لوزېيىت	蓝锌锰矿
لوشمىدت	洛喜密脱
لوفىن	洛芬碱
لوفۇرا	火背雉
لوكارنو	洛迦诺
لوكېئانىزم	洛克主义
لوماتىئول	拉帕醇黄
لومباردلىقلار	伦巴第人
لوندونلۇقلار	伦敦人
لونگۇلىت	长联雏晶
لوپا	放大镜
لوگارىفمېتىر	计算尺
لوگانىن	马钱子苷
لوگوس	逻各斯
لوگىستىك	逻辑斯蒂
لوگىكىزم	逻辑主义
لوگىكىلاشتۇرۇش	逻辑化
لىئازا	裂合酶
لىئېبىگىت	铀钙石
لىبراتسىيە	天平动
لىبرىئۇم	利眠宁
لىبوللىت	暗沥青
لىبېتېنىت	磷铜矿
لىبېراللار	自由派
لىبېرىت	锂铍石
لىتوپون	锌钡白
لىتوگرافىيە	平印术
لىتىئوفورىت	锂硬锰矿
لىتىت	钙结核
لىتىدىئونىت	碱硅铜矿
لىتۇرگىئولوگىيە	礼拜仪学
لىتۋالىقلار	立陶宛人
لىدار	激光雷达
لىدوكائىن	利多卡因
لىدىيىلىكلەر	吕底亚人
لىزاردىت	板蛇纹石
لىزوزوما	溶酶体
لىزوزىما	溶菌酶
لىزوگېنلىشىش	溶菌化
لىزوگېنلىق	溶原性
لىسساجۇ	利萨如
لىسكېئاردىت	砷铁铝矿
لىشاينولوگىيە	地衣学
لىشېنىن	地衣聚糖
لىفتېر	掘起机
لىقمۇلىق	满满当当
لىكانتروپىيە	变狼妄想
لىكسوزا	来苏糖
لىكسوفلاۋىن	来苏黄素
لىكورىن	石蒜碱
لىكوپېردونوزىيە	马勃菌病
لىكۇتا	里库塔
لىللىئانىت	硫秘铅矿
لىمنائېيە	椎实螺
لىمنورىيە	蛀木水虱
لىمنولوگىيە	湖沼学
لىمنېفىلىد	沼石蛾
لىموسفېرا	顶体球
لىموناد	来檬汽水
لىمونىت	褐铁矿
لىنارىت	青铅矾
لىنالول	里哪醇
لىنالىل	里哪基
لىنامارىن	里哪苦苷
لىنتونىت	绿杆沸石
لىنداككېرىت	砷镍铜矾
لىندسترومىت	辉铋铜矿
لىندگرېنىت	钼铜矿
لىنزىسىمان	透镜状
لىنكوتسىن	林可辛
لىنكومىتسىن	林肯霉素
لىننېئىت	硫钴矿
لىنولېئىن	亚油精
لىنولېنىن	亚麻精
لىنىيىلىكلىك	线性度
لىنگۇلا	海豆芽
لىنۇرون	利谷隆
لىپوتروپىن	趋脂素
لىپوخروما	脂色素
لىپوزىتول	肌醇磷脂
لىپوساركوما	脂肉瘤
لىپوفۇسسىن	脂褐质
لىپوپولىساخارىد	脂多糖
لىپەكسىمان	细肋盘型
لىگنىن	木质素
لىگودىئۇم	海金沙
لىۋىسچىلار	利维斯派
لىۋىنگستونىت	硫汞锑矿
لىۋىيىلىكلەر	利比亚人
لىۋېتىن	卵黄蛋白
ليۇتسىگېن	荧光源
ليۇتېتسىت	水玉髓
ليۇدۋىگىت	硼镁铁矿
ليۇكسېمبۇرگلۇقلار	卢森堡人
ليۇمىخروم	络光色
ليۇمىستېرول	光淄醇
ليۇمىفلاۋىن	光黄素
ليۇمىنوسكوپ	荧光仪
ليۇمىنېسسېنسىيە	发冷光
ليۇمېنمېتىر	流明表
ليېبېنېرىت	白假霞石
لۇئېنېبۇرگىت	硼磷镁石
لۇتىت	细屑岩
لۇتېئولىزىن	溶黄体素
لۇددىزم	卢德主义
لۇدلامىت	板磷铁矿
لۇسېك	流西克
لۇكسون	光速子
لۇكۇللىت	卢卡尔石
لۇمىنال	鲁米那
لۇپا	凸透镜
لۇپانىن	羽扇烷宁
لۇپولون	蛇麻酮
لۇپىنىن	羽扇豆宁
لۇپۇلىن	蛇麻腺
لۇپېئول	羽扇醇
لېئونارد	莱奥纳德
لېئونخاردىت	黄浊沸石
لېئونلۇقلار	莱昂人
لېئونىت	钾镁矾
لېئۇتېئىن	黄体制剂
لېئۇتېئىنىزاتسىيە	黄体化
لېئۇكوكسېن	白钛石
لېبېدېف	列别捷夫
لېتسىتوپروتېئىن	磷脂蛋白
لېتسىتىنازا	卵磷脂酶
لېتوۋىتسىت	重铵矾
لېدېبۇرىت	莱氏体
لېرپ	桉叶胶
لېس	烘烤盘
لېسسىنگىت	钙铬铈石
لېسلېئىت	钾珠云母
لېكسىكولوگىست	词学家
لېكسىكولوگىيە	词汇学
لېكسىگرافىيە	语字法
لېكونتىت	钠铵矾
لېناتسىل	环草定
لېنىنىزم	列宁主义
لېنىنگراد	列宁格勒
لېنگۇئالار	伦瓜族
لېيتسىل	白氨酰
لېيتسىن	亮氨酸
لېيختونىت	钾钙铜矾
لېيفىت	白针柱石
لېيكاۋگىت	白辉石
لېيكوخالسىت	白砷铜矿
لېيكوساركوما	白色肉瘤
لېيكوسفېنىت	淡钡钛石
لېيكوفانىت	白铍石
لېيكوفېنىتسىت	水硅锰石
لېيكون	白细胞系
لېيكوپتېرىن	白蝶呤
لېيكوپلاست	白色体
لېيكوۋورىن	白卧仁
لېيكوۋىرۇس	白血病毒
لېيكىن	白细胞素
لېپتودورا	薄皮蚤
لېپتوسپېرمون	纤精酮
لېپتوفىل	微形叶
لېپتوكاردىيە	狭心纲
لېپروفوبىيە	麻风恐怖
لېپرولوگىست	麻风学家
لېپرولوگىيە	麻风病学
لېپروما	麻风结节
لېپرومىن	麻风菌素
لېپىدوكروتسىت	纤铁矿
لېپىدومېلان	铁黑云母
لېپىدوپتېرولوگىيە	鳞翅目学
لېگالىزم	教法主义
لېگراندىت	碱砷锌矿
لېگۇمېلىن	豆清蛋白
لېۋامىزول	左旋咪唑
لېۋانتىنلار	勒旺人
لېۋانتېرلار	黎凡特人
لېۋىتلار	勒维人
لەخۋا	土老帽
لەيلىقازاق	野罂粟
لەيلىمىلەر	悬移质
لەپەر	表演唱
لەپەڭلەپ	一溜歪斜
مائابارا	马巴鲁特
مائۇخېرىت	砷镍矿
مائۇس	鼠标器
مائېرل	美尔卢
ماتروسلار	水手们
ماترىئارخ	女族长
ماترىئارخاللىق	母权制
ماترىكس	菌类基体
ماتلوككىت	氟氯铅矿
ماتورلىشىش	摩托化
ماتىلدىت	硫银铋矿
ماتېماتىك	数学家
ماخمېتر	马赫表
مادارسىز	不得劲
مادارسىزلانماق	有气无力
مادخيامىكا	大乘空宗
ماددىلىق	物质性
ماددىچىلىق	物质主义
مادىيە	麻迪菊属
مارابوۋ	马拉布鹳
مارافون	马拉松
ماراكان	马拉坎
مارامچى	偷看者
مارتىنېتا	马丁内塔
مارتېللاتو	重断奏
مارجانسىمانلار	似珊瑚类
ماررۇبلىن	夏至草素
مارزىن	苯甲哌嗪
مارسخىت	碘铜矿
ماركازىت	白铁矿
ماركس	马克思
ماركىشۇناسلىق	商标学
ماركېر	标识器
مارماتىت	铁闪锌矿
مارونىت	马尤教
مارىئالىت	钠柱石
مارىئوت	马略特
مارىئولوگىيە	圣母学
مارىست	圣母会
مارىمبا	马林巴琴
مارىنىزم	马里尼体
مارىپوزىت	铬硅云母
ماريورام	马郁兰
مارگارودىت	珠水云母
مارگارىت	串珠雏晶
مارگانسوۋكا	高锰酸钾
مارگېرىت	木茼蒿
مارۇن	逃亡黑奴
مازائېدىي	孢丝粉体
ماسستون	多色调
ماسسۇلا	孢胶块
ماسكون	质量瘤
ماسكېلىنىت	陨玻长石
ماسلاشتۇرغۇچ	适配器
ماسوخىزم	受虐狂
ماشىنكا	打字机
ماشىنكىخانا	打字间
ماشىنىسى	单烘缸机
ماشېت	马谢特琴
ماغزاپلاشتۇرغۇچ	起沫剂
مافىيە	黑手党
ماقالىشۇناسلىق	文章学
ماقۇلنامە	同意书
ماكانلىشىش	安家落户
ماكدونالد	麦当劳
ماكروئاگرېگات	大团聚体
ماكروتاكسونومىيە	大分类学
ماكروخىمىيە	常量化学
ماكروسىست	大包囊
ماكروسپورا	大孢子
ماكروسېيسموگراف	强震仪
ماكروكرىستال	宏观晶体
ماكروكود	宏代码
ماكروكونيۇگانت	大接合体
ماكروكىلىمات	大气候
ماكروكىلىماتولوگىيە	大气候学
ماكرولىت	巨石器
ماكرومۇتاتسىيە	大突变
ماكرومۇتانت	大突变体
ماكروپارامېتر	宏参数
ماكروپرىزما	宏棱镜
ماكروپىرامىدا	宏棱锥体
ماكروگامېتا	大配子
ماكروگلوبۇلىن	巨球蛋白
ماكسىمۇملاشتۇرۇش	极大化
ماكسۋېل	麦克斯韦
ماككابى	马卡比
ماككايىت	水碲铁矿
ماكلۇرىن	桑橙素
ماكومىت	黑蛭石
ماكىناۋىت	马基诺矿
مالاتىئون	马拉硫磷
مالاكولىت	白透辉石
مالاكون	变水锆石
مالامبو	麻拉波
مالتازا	麦芽糖酶
مالتوزۇرىيە	麦芽糖尿
مالتول	麦芽醇
مالتېن	马青烯
مالدونىت	黑铋金矿
ماللادرىت	氟硅钠石
مالم	麻姆世
مالونىل	丙二酰
مالىنوۋسكىت	铅黝铜矿
مالىگرامما	邮信机
مالۋىدىن	樱草素
مالېخۇلىيە	忧郁症
مامموگېن	激乳腺素
مامىسا	海婴粟
مانائىزم	马纳主义
ماناسسېئىت	水镁铝石
ماناك	马纳克
ماناگېرىئالىزم	管理主义
مانتېللون	教廷外袍
مانخاتتانلار	曼哈顿人
ماندالىن	曼德琳
ماندولا	曼多拉琴
ماندېلونىترىل	苯乙醇腈
مانسفيېلدىت	砷铝石
مانكاتو	曼卡托
ماننان	甘露蜜
ماننوزا	甘露糖
مانوستات	恒压器
مانىلكارا	人心果
مانىللا	马尼亚
مانىپۇرى	曼尼普利
مانگالوتانتالىت	锰钽铁矿
مانگانوزىت	方锰矿
مانگانوسىدېرىت	锰菱铁矿
مانگانوفىللىت	锰黑云母
مانگانوكالتسىت	锰解石
مانگانوكولۇمبىت	锰铌铁矿
مانگوستان	人面果
مانۇئالى	曼纽瓦利
مانۇتاگى	马纳塔吉
مانۇسىنا	马纳西纳
مانۇكودىيە	辉羽风鸟
مانۇما	马纳马
مانېب	代森锰
مانېۋېر	机动飞行
مايكېلسون	迈克尔孙
مايلامچى	涂油的人
مايمۇنگۈل	猩猩草
مايورىتارىئانىزم	多数主义
ماڭدار	铁线莲
ماڭغۇزۇۋەتمەك	打发走
ماگرىم	麻克里姆
ماگماتىت	岩浆岩
ماگنتومېتىرىيە	测磁学
ماگنىستور	磁变管
ماگنېت	吸铁石
ماگنېتوئاكۇستىكا	磁声学
ماگنېتوئېلاستىك	磁致弹性
ماگنېتوئېلېكترىكلىك	磁电性
ماگنېتوخىمىيە	磁化学
ماگنېتورېزىستور	磁控电阻
ماگنېتوستاتىكا	静磁学
ماگنېتوفون	磁录声机
ماگنېتومېتىر	磁强计
ماگنېتومېتىرىيە	测磁强术
ماگنېتومېخانىكا	磁力学
ماگنېتىت	磁铁矿
ماگنېتىكىشۇناس	磁学家
ماگنېزىئوفېررىت	镁铁矿
ماگنېزىئوكوپىئاپىت	镁叶绿矾
ماگنېزىت	菱镁矿
ماگىئانىزم	祭司教
ماگىنىتسىزلىغۇچ	消磁器
ماگىنىتلاندۇرغۇچ	磁化器
ماگىنىتلىقماتېرىيال	磁性材料
ماگىنىتوگراف	地磁计
ماگيار	玛格亚
ماگۋارى	马格里
ماھىيەتسىز	非本质
ماھىيەتچىلىك	本质论
ماۋزولېي	纪念堂
مبىرا	姆比拉琴
مناندرىت	褐硅铈矿
موئىسسانىت	碳硅石
موبېد	穆白德
موتورخانا	发动机房
موتورىي	中枢质点
موخۇركا	黄花烟草
مودۇلومېتىر	调制计
مودۇلياتسىيە	和谐优美
مودېراتىزم	温和主义
مورفاكتىن	形态素
مورفوتروپىزم	变形晶
مورفوسان	吗啡散
مورفوفونېما	形态音素
مورفولوگىست	形态学家
مورفولىد	酰替吗啉
مورفولىن	吗啡啉
مورفومېترىيە	形态量测
مورفېمىكا	语素学
مورمون	摩门教
مورمونىزم	摩门主义
مورمېر	大区总管
موروكسىت	蓝磷灰石
مورىندىن	巴戟苷
مورۇلا	桑椹胚
مورېنسىت	褐绿脱石
مورېپورك	莫尔波克
موزا	没食子
موزابىت	摩扎比信
موزايكا	马赛克
موزېزىت	黄铵汞矿
موسائىزم	摩西教法
موسبائۇئېر	穆斯堡尔
موسكوۋىت	莫斯科灰
موسېلېي	莫斯菜
موغوللار	莫卧儿人
موكو	毛利文身
موكى	毛利筏
مولىبدېنىت	辉钼矿
مولىنىزم	莫利那教
مولېكۇلىلىق	分子性
موموردىكا	罗汉果
موميا	木乃伊
موميالاش	木乃伊化
مومېتر	姆欧计
مومېنتومېتر	转矩计
مونازىت	独居石
مونتگولفىئىر	蒙格尔费
مونوترىگلىف	单柱类
مونوتونلۇقلۇقى	单调性
مونوتېئىزم	一神教
مونوتېئىستىزم	一神论
مونوگامىيە	一夫一妻
موڭغۇلشۇناسلىق	蒙古学
مىئارگىرىت	辉锑银矿
مىئوفورا	内带槽
مىئوكاردىت	心肌炎
مىئوكاردىيە	心肌层
مىئوگېئوسىنكلىن	冒地槽
مىئېرسىت	黄碘银矿
مىترائىزم	太阳神教
مىتسار	北斗六
مىتسېتوما	含菌体
مىتكار	梅蒂卡尔
مىتوزوما	精丝体
مىتومىتسىن	自力霉素
مىدرىئازىن	散瞳新
مىدىرلىماسلىق	站住脚
مىراب	水利总管
مىرابېللې	布拉斯李
مىراتسىدىيە	纤毛幼虫
مىراتسىل	米来西
مىررورسكوپ	取景器
مىرمېكوفىلىزم	喜蚁作用
مىرمېكىت	蠕状石
مىروزىن	芥子酶
مىرىتسېتىن	杨梅酮
مىرىتسېن	香叶烯
مىرىستىتسىن	肉豆蔻醚
مىرېد	微倒度
مىرېكس	灭蚁灵
مىرەز	害群之马
مىزانشۇناسلىق	准则学
مىززونىت	钠钙柱石
مىزوگىنىيە	厌女症
مىزېنىت	纤重钾矾
مىستىتسىزم	神秘教义
مىستېرىيە	神秘源
مىسسال	弥撒本
مىسسىئونېر	传教士
مىسسىيە	地方教会
مىسىرلىقلار	埃及人
مىقدارلاشتۇرغۇچ	量化器
مىقدارى	辐射剂量
مىكتېرىيە	美洲彩鹳
مىكروئاكۇسىتكا	微声学
مىكروئامپېرمېتر	微安计
مىكروئامپېرمېتىر	微安培计
مىكروئانالىز	微量分析
مىكروئاپتوموبىل	微型汽车
مىكروئاگرېگات	微团聚体
مىكروئورگانىزم	微生物
مىكروئېكولوگىيە	微生态学
مىكروئېلېكترود	微电极
مىكروئېلېكترولىز	微电解
مىكروئېلېكترونىكا	微电子学
مىكروبرېكسىيە	微角砾岩
مىكروبىئولوگىيە	微生物学
مىكروتارازا	微量天平
مىكروتسىست	小孢囊
مىكروتوم	切片机
مىكروتون	微分音
مىكروتۇرۇپكا	微型听筒
مىكروتېكست	微型课本
مىكروخىرۇرگىيە	显微外科
مىكروخىمىيە	微量化学
مىكرودىئاگنوز	微诊断
مىكرودىئورىت	微闪长岩
مىكرودىستىللياتسىيە	微量蒸馏
مىكرودىففۇزىيە	微扩散
مىكرودېتېرمىناتسىيە	微量测定
مىكرورادىئومېتر	微辐射计
مىكرورېلېف	微地貌
مىكروزوئىد	小个员
مىكروزوند	微探针
مىكروزىئېنىت	小正长岩
مىكروسفېرا	微球体
مىكروسكوپىيە	显微术
مىكروسوتسىئولوگىيە	微社会学
مىكروسپورا	小孢子
مىكروسپورانگىيە	小孢子囊
مىكروسۇبلىماتسىيە	微量升化
مىكروسېيسمولوگىيە	微震学
مىكروسېيسمومېتر	微震仪
مىكروسېگرېگاتسىيە	显微偏析
مىكروشكالا	微刻度
مىكروفورما	冬眠孢型
مىكروفونىكا	传声学
مىكروفىلىم	缩微摄影
مىكروفۇنگۇس	微真菌
مىكروكارتوچكا	缩微卡片
مىكروكالورىمېتر	微量热计
مىكروكاپسيۇل	微胶囊
مىكروكاپسيۇللۇق	装于微囊
مىكروكاپسۇلا	微型胶囊
مىكروكلىمات	小气候
مىكروكلىماتولوگىيە	小气候学
مىكروكلىن	微斜长石
مىكروكوندېنساتور	微电容器
مىكرولاشتۇرۇش	微型化
مىكرولوگىيە	微工艺学
مىكرولىتولوگىيە	微岩性学
مىكرولىنزا	精微镜头
مىكروليۇكس	微勒克斯
مىكرومانومېتر	微压表
مىكرومانومېتىر	微压计
مىكرومانىيە	微小狂
مىكرومانىپۇلياتسىيە	显微操作
مىكروموتور	微电机
مىكرومول	微摩尔
مىكرومىكروفارادا	微微法拉
مىكرومۇتاتسىيە	小突变
مىكرومېتىرىيە	测微法
مىكرومېتېئورولوگىيە	微气象学
مىكرومېتېئورىت	微陨星
مىكرومېرىتىكا	微晶学
مىكروپار	微电偶
مىكروپارازىت	微寄生物
مىكروپانتوگراف	缩微仪
مىكروپرويېكسىيە	显微投影
مىكروپروگرامما	微程序
مىكروپۇلساتسىيە	微脉动
مىكروگائۇس	微高斯
مىكروگامېتا	小配子
مىكروگلوبۇلىن	微球蛋白
مىكروگورېلكا	微焰灯
مىكروۋولتمېتر	微伏计
مىكروۋولتمېتىر	微伏特计
مىكروۋىكليۇچاتېل	微动开关
مىكرۇرگىيە	显微手术
مىكستۇرا	混合药
مىكسوسپورا	胶孢子
مىكسوسپورىدىيە	胶孢子虫
مىكسوكسانتىن	粘黄色烯
مىكسوپلوئىد	混倍体
مىكسوۋىرۇس	粘病毒
مىكسىت	砷铋铜矿
مىككرومودۇل	微模块
مىكوتوكسىن	真菌毒素
مىكوستېرول	真菌甾体
مىكوسىمبىئوز	真菌共生
مىكوفلورا	真菌区系
مىكولوگىست	真菌学家
مىكولوگىيە	真菌学
مىكومىتسىن	真霉素
مىكوپلازموز	支原体病
مىلارىت	整柱石
مىللىئېرستېد	毫奥斯特
مىللىرادىئان	毫弧度
مىللىكېن	密立根
مىللىمول	毫摩尔
مىللىمىكروۋات	毫微瓦
مىللىيلاشتۇرۇش	民族化
مىللىگائۇس	毫高斯
مىللىھېنرى	毫亨利
مىللېرىت	针镍矿
مىللېرىزم	米勒主义
مىللەتشۇناسلىق	民族学
مىللەتچىلىك	民族主义
مىلنېل	代森环
مىلودون	磨齿兽
مىلونىت	糜棱岩
مىلېپورا	多螅孔
مىمامسا	弥曼蹉
مىموزىن	含羞草素
مىمېتىت	砷铅矿
مىناميوت	迫击炮
مىنماكسلىق	极大极小
مىننېزوتائىت	铁滑石
مىنورلۇق	小调调式
مىنومېتر	微放射计
مىنىبوس	面包车
مىنىسترىيە	执政内阁
مىنىماكس	极小极大
مىنىمۇملاشتۇرۇش	极小化
مىنىمېتر	千分表
مىنگەشمەك	乘后座
مىنېرالسىزلاشتۇرغۇچ	脱矿物器
مىنېرالوئىد	准矿物
مىنېرالوكورتىكوئىد	盐皮质素
مىنېرالوگىست	矿物学家
مىنېراگرافىيە	矿相学
مىپافوكس	丙胺氟磷
مىچېرلىخىت	氯钾铜矿
مىڭپېلەك	鸡血藤
مىگراتسىيە	定期迁徙
ميوخوندرىيە	肌粒体
ميودىنامىكا	肌动力学
ميوزمىن	麦斯明
ميوزىن	肌球蛋白
ميوفورىيە	褶翅蛤
ميوكىنازا	肌激酶
ميولىپما	肌脂瘤
ميوپلاستىيە	肌成形术
ميوگلوبىن	肌红蛋白
مۆلچەرلىگۈچ	预测器
مۆلچەرلىگۈچى	预测者
مۇئەييەنچىلىك	肯定论
مۇتاتسىئونىزم	突变主义
مۇتاتسىيىلىنىش	突变发生
مۇتاروتازا	变旋光酶
مۇتامېرىزم	变构现象
مۇتاگېن	诱变剂
مۇتاگېنلىق	诱变性
مۇتسىن	粘蛋白
مۇتسىنوگېن	粘蛋白原
مۇتلەقلىق	绝对性
مۇتلەقلەشتۈرۈۋەتمەك	绝对化
مۇتلەقچىلىك	绝对主义
مۇتۇئالىست	互助论者
مۇتەسسىپلەر	保守派
مۇجمەللىك	模糊现象
مۇخبىرلىق	采访新闻
مۇداپىئەسىز	无防卫
مۇداپىئەلىنىيىسى	一条防线
مۇدىرىيەت	董事会
مۇرامىدازا	胞壁质酶
مۇرتۇق	旱麦草
مۇرومونىت	钇褐帘石
مۇرېئىن	胞壁质
مۇرېكسىد	骨螺紫
مۇرەببە	双回旋诗
مۇرەسسەنامە	调解书
مۇرەسسەچى	妥协派
مۇرەككەپلىك	复杂性
مۇزلىن	真丝薄绸
مۇزلۇقلىشىش	冰川化
مۇزىكىلاشتۇرماق	音乐化
مۇزېيشۇناسلىق	博物馆学
مۇستۇمزورلار	黑恶势力
مۇستەبىتچىلىك	权利主义
مۇستەملىكىلەشتۈرۈش	殖民地化
مۇستەملىكە	殖民地
مۇسسېلىن	沫丝淋
مۇسكارىن	毒蕈碱
مۇسكولوگىست	苔藓学家
مۇسكون	麝香酮
مۇسكوۋىتلاشتۇرۇش	白云母化
مۇسكۇلوتروپىزم	向肌性
مۇشكاۋا	佛手瓜
مۇفتا	离合器
مۇفتى	穆夫提
مۇقاۋىلىماق	装上封面
مۇقەددەسلەشتۈرمەك	神圣化
مۇقەررەرلىك	必然性
مۇقەررەرچى	必然论者
مۇقەررەرچىلىك	必然论
مۇكوپروتېئىن	粘蛋白质
مۇلازىمەتچانلىق	可服务性
مۇلايىملاشماق	温和起来
مۇلتىفىلىم	动画片
مۇلتىگرىد	多栅极管
مۇللىت	模来石
مۇنارچى	铁塔工
مۇنازىرىشۇناس	雄辩家
مۇناسىتر	修道院
مۇنبەتلەشتۈرمەك	腐殖化
مۇنبەتلەشمەك	肥沃起来
مۇنتىزىملاشتۇرۇش	正规化
مۇنجىستىن	门衣司亭
مۇيۇسا	木芋莎
مۇپەتتىش	审计官
مۇھاكىمىچى	评议员
مۇھىملىق	重要性
مۈشك	龙涎香
مۈشكۈللۈكتە	惨淡经营
مۈشۈكېئيىق	大熊猫
مۈلۈكچىلىك	所有制
مۈڭگۈزسىزلەر	无角类
مېئىوزىيە	减数分裂
مېتابولا	变态类
مېتابولىت	代谢物
مېتابىئوز	半共生
مېتابىئولوگىيە	超生物学
مېتابېنتونىت	准斑脱岩
مېتاتىپ	后出模
مېتاتېئورىيە	元理论
مېتاتېرىئانلار	后兽动物
مېتاتېزىز	后成现象
مېتاخروماتىن	异染质
مېتاخولىن	甲胆碱
مېتادون	美散痛
مېتازوئالار	后生动物
مېتازول	灭草定
مېتاستاز	同质蜕变
مېتاسىلىكات	偏硅酸盐
مېتافىز	干骺端
مېتاكاماتسىت	铁纹石
مېتاكرولېئىن	异丁烯醛
مېتالدېگىد	四聚乙醛
مېتاللوئىد	非金属
مېتاللوتسېن	金属茂
مېتاللوفون	梅它洛风
مېتاللوپورفىرىن	金属卟啉
مېتاللوگرافېر	金相学家
مېتاللىد	金属化物
مېتاللۇرگىست	冶金学家
مېتالوگرافىيە	金相学
مېتاماتېماتىكا	元数学
مېتامفېتامىن	甲丙胺
مېتامىكت	蜕晶质
مېتانلىشىش	甲烷化
مېتانىد	甲烷化物
مېتاپسىخولوگىيە	心理玄学
مېتاپلازما	词形变化
مېتاپلاست	后成体
مېتاپودوزوما	后足体
مېتاگاللويسىت	变埃洛石
مېتاگوماننىت	变褐铁矾
مېتاۋارىستسىت	变磷铝石
مېتاۋولتىن	变钾铁矾
مېترونىدازول	灭滴灵
مېتروپولىيە	宗主国
مېترىبۇزىن	赛克津
مېتوبرومىد	甲溴化物
مېتوبرومۇرون	秀谷隆
مېتوكسى	甲氧基
مېتول	米吐尔
مېتومىل	灭多虫
مېتىئونىن	蛋氨酸
مېتىداتىئون	杀扑磷
مېتىراپون	甲吡丙酮
مېتىسلاشماق	串秧儿
مېتىكائىن	米替卡因
مېتىلاتلاشتۇرۇش	引入甲醇
مېتىلازا	甲基化酶
مېتىللاشماق	甲基化
مېتىيودىد	甲碘化物
مېتىپا	甲基涕巴
مېتېئوترون	造云器
مېتېئورولوگ	气象学家
مېتېئوروگرامما	气象图解
مېتېئورىتىكا	陨星学
مېتېئورىست	流星学家
مېتېدرىن	梅太德林
مېتېمپىرىكا	先验哲学
مېخانوخىمىيە	机械化学
مېخانىتسىزم	机械论
مېخانىكاشۇناس	力学家
مېدىئاستىنىتىز	纵隔炎
مېدىئانا	二等分线
مېدۇللىن	肾髓素
مېراك	北斗二
مېراللۇرىد	莫鲁来
مېراۋان	麦拉丸木
مېربرومىن	红汞溴
مېرسالىل	汞撒利
مېركاللىت	重钾矾
مېركاپتال	缩硫醛
مېركاپتوئېتانول	巯基乙醇
مېركاپتودىمېتۇر	灭虫威
مېركاپتول	缩硫醇
مېركاپتومېرىن	巯汞林
مېركاپتىد	硫醇盐
مېركاپتۇپۇرىن	巯基嘌呤
مېركۇروفىللىن	汞非林
مېركۇرىدلار	汞化物
مېروخروم	部色体
مېروزوئىت	裂殖子
مېروستوماتالار	肢口类
مېروسيانىن	部花青
مېروسپورا	柱囊孢子
مېروسپورانگىي	柱孢子囊
مېروكسېن	黑云母
مېروگونىيە	卵片发育
مېرىخىنون	部苯醌
مېرىزم	分节性
مېرىسپورا	分断孢子
مېرىلېن	梅里林
مېرۋىنىت	镁硅钙石
مېرېئولوگىيە	部分学
مېزابىت	赭针铁矿
مېزادېنىي	中胚腺
مېزوئاتوم	介原子
مېزوبىلىرۇبىن	中胆红素
مېزوبىلىۋېردىن	中胆绿素
مېزورزوئا	中生动物
مېزوزۇئىد	中个员
مېزوسفېرا	中间层
مېزوسىدېرىت	中铁陨石
مېزوكسالىل	中草酰
مېزوكوللوئىد	介胶体
مېزوكىلىمات	中气候
مېزولىت	中沸石
مېزونېفروما	中肾瘤
مېزوپورا	间隙孢子
مېزوگلېيە	中胶层
مېزىتىت	菱铁镁矿
مېزېنتودېرما	中内胚层
مېزېنخىما	间充质
مېسكالىن	墨斯卡灵
مېفوباربىتال	甲巴比妥
مېفېنېزىن	唛酚生
مېكاربام	灭蚜磷
مېكامىلامىن	美加明
مېكساكاربات	自克威
مېكودونتا	长齿类
مېكونىن	袂康宁
مېلافىر	暗玢岩
مېلاكونىت	土黑铜矿
مېلام	蜜白胺
مېلانوتسېرىت	黑稀土矿
مېلانوسىت	黑素细胞
مېلانوكارسىنوما	黑素癌
مېلانوگېن	黑色原
مېلانىت	黑榴石
مېلانېمىيە	黑水症
مېلخىت	麦尔凯特
مېللوفون	梅洛风号
مېللىت	蜜蜡石
مېلوتروپا	机械钢琴
مېلودرامما	情节剧
مېلودىزم	旋律主义
مېلوپوئېيە	旋律法
مېلىئورىستلار	改善论者
مېلىبوزا	蜜二糖
مېلىفانىت	蜜黄长石
مېلىلىت	黄长石
مېلۇنگېئونلار	默伦琼人
مېلېزىتوزا	松三糖
مېناد	狂欢女人
مېنازون	灭蚜松
مېنتول	薄荷醇
مېنتون	薄荷酮
مېندىپىت	白氯铅矿
مېنشېۋىك	孟什维克
مېنوتاكسىس	补偿向性
مېنىنىيە	麦尼螨
مېنېخۇن	矮石匠
مېيونىت	钙柱石
مېپروبامات	眠尔通
مېگاتسىن	巨大菌素
مېگاتېر	大地懒
مېگادىنامىكا	巨动力学
مېگاراد	兆拉德
مېگازوئوئىد	大虫体
مېگاسىكلوتېم	巨旋回层
مېگاسپوروفىل	大孢子叶
مېگاكيۇرى	兆居里
مېگالوزاۋر	巨齿龙
مېگالوسفېرا	大球壳
مېگالېتوسكوپ	大体视镜
مېگاپارسېك	兆秒差距
مېگاگائۇس	兆高斯
مېگاگامېتوفىت	雌配子体
مېگرېتس	北斗四
مېگليۇمىن	甲葡胺
مېگىمىد	美解眠
مېھراب	祭坛台座
مېھىرگۈل	西番莲
مەجلىسخانا	会议室
مەجۇن	印度大麻
مەخسۇسلاشتۇرۇش	专门化
مەخسۇسلىشىشچانلىقى	专化性
مەدداھخانا	书馆儿
مەدەستان	密陀僧
مەدەنىيەتلىك	风流儒雅
مەرتىۋىلىك	名门显贵
مەردلەرچە	大义凛然
مەركەزلەشتۈرۈش	集中化
مەركەزلەشكەن	一元化
مەرمەرلىشىش	大理岩化
مەرىپەتچى	启蒙学者
مەرۋايىتدار	珍珠蚌
مەزمۇت،مۇستەھكەم	盘石桑苞
مەزھەبى	麦兹哈比
مەستخۇش	悠悠忽忽
مەستۇرىلىك	深居简出
مەستەر	动名词
مەسە	内套鞋
مەشغۇلاتسىز	无操作
مەشغۇلاتچى	操作员
مەشچى	烘炉工
مەغرىبى	马格里布
مەقسەتچىىك	目的论
مەمۇرىيەتشۇناسلىق	行政学
مەمۇلات	产成品
مەنسىتمەك	瞧得起
مەنسەپپەرەسلىك	长袖善舞
مەنپەئەتىچلىك	功利主义
مەنچىلىك	唯我论
مەپىكەش	大篷车夫
مەڭزى	脸蛋儿
مەھدى	玛赫迪
مەھشەرگاھ	涤罪所
مەھەللىۋازلىق	地方主义
مەۋجۇدات	存在物
مەۋجۇدىيەتچىلىك	存在主义
نائۇماننىت	硒银矿
نائەھلىلىك	非人格性
ناباتلار	奈伯特人
نابام	代森钠
ناتاللىقلار	纳塔尔人
ناتروئالۇنىت	钠明矾石
ناتروخالتسىت	钠铜矾
ناتروفىلىت	磷钠锰矿
ناترولىت	钠沸石
ناتروياروزىت	黄钠铁矾
ناتسىستلاشتۇرۇش	纳粹化
ناتۇرالىزم	自然主义
ناتۇرىزم	自然宗教
ناتۇفىلار	纳图菲人
ناخكولىت	苏打石
ناخىلار	拿喜人
نادورىت	氯锑铅矿
نار	单峰驼
نارتسېئىن	那碎因
نارسارسۇكىت	短柱石
ناركوئانالىز	麻醉分析
ناركوتولىن	那可托灵
ناركوتىن	那可丁
ناركوتېتسىزم	麻醉瘾
ناركولوگ	麻醉学家
ناركولوگىيە	麻醉学
ناركوگىپنوز	麻醉催眠
نارودنىكلار	民粹派
نارودنىكلىق	民粹主义
نارىنگېنىن	柚配质
نازارىتلار	纳齐尔人
نازارېنلار	拿撒勒人
نازىركوم	纳孜尔孔
نازىگۈل	风铃草
ناشىر	出品人
نافتا	石脑油
نافتازولىن	萘唑啉
نافتورېزورتسىنول	间萘二酚
نافتوكسى	萘氧基
نافتوكسىد	萘酚盐
نافېلىنلىشىش	霞石化
ناكرىت	珍珠陶土
ناكلونومېتىر	倾角仪
نالورفىن	丙烯吗啡
نالوكسون	纳络酮
نالېد	二溴磷
نامازشامگۈل	紫茉莉
نامالار	纳马人
نامزات	候选人
ناموئىلمىي	纳米科学
ناموتېخنىكىسى	纳米技术
نامچىلىق	唯名论
نانوئوپېراتسىيە	毫微手术
نايادىلار	纳亚迪
ناپتالام	抑草生
ناگاتېلىت	磷褐帘石
ناۋاتچاي	冰糖茶
ناۋارالىقلار	纳瓦拉人
ناۋارو	那伐罗
ناۋرۇلۇقلار	瑙鲁人
ناۋىگاتسىيە	航行学
نوئۇمېئىت	硅镁镍矿
نوئۇمېنالىزم	本体主义
نوتوبىئوتا	择生生物
نودوسائۇر	结节龙
نوربورنان	降冰片烷
نوربېرگىت	块硅镁石
نورترىپتىلىن	去甲替林
نورتۇمبېرلىقلار	诺森伯人
نوردماركىت	锰十字石
نوردېنسكيولدىن	硼钙锡矿
نورلاندۇرغۇچ	起放器
نورلېئۇتسىن	正白氨酸
نورمالىزېر	正规化子
نورماندىلىقلار	诺曼底人
نورمىسىز	无限额
نورنىكوتىن	降烟碱
نورۋالىن	原缬氨酸
نورۋېگىيىلىكلەر	挪威人
نورېتىندرون	炔诺酮
نوزېلىت	黝方石
نوسكاپىن	诺斯卡品
نوفوگراف	云摄影机
نوكتىلۇتسىن	夜光素
نومولوگىيە	法则学
نوموگرامما	诺模图
نوموگېنېز	恒定发生
نومۇرلىغۇچ	编号机
نوناگىدرات	九水合物
نونتل	九重线
نوندۇئالىزم	不二论
نونۇپلېت	九连音
نويابر	十一月
نوپىنېن	诺蒎烯
نوپۇسشناسلىق	人口学
نوگالامىتسىن	诺加霉素
نوۋوبىئوتسىن	新生霉素
نوۋوكائىن	奴佛卡因
نىئاسلار	尼亚斯人
نىئورولار	尼奥罗人
نىئېللىست	乌银匠
نىتراتىن	钠硝石
نىترادىن	磺乐灵
نىتروئۇرېيە	硝基脲
نىتروبارىت	钡硝石
نىتروبېنزوخىنون	硝基苯醌
نىترودېكسترىن	硝化糊精
نىتروزامىن	亚硝胺
نىتروزوباكتېرىيە	亚硝酸菌
نىتروفېنول	硝基苯酚
نىتروكالتسىت	钙硝石
نىتروكراخمال	硝化淀粉
نىترولاشتۇرۇش	亚硝化
نىترولېۋۇلوزا	硝化果糖
نىتروماگنېزىت	镁硝石
نىترومېتان	硝基甲烷
نىترومېتىر	测氮管
نىتروگلىتسېرىن	硝化甘油
نىتروگلىكول	硝化甘醇
نىتروگلۇكوزا	硝化葡糖
نىتروگىدروكاربون	硝基烃
نىتروگېنازا	定氮酶
نىترىد	氮化物
نىتسېئالار	尼西亚人
نىتومېتر	尼特计
نىخروم	镍克罗
نىدۇلىت	小巢石
نىزىن	乳酸菌素
نىسىن	尼生素
نىسپىيلەشتۈرۈش	相对化
نىسپىيىلىك	相对性
نىسپىيچىلىك	相对主义
نىشادالار	尼沙达人
نىشانسىز	漫无目标
نىشانلىغۇچ	照准器
نىقابسىز	无屏蔽
نىقاپ	蒙面纱
نىكتىناستىيە	感夜性
نىككولىت	红砷镍矿
نىكوتىنامىد	烟酰胺
نىكول	尼科耳
نىكېلات	镍酸盐
نىكېلوتسېن	二茂镍
نىلومېتىر	水位计
نىمكەش	半新半旧
نىنگىدرىن	茚满三酮
نىنېۋىتلار	尼尼韦人
نىگرومېتر	黑度计
نىگرىن	铁金红石
نىگېرىت	锡铝矿
نىھزار	牛角花
نىۋېلېر	水准仪
نىۋېنىت	钇铀矿
نيايا	正理派
نيۇئاركتىكا	新北界
نيۇئېلىقلار	纽埃人
نيۇبېرىئىت	镁磷石
نيۇكوم	纽科姆
نيېتشېئانىزم	尼采主义
نگۋاتولار	恩瓜托人
نۆكچىچى	出锭工
نۇبىيەلەر	努比亚人
نۇدالار	无触手纲
نۇدىزم	裸体主义
نۇسايرىلار	努赛里人
نۇسخىئالغۇ	复印机
نۇسفېرا	智能圈
نۇقسانسىزلىق	天衣无缝
نۇكلېئوتىد	核苷酸
نۇكلېئوتىدازا	核苷酸酶
نۇكلېئوزىدازا	核苷酶
نۇكلېئوكاپسىد	核衣壳
نۇكلېئونىكا	核子学
نۇكلېئونىي	核子素
نۇكلېئوپروتامىن	核精蛋白
نۇكلېئوپروتېئىن	核蛋白
نۇكلېئوگىستون	核组蛋白
نۇمېرولوگ	数灵学家
نۇمېرولوگىيە	数灵学
نېئوتوتسىت	水锰辉石
نېئوتېنىن	幼稚素
نېئوستىگمىن	新斯的明
نېئوسسولوگىيە	幼鸟学
نېئوسىئانىن	新花青
نېئولىگوخېتالار	异寡毛类
نېئومورف	新基因
نېئومىتسىن	新霉素
نېئونىخىئۇم	幼甲床
نېئوپالىنولوگىيە	新孢粉学
نېئوپىن	尼喔品
نېئوپېنتان	新戊烷
نېئوگامىيە	新配合
نېئوگېكسان	新己烷
نېئۇروسپورا	脉孢菌
نېبۇرون	草不隆
نېتروپسىن	纺锤菌素
نېرال	橙花醛
نېرول	橙花醇
نېرولىدول	橙花叔醇
نېرىيدا	海卫二
نېرۋون	神经苷酮
نېرۋىللار	内尔维人
نېرۋىن	健神剂
نېستورىئانىزم	景教教义
نېفروتوكسىن	肾毒素
نېفرولوگىيە	肾脏病学
نېفرولىزىن	溶肾素
نېفوسكوپ	测云仪
نېفومېتىر	测云器
نېفىتلار	莱希人
نېفېلومېتر	混浊度表
نېفېلوگنوزىيە	测云学
نېكروتوكسىن	坏死毒素
نېكروزىن	坏死素
نېكروفىلىزم	恋尸行为
نېماتوتسىست	刺丝囊
نېماتوزوئوئىد	线形个体
نېماتولوگىيە	线虫学
نېماتوگون	刺丝子
نېمالىت	纤水镁石
نېيتېر	中性个体
نېپتۇنىت	柱星叶石
نېپتۇنىزم	水成论
نېپتۇنىست	水成论者
نېگياگىت	叶碲矿
نېۋادالىقلار	内华达人
نېۋادىت	斑流岩
نېۋاركلىقلار	纽瓦克人
نېۋارلار	尼瓦尔人
نېۋروزوما	神经小体
نېۋروسىررۇس	神经阳茎
نېۋروكىنىن	神经激肽
نېۋرون	神经元
نېۋروگېن	神经原质
نېۋرىن	神经毒碱
نېۋفۇندلاندلىقلار	纽芬兰人
نېۋمانىزم	纽曼主义
نېۋيانسكىت	亮铱锇矿
نەجدىلەر	内志人
نەزەرىيىلەشتۈرمەك	理论化
نەزەرىيىچى	理论家
نەسەبشۇناس	血统学家
نەقلەشتۈرگۈچى	兑付员
نەملىشىشچانلىق	吸湿性
نەملىگۈچ	润湿器
نەملەشتۈرگۈچى	弄潮湿者
نەيچى	吹笛人
نەپدارلار	利益群体
نەپەسلەندۈرگۈچ	呼吸器
نەۋكەر	侍卫官
ياتروررىزىن	药根碱
ياراقلىق	吃得开
يارغۇرچاق	马推磨
ياروزىت	黄钾铁矾
يارىشالماسلىق	心有未甘
يارىمايدۇ	使不得
يارگۇن	黄锆石
يازغۇچىلىق	著述业
ياسمون	茉莉酮
ياسىئون	菊头桔梗
ياشلار	小字辈
ياشلىقشۇناسلىق	青年学
ياشمان	亚什馒
ياغاق	皮板儿
ياغاچلىشىش	木质化
ياقىتاش	边缘石华
ياقۇتلار	雅库特人
ياكانلار	雅坎人
يالاپىن	药喇叭脂
يالتىراتقۇچ	研磨器
يالتىراقلاشتۇرماق	闪光化
ياللانغۇچى	受雇人
يالپاقلىغۇچ	切片器
ياماراجا	阎罗王
ياماسىلار	雅马西人
ياماقچىلىق	缝缝连连
يامايكىلىقلار	牙买加人
يانالار	雅纳人
يانسكى	央斯基
يانىزارى	雅尼塞里
يانچىدار	农奴主
ياپلىقلار	雅浦人
ياپما	压普麻
ياپونىزم	日本特性
ياپونپەرەس	亲日分子
ياپىر	好家伙
ياپىگىلار	雅皮加人
ياپېشلار	雅皮士
ياۋروپالىقلار	欧洲人
ياۋۇزقىلىق	野蛮行为
ياۋۇزلارچە	恶狠狠
يوبدان	玉不丹
يوخىمبىن	育亨宾
يودفېنفوس	碘硫磷
يودوئازىد	叠氮化碘
يودوبېنزېن	碘代苯
يودوزوبېنزېن	亚碘酰苯
يودوفتالېين	碘酚酞
يودوفور	碘载体
يودومېركۇرات	碘汞酸盐
يودونىي	碘湩鲃
يودوپروتېئىن	碘蛋白
يودوپىراتسېت	碘吡啦啥
يودوگىدروكاربون	碘代烃
يودىدلار	碘化物
يوركشىرلىقلار	约克郡人
يوركلۇقلار	约克人
يورۇقلۇقشۇناس	光学家
يوقالماس	不可磨灭
يوكۇتسلار	约克茨人
يولكا	圣诞树
يوللىغۇچ	发送器
يوپۇرغا	镇压器
يوھاننىت	铀铜矾
يىدۇجىن	伊豆锦
يىغقۇچ	收集器
يىغقۇچى	召集人
يىغلىغۇچى	哭泣者
يىغىنچاقلىنىشچانلىق	可归约性
يىلانسىمان	似蛇地
يىلانگۈل	蛇鞭柱
يىلتىزداشلىق	一脉相承
يىلقىچى	养马人
يىلىم	交合剂
يىڭنىمىخ	大头针
يۆتكىلىشچان	移动性
يۆتكىلىشچانلىق	转移性
يۆتكىگۈچ	转移器
يۆنىلىشچانلىق	指向性
يۆگىمەي	田旋花
يۆگەك	婴儿包毯
يۇتازا	油沓子
يۇتالىقلار	犹他人
يۇتۇشچانلىق	吸收率
يۇراكلار	尤拉克人
يۇروكلار	尤罗克人
يۇرۇنالار	尤鲁纳人
يۇغۇچى	洗涤者
يۇقۇملانغۇچ	感染者
يۇقۇملىنىشچانلىق	侵染性
يۇقۇمچانلىق	传染性
يۇكونلۇقلار	育空人
يۇمشاققىنا	软绵绵
يۇمۇقلۇق	闭合性
يۇنانشۇناس	希腊学家
يۇيۇلۇشچانلىق	可洗性
يۇگاۋارالىت	汤河原石
يۈرۈشلەشتۈرگۈچى	配套员
يۈرۈشۈشچانلىقى	流动性
يۈزدەك	百儿八十
يۈزەلىك	表面性
يۈزەلەشتۈرمەك	表面化
يۈكلىگۈچ	加载器
يۈننەنلىكلەر	云南人
يېراۋالار	耶拉瓦人
يېرىلغا	沙冬青
يېرېمېيېۋىت	硼铝石
يېزىقشۇناسلىق	文字学
يېزىلاشتۇرۇش	农村化
يېزىلىقلار	乡下人
يېسسمۇق	小扁豆
يېشىلىدىغانلىق	可解性
يېقىنلاشماسلىق	不亲和性
يېقىنلىشالىماق	可接近
يېقىنلىشىشچانلىق	可接近性
يېقىنلىقى	亲近性
يېنىسەيلىكلەر	叶尼塞人
يېيىلمىلىق	广廷性
يېيىلىشچانلىق	广延性
يېپتون	蛋白胨
يېپىشتۇرۇۋالغۇچ	吸附器
يېپىشىشچانلىقى	粘着性
يېڭىلىغۇچى	复兴者
يەتكۈزگۈچى	发送者
يەتكۈزۈشچانلىق	传递性
يەتمەيدۇ	还不如
يەتىكەن	天罡星
يەرلىكلىشىش	本地化
يەكدىللىك	一条心
يەككىلىك	形单影只
يەككىچىلىك	孤立主义
يەكلەشچانلىق	排趋性
يەكگۈل	独丽花
يەملىگۈچ	砖缝填料
يەمەنلىكلەر	也门人
پائالىيەتشۇناسلىق	行为学
پائالىيەتچى	活动家
پائالىيەتچىلىك	行为主义
پائىگېئىت	硼铁矿
پاتافىزىكا	超然科学
پاتالوگىيە	病理学
پاتانلار	帕坦人
پاترولوگىيە	神父学
پاترونىت	杂硫钒石
پاتسېماكېر	起博器
پاتقاقچىلىق	泥泞地
پاتودونتىيە	牙病学
پاتوكولار	帕托科人
پاتولوگ	病理学家
پاتومورفولوگىيە	病态学
پاتېرنوئىت	水硼镁石
پاخنولىت	霜晶石
پاخو	求神棒
پاخىتسېفالوزاۋر	肿头龙
پادىشاھسىزلىق	无君论
پادۇئالىقلار	帕多瓦人
پادۇكالار	帕都卡人
پارابلاست	副胚层
پارابىئوزىيە	并体结合
پارابىئونىت	连体生物
پاراتاكامىت	副氯铜矿
پاراتولۇئىدىن	对甲苯胺
پاراتىف	副伤寒
پاراتېرگىت	侧背片
پاراخروماتىن	副染色质
پاراخور	等张比容
پارادوكسولوگىيىچى	反论家
پارادىئازىن	对二嗪
پارادىخلوروبېنزېن	对二氯苯
پارادېسموزا	副连丝
پاراسىمبىئوزىيە	假共生
پاراسىناپسىس	平行联会
پاراشوت	降落伞
پاراشوكچى	搽粉工
پاراشىست	副片岩
پارافلوككۇلۇس	傍绒球
پارافورمالدېگىد	多聚甲醛
پارافىسوئىد	拟侧丝
پاراكوخىمبىت	紫铁矾
پاراكىنېزىيە	运动紊乱
پاراكۇزىيە	听觉倒错
پارالدول	聚醛醇
پاراللاگېئوسىنكلىن	海滨地槽
پاراللېلسىزلىق	不平行性
پاراللېللاشتۇرۇش	并行化
پاراللېلېپىپېد	长方体
پارالوگىزم	论理倒错
پاراماگنېت	顺磁体
پاراماگىنتلىق	顺磁性
پارامولېكۇلا	仲分子
پارامىكسوۋىرۇس	副粘病毒
پارامۇتاتسىيە	副突变
پارامېترون	参数器
پارامېتسىن	草履虫素
پارامېتىرلاشتۇرۇش	参数化
پارامېلاكونىت	锥黑铜矿
پاراپسىخولوگىيە	心灵学
پاراگاسترۇلا	副原肠胚
پاراگلىكوگېن	副糖原
پاراگنېز	副片麻岩
پاراگومولوگىيە	副同原性
پاراگوپېئىت	副磷锌矿
پاراگىپوفىز	副垂体
پاراگۇلا	侧外咽
پاراگۋايلىقلار	巴拉圭人
پاراگېموفىلىيە	副血友病
پاراۋولفرامات	仲钨酸盐
پاربولوئىد	抛物面
پارتلاتقۇچى	爆破手
پارتىئانلار	帕提亚人
پارتىتون	派对松
پارتىيىسىز	非党派
پارتۇرىئومېتر	分娩力计
پارتېنوسپورا	单性孢子
پارتېنوگامىيە	单性核配
پارسون	教区牧师
پارسېتتېنسىت	红硅锰矿
پارسېك	秒差距
پاركىيە	球花豆属
پارلامېنتارىزم	代议制
پارلاندۇرغۇچ	汽化器
پارمون	巴马酮
پارمېنىد	巴门尼德
پارناسسىئانىزم	高蹈主义
پاروئېمىئولوگىيە	谚语学
پارومومىتسىن	巴龙霉素
پارونىخىيە	甲沟炎
پارونىم	同音字
پارىئان	仿云石
پارىلېن	聚对二甲
پارىنول	苯吡醇
پارىژلىقلار	巴黎人
پارگازىت	韭闪石
پارگىلىن	优降宁
پارېئويلار	帕雷依人
پارېئىئازاۋر	巨颊龙
پارېستېزىيە	感觉异常
پارېنخىما	薄壁组织
پاس	轧钢孔道
پاسكال	帕斯卡
پاسكوئىت	橙钒钙石
پاسىلدىماق	轻脆声响
پاسىمولوگىيە	手语学
پاسىن	包身裙
پاسگۋارد	左肘甲
پاشىئوت	合叶子
پافۇسلۇقلار	帕福斯人
پاكتامىتسىن	密旋霉素
پاكسىللۇس	木桩菌
پاكومى	帕科米
پالائۇلۇقلار	帕劳人
پالائېئوفىل	好古者
پالاتىنلار	帕拉廷人
پالاس	蹭鞋垫
پالاكىئۇم	胶木属
پالاگونىت	橙玄玻璃
پالشوپكا	短大衣
پاللاد	巴拉德
پاللازىت	石铁陨星
پاللىيانلار	帕利扬人
پالماتىن	巴马亭
پالمىئېرىت	钾钠铅矾
پالمىزارلىق	棕榈园
پالىنولوگىيە	孢粉学
پالىگورسكىت	坡缕石
پالۇدرىن	百乐君
پالېئاركتىكا	古北界
پالېئوئامېرىكانلار	古美洲人
پالېئوئانتروپولوگىيە	古人类学
پالېئوئاگروستولوگىيە	古禾草学
پالېئوئىخنولوگىيە	古遗迹学
پالېئوئېكولوگىيە	古生态学
پالېئوئېنتومولوگىيە	古昆虫学
پالېئوبوتانىكا	古植物学
پالېئوتالامۇس	古花托
پالېئوتوپوگرافىيە	古地形
پالېئوتىئولوگىيە	古因果论
پالېئوتىپوگرافىيە	古印刷术
پالېئوتېمپېراتۇرا	古温度
پالېئودېندرولوگىيە	古树木学
پالېئوزوئولوگىيە	古动物学
پالېئوسترىئاتۇم	旧纹状体
پالېئوسېرېبېللۇم	旧小脑
پالېئوكىلىمات	古气候
پالېئولوگىيە	古物学
پالېئولىمنولوگىيە	古湖沼学
پالېئوماگنېتىكا	古地磁学
پالېئوماگىنىتلىق	古磁性
پالېئوماگىنىتىزم	古磁学
پالېئوپېدولوگىيە	古土壤学
پالېئوگرافىيە	古文字学
پالېئوگېئولوگىيە	古地质学
پالېئوگېئومورفولوگىيە	古地貌学
پالېئوگېنېتىكا	古遗传学
پالېئوھىدرولوگىيە	古水文学
پالېئىختىئولوگىيە	古鱼类学
پالېئېتنولوگىيە	古人种学
پالېرمىتانلار	巴勒莫人
پامابروم	柏马溴
پاماخىن	扑疟喹
پامپانگا	邦板牙
پاناتېنائىيە	祭神庆典
پانادول	扑热息痛
پانامالىقلار	巴拿马人
پاناھسىز	生活无着
پاناھلانغۇچى	受助人员
پاناھگاھ	救助站
پانتوبازا	全能起落
پانتوخرومىزم	泛色性
پانتوگرافچى	缩放员
پانتېئىست	泛神论者
پانتېرىزم	黑豹主义
پانتېللېرىت	碱流岩
پانتېلىزم	泛意志论
پانتېنول	泛酰醇
پانداكا	半托梵
پانروھچىلىق	泛心论
پانكرېئاتىت	胰腺炎
پانكرېئاتېكتومىيە	胰切除术
پانكرېئوزىمىن	促胰酶素
پانلوگىزم	泛理论
پانمىتسىن	盘霉素
پانمېرىزم	泛生论
پانىئانلار	帕尼安人
پانپلاناتسىيە	溶夷作用
پانۇسگۇل	吊灯花
پايدىلىقلىق	有用性
پايدىپەرەسلىك	营利主义
پاپاۋېرىن	罂粟碱
پاپوروتنىكسىمانلار	拟蕨类
پاپىلىق	矮小畸形
پاپۇئا	巴布亚
پاپۇئاسلار	巴布亚人
پاگانىزم	异教气质
پاۋلوسپورا	休眠子
پاۋلوۋ	巴甫洛夫
پاۋلىنىزم	保罗教
پاۋلىنىست	保罗信
پاۋلىنگىت	方碱沸石
پتولېمېي	托勒蜜
پتومائىن	肉毒胺
پتىگما	肠状体
پتېروداكتىل	翼手龙
پتېرىلولوگىيە	羽序学
پتېرىلوگرافىيە	羽毛学
پراتول	普拉脑
پرامىدا	角锥体
پراگماتىكا	语用学
پرساۋسەن	铁线蕨
پروئۇستىت	淡红银矿
پروئېتىكا	先伦理学
پروبابىلىئورىزم	惑然论
پروبابىلىئورىست	惑然论者
پروبابىلىزم	盖然论
پروبان	普鲁班
پروبېرتىت	硼钠钙石
پروبېنېتسىد	丙磺舒
پروتامىن	鱼精蛋白
پروتاگون	初磷脂
پروتوئېنستاتىت	原顽辉石
پروتوبازىدىيە	原担子
پروتوخلوروفىل	原叶绿素
پروتوزوئا	原生动物
پروتوكاتېخۇئالدېگىد	原儿茶醛
پروتوكورم	原胚体
پروتوكۋارتىزىت	原石英岩
پروتونىمفا	原若虫
پروتونىي	质子素
پروتوپلازما	原生质
پروتوپلاست	原生质体
پروتوپورفىرىن	原卟啉
پروتوپىن	前鸦片碱
پروتوپېرىتېتسىي	子囊壳原
پروتوپېكتىن	原果胶
پروتوپېكتىنازا	原果胶酶
پروتوگالاكسىيە	原星系
پروتوگېنېز	原始发生
پروتوۋېراترىن	原藜芦碱
پروتىد	蛋白类
پروتېئوكارب	胺丙威
پروتېئولىپىد	蛋白脂体
پروتېئوپلاست	类蛋白体
پروتېئوگلىكان	蛋白多糖
پروتېئىن	蛋白质
پروتېئىنات	蛋白盐
پروتېئىنازا	蛋白酶
پروتېئىنوئىد	类蛋白质
پروتېئۇس	变形杆菌
پروتېستانت	新教徒
پروتېستانتلاشماق	新教化
پروتېكتوسكوپ	掩望镜
پروخروموزوما	前染色体
پرودىگىئوزىن	灵菌素
پروزودىيە	诗体学
پروزىموگېن	前酶原
پروستاگلاندىن	前列腺素
پروستېزىيە	词首添音
پروسودىئون	进坛赞歌
پروسوپىت	水铝氟石
پروسىللوگىزم	前三段论
پروسپورىلىق	前孢性
پروسۇسپېنزور	原胚柄
پروفام	苯胺灵
پروفلاۋىن	副核黄素
پروفلۇرالىن	卡乐施
پروفىروبلاست	斑状变晶
پروكائىن	普鲁卡因
پروكتولوگىيە	直肠病学
پروكسان	扑灭生
پروكوئاگۇلانت	前凝血剂
پروكۇراتور	检察官
پروكۇرور	检察员
پرولىل	脯氨酰
پرولېتارىيات	无产阶级
پرومازىن	普马嗪
پرومورفولوگىيە	原形学
پرومىتسېللۇم	原菌丝
پرومىللې	千分率
پرومېتازىن	异丙嗪
پرومېترىن	扑草净
پرومېتون	扑灭通
پرومېكارب	猛杀威
پرونامىد	拿草特
پرونتوزىل	百浪多息
پرونىمفا	预若虫
پرونېتالول	萘心定
پرويېكتىۋلىق	投影性
پرويېكسىيىلىگۈچ	投影器
پروپاخلور	毒草安
پروپارگىت	克螨特
پروپارگىل	丙炔基
پروپازىن	扑灭津
پروپانسىزلاشتۇرۇش	丙烷脱除
پروپرانولول	心得安
پروپلازتىد	前质体
پروپورتسىيە	单比例
پروپوكسى	丙氧基
پروپىئولاكتون	丙内酯
پروپىئونات	丙酸盐
پروپىئونىل	丙酰基
پروپىئونىلات	丙酰化
پروپىلىت	绿盘岩
پروپېردىن	备解素
پروپېللانتلار	推进剂
پروپېنىل	丙烯基
پروگامېتا	原配子
پروگراممىلاشتۇرۇش	程序化
پروگرېسسىئونىست	进论者
پروگرېسسىۋىزم	进主义
پروگونېئاتالار	前门类
پروگېستىن	孕激素
پروگېستېرون	黄体酮
پروگېنىتور	祖先形体
پروگېنېز	前生殖
پروۋىتامىن	维生素原
پروۋىتراين	粗镜煤
پرىئورىت	钇易解石
پرىبورلاشتۇرماق	仪表化
پرىبول	辉闪石类
پرىتسېئىت	白硼钙石
پرىماتلار	灵长目
پرىماتولوگىيە	灵长类学
پرىماخىنون	伯氨喹啉
پرىمۇلاۋېرىن	樱草根苷
پرىمېۋېروزا	樱草糖
پرىمېۋېرىن	樱草苷
پرىناخلور	广草胺
پرىنتېگرامما	印字电报
پرىنسىپسىز	反复无常
پرىنسىپسىزلىق	无原则
پرۇبكا	气孔塞
پرۇدېنتىئالىزم	谨慎主义
پرۇسسىيىلىكلەر	普鲁士人
پرۇلاۋرازىن	桂樱苷
پرۇنازا	洋李酶
پرۇنازىن	稠李苷
پرۇنىترىن	洋李春
پرۇنېتىن	洋李亭
پرېئانىمىزم	前泛灵论
پرېئېكسىستېنتىزم	先在论
پرېتسىپىتىن	沉淀素
پرېخنىت	葡萄石
پرېداتىزم	掠食性
پرېدنىزولون	泼尼松龙
پرېدېتېرمىنىزم	先决论
پرېزوما	前体干
پرېزومىت	前体节
پرېسبىتېرىئاللىق	长老会
پرېستابىلىزم	前定和谐
پرېفېرېنتسىئالىزم	优惠主义
پرېپلاستىكاتسىيە	预塑炼
پرېپولىمېر	预聚物
پرېگناندىئول	孕二醇
پرېگنىتېن	连四甲
پرېگنېنولون	孕烯醇酮
پرېۋىتامىن	前维生素
پشاۋلار	普沙夫人
پلاتنېرىت	块黑铅矿
پلاتىنامىن	铂氨络物
پلازمالوگېن	缩醛磷酯
پلازمودېسما	胞间连丝
پلازمولىز	胞质皱缩
پلازمىن	胞浆素
پلاسترون	拒水膜
پلاستونېما	质体丝
پلاستوگېن	质体基因
پلاستىتسىزم	造型学
پلاستىتسىمېتر	塑性计
پلاستىتسىن	蜡泥塑料
پلاستىدوما	质体系
پلاستىدۇلا	原生粒
پلاستىزول	塑料溶胶
پلاستىكلاشتۇرغۇچ	增塑剂
پلاستىكلىشىش	塑性化
پلاستېلىن	蜡泥料
پلاك	普莱克
پلاناتسىيە	均夷作用
پلانتۇلا	爪垫叶
پلانخېئىت	纤硅铜矿
پلانوسپورا	游走孢子
پلانومېتىر	测平仪
پلانومېتىرىيە	测平法
پلانوگامېتا	游走配子
پلانۇلا	浮浪幼体
پلانېتارىيە	天象仪
پلانېتولوگىيە	行星学
پلاگىئوتروپىزم	斜向地性
پلاگىئوستومىلار	横口类
پلاگىئوفوتوتاكسىيە	斜趋光性
پلاگىئوگراف	斜缩放仪
پلوددېر	蜗压机
پليۇرالىست	多元论者
پليۇۋىئوگراف	雨量计
پلۇتونىست	火成论者
پلۇمبات	铅酸盐
پلۇمبوفېررىت	铅铁矿
پلۇمبونىئوبىت	铅铌铁矿
پلۇمبوياروزىت	铅铁矾
پلۇمبىت	亚铅酸盐
پلۇمىئېرىد	鸡蛋花苷
پلۇمۇليارىيە	海榧属
پلۇگگېر	充填器
پلۇۋىئومېترىيە	量雨学
پلېئومورفىزم	多型现象
پلېئىئوتروپىيە	多效性
پلېئىئون	正距平区
پلېئۇروتوتونوس	侧弓反张
پلېروما	中柱原
پلېززىت	合纹石
پلېزىئوئاستېر	近星体
پلېسىئوزاۋر	蛇颈龙
پلېكتوسېراس	褶菊石
پلېۋروسېنترۇم	侧椎体
پلېۋروپنېۋمونىيە	胸膜肺炎
پلېۋرىت	胸膜炎
پنىخروگراف	干湿计
پنىخوئاكۇستىكا	心理声学
پنىخوئانالىز	心理分析
پنىخوئىستورىيە	心理史
پنىخوتاكسىس	心理整复
پنىخوتېخنىكا	心理技术
پنىخوتېراپىيە	心理疗法
پنىخوزوماتىكا	心身医学
پنىخوسكوپ	精神仪
پنىخوفوبىيە	心理恐怖
پنىخولوگ	心理学者
پنىخولوگىيىلەشتۈرۈش	心理学化
پنىخوماخىيە	心理冲突
پنىخومورفىزم	精神归属
پنىخوپاتالوگىيە	变态心理
پنىلوتسىبىن	裸盖碱
پنىلوتسىن	裸盖素
پنىلومېلان	硬锰矿
پنېفولوگىيە	选举学
پنېۋدوجېرۋىن	拟藜芦碱
پنېۋدورېدۇكسىيە	拟减数
پنېۋدوسفېرا	伪球面
پنېۋدوسكوپ	幻视镜
پنېۋدوكوتۇننىت	钾氯铅矿
پنېۋدوكېراتىن	拟角蛋白
پنېۋدوپتىكا	幻视光学
پنېۋدوپۇرپۇرىن	假红紫素
پنېۋماتوفورا	气囊体
پنېۋماتولوگىست	圣灵论者
پنېۋماتوگرافىيە	圣灵记
پنېۋماتىزم	圣灵论
پنېۋماتىكا	气体力学
پنېۋموئېنسېفالوگرامما	气脑照片
پنېۋمولوگىيە	肺病学
پنېۋموپېرىكاردىيە	心包积气
پوئىدومېتىر	称重计
پوئىكىلوبلاست	变嵌晶
پوئېزىيە	诗情画意
پوتارىت	钯汞膏
پوتېنسئومېتىر	电位计
پوتېنسىئوستات	稳压器
پوتېنسىئومېترىيە	电势计术
پودودېرما	蹄皮层
پودوفتالمىيىلەر	有眼柄类
پودوفىللوتوكسىن	鬼臼毒
پودوفىللىن	鬼臼树脂
پورتسېلائىنىت	白陶岩
پورتسېللانىت	瓷状岩
پورتلاندلىقلار	波特兰人
پورتلاندىت	羟钙石
پورفىروئىد	残斑岩
پورفىروكسىن	鸦片碱
پورفىرى	波菲里
پوروزىمېتر	孔率计
پورومېتر	气孔计
پوزنانلىقلار	波兹南人
پوزىترون	正电子
پوزىترىنو	正微子
پوستدوكتور	博士后
پوستلاقخور	小蠹虫
پوستىپوفىز	垂体后叶
پوستۇلياتور	呈请人
پوققورساق	窝囊废
پوككېلس	普克尔斯
پوكېرىزم	朴克作风
پولابلار	波拉布人
پولابىلار	波拉比人
پولاتلاشتۇرماق	进行钢化
پولخودا	本体极迹
پولزۇنوپ	伯祖诺夫
پوللۇتسىت	铯榴石
پوللۇكس	北河三
پولىئارخىيە	多头政治
پولىئاكرىلونىترىل	聚丙烯腈
پولىئالكان	聚链烷
پولىئاندرىيە	一妻多夫
پولىئانىت	黝锰矿
پولىئود	多极管
پولىئىزوبۇتىلېن	聚异丁烯
پولىئىمىد	聚酰亚胺
پولىئېستىرلاشتۇرۇش	聚酯化
پولىئېلېكترولىت	聚电解质
پولىبۇتادىئېن	聚丁二烯
پولىتېئىزم	多神论
پولىتېئىست	多神论者
پولىتېرپېن	聚萜烯
پولىخروئىزم	多向色性
پولىخرومات	多铬酸盐
پولىدىمىت	辉镍矿
پولىسىلوكسان	聚硅氧烷
پولىفاگىزم	多食性
پولىفوسفات	聚磷酸盐
پولىفون	百音盒
پولىفونىيە	复调音乐
پولىفىلېتىزم	多元主义
پولىكاربونات	聚碳酸酯
پولىكرازا	复稀金矿
پولىمولىبدات	多钼酸盐
پولىمىكسىن	多粘菌素
پولىمىمىگنىت	铌铈钇矿
پولىمىېرلىنىش	聚合作用
پولىمېتر	多测计
پولىمېترىيە	多格律
پولىمېر	聚合物
پولىمېرازا	聚合酶
پولىمېرلىق	等效异位
پولىنۇكلېئوتىد	多核苷酸
پولىنېۋروفاتىيە	多神经病
پولىنېۋرىت	多神经炎
پولىپروپىلېن	聚丙烯
پولىپلار	水螅类
پولىپلوئىدوگېن	多倍体原
پولىگارمونىيە	复和声
پولىگالىت	杂卤石
پولىگالىتول	远志糖醇
پولىگالىد	多卤化物
پولىگامىيە	一夫多妻
پولىگرافىست	复写员
پولىگولومېترىيە	导线测量
پولىگىرىيە	多脑回
پوليارون	极化子
پولياروگرافىيە	极谱法
پوليارىتون	电磁声子
پوليارىمېتر	偏光计
پولۇفېن	巴鲁芬
پولەكلەشتۈرۈش	波兰化
پومولار	波莫人
پومپېيىلىكلەر	庞贝人
پومېرون	坡密子
پوناپېئانلار	波纳佩人
پونتوكائىن	本多卡因
پوندولار	庞多人
پونېرولوگىيە	恶行神学
پويىنتىڭ	坡印亭
پوپوپ	波波夫
پوپۇلىن	白杨苷
پوچتاليون	邮递员
پوچتىكەش	投递员
پوچېركىشۇناسلىق	笔迹学
پوگونوفورالار	须腕动物
پوگونولوگىيە	胡须学
پوۋىنداھ	波文达
پوۋېسىت	中篇小说
پوۋېللىت	钼钨钙矿
پىئانولا	自动钢琴
پىئوكسانتوزا	绿脓黄质
پىئېزورئېلېكتر	压电学
پىئېزورقارشىلىق	压电电阻
پىئېمونتىت	红帘石
پىتتسبۇرگلۇقلار	匹兹堡人
پىتتىتسىت	土砷铁矾
پىتسېئىن	云杉素
پىتومېتر	皮托计
پىتونومورفلار	海蟒型类
پىتىئانلار	德尔裴人
پىتېكولوگىيە	猿类学
پىجىگەن	皮极甘
پىراتسېن	匹拉省
پىرازوفوس	定菌磷
پىرازوللار	吡唑类
پىرازولون	吡唑啉酮
پىرازولىل	吡唑基
پىرازولىن	吡唑啉
پىرازون	杀草敏
پىرازىنامىد	吡嗪酰胺
پىراكاربولىد	比锈灵
پىرالىن	派雷林
پىرانوزا	吡喃糖
پىرانوزىد	吡喃苷
پىرانىل	吡喃基
پىررولىدون	吡咯烷酮
پىررولىدىل	吡咯烷基
پىررولىدىن	吡咯烷
پىررولىن	吡咯啉
پىررىل	吡咯基
پىرسسونىت	钙水碱
پىروئائۇرىت	鳞镁铁矿
پىروخروئىت	羟锰矿
پىروخلور	烧绿石
پىروستىلپنىت	火红银矿
پىروسكوپ	高温仪
پىروسمالىت	热臭石
پىروسۇلفات	焦硫酸盐
پىروسۇلفۇرىل	焦硫酰
پىروسېللۇلوزا	焦纤维素
پىروفوسفات	焦磷酸盐
پىروفوسفاتازا	焦磷酸酶
پىروفىللىت	叶蜡石
پىروكاتېخول	焦儿茶酚
پىروكسىلىن	焦木素
پىروكسېنوئىد	似辉石
پىروكوللودىئون	焦珂罗酊
پىرولىگنىت	焦木酸盐
پىرولۇزىت	软锰矿
پىروموتور	热动机
پىرومېتاللورگىيە	火法冶金
پىرومېتر	高温计
پىروپ	镁铝榴石
پىروپورفىرىن	焦卟啉
پىروگاللول	焦棓酚
پىروگلوبۇلىن	热球蛋白
پىرىت	黄铁矿
پىرىتوبىتۇمېن	火成沥青
پىرىمىدىل	嘧啶基
پىرىمېتامىن	乙嘧啶
پىرۇۋالدېگىد	丙酮醛
پىرېترىن	除虫菊酯
پىرېنىن	核仁素
پىسالىقلار	皮萨人
پىسانىت	铜绿矾
پىستولوگىيە	信仰学
پىسخولوگىيە	心理学
پىسېنىلىقلار	皮森尼人
پىسەن	皮三瓜
پىشاڭچى	橇运工
پىششىقلىق	小家子气
پىكاردلار	皮卡德人
پىكتلار	皮科特人
پىكتوگراف	象形字
پىكراتول	比克拉托
پىكراسمىن	苦树素
پىكروتوكسىن	苦毒素
پىكروتوكسىنىن	苦毒宁
پىكروفارماكولىت	镁毒石
پىكروكروتسىن	苦藏花素
پىكرومېرىت	软钾镁矾
پىكروپودوفىللىن	鬼桕苦素
پىكلورام	毒莠定
پىكنومېتىر	比重瓶
پىكنىئوسپورا	性孢子
پىكنىت	圆柱黄晶
پىكوتى	荷兰石竹
پىكوتىت	铬尖晶石
پىكوس	橡皮树
پىكولىن	皮考啉
پىكېرىنگىت	镁明矾
پىلانلاشتۇرۇش	计划化
پىلاۋ	肉菜烩饭
پىلسىرات	鬼门关
پىلموت	机关枪
پىلموتچى	机关枪手
پىمارىتسىن	多马霉素
پىمانترېن	海松烯
پىناتا	彩饰陶罐
پىناتسىئانول	频哪氰醇
پىناخروما	松色素
پىناكولون	频哪酮
پىناكىئولىت	硼镁锰矿
پىناۋېردول	平纳沃德
پىنتادوئىت	钙钒华
پىننا	江珧科
پىننوئىت	柱硼镁石
پىننېر	垂沿女帽
پىنوزوما	胞饮体
پىنوكامفون	蒎莰酮
پىنوكامفېئول	蒎莰醇
پىنوگلىكول	蒎脑二醇
پىيزەكلىك	藨草地
پىپىللار	皮比尔人
پىپېروكسان	哌扑罗生
پىپېرونال	胡椒醛
پىپېرونىل	胡椒基
پىپېرىتون	胡椒酮
پىپېرىن	胡椒碱
پىچاقچى	制造刀匠
پىچى	小犰狳
پىگمالىئونىزم	爱雕像癖
پىگمىلار	俾格米人
پىگېئونىت	易变辉石
پيېزوخىمىيە	压力化学
پيېزوكرىستال	压电晶体
پيېزومېتر	压强计
پيېمىيە	腐血症
پۆرىچى	馅饼师傅
پۆپۈكئوت	缨丝草
پۇتسىزلار	无足类
پۇتلۇقلار	有足类
پۇختىلىقلىق	严密性
پۇراقلىق	有味道
پۇرانا	往世书
پۇرسەتچانلىق	时机性
پۇرومىتسىن	嘌呤霉素
پۇرپۇروكسانتىن	红紫黄质
پۇرپۇرىن	红紫素
پۇشقۇرماق	打响鼻
پۇشۇلداش	鼻息声
پۇقراشۇناسلىق	公民学
پۇقرالارئاۋىئاتىسيىسى	民用航空
پۇكاتېئىن	蒲卡特因
پۇلاڭشىماق	悠悠荡荡
پۇلسار	脉冲星
پۇلسومېتر	气压泵
پۇلسىمېتر	脉冲计
پۇلسېر	脉冲器
پۇلىتسىد	灭蚤剂
پۇنالىقلار	普纳人
پۇنالۇئا	普那路亚
پۇنگاپۇڭ	钟苞魔芋
پۈتۈنسىزلىك	非整合
پۈركۈگۈچى	喷洒者
پۈرمىلىگۈچ	卷边器
پېئونىدىن	芍药配基
پېئونىن	芍药精
پېئىللاشتۇرۇش	动词化
پېئېلىت	皮尔分子
پېبۇلات	克草锰
پېتالىت	透锂长石
پېتروخىمىيە	岩石化学
پېتروفابرىكا	岩组学
پېتروكسولىن	石蜡药膏
پېترولوگ	岩石学家
پېترولوگىيە	岩石学
پېتروگرافىيە	岩类学
پېترىنىزم	彼得教
پېترۇشكا	香芹菜
پېتىدىن	陪替丁
پېتىرمانتا	薄皮包子
پېتىرنان	死面馕
پېتىرى	佩特尔
پېتۇنىيە	碧冬茄
پېدالىئېر	脚踏键盘
پېداگوگىيە	教育学
پېدوباپتىزم	婴儿洗礼
پېدوسفېرا	土壤圈
پېدومورفوز	童态构成
پېدومورفىزم	幼稚形态
پېدوگامىيە	幼体配合
پېدوگېنېز	幼体生殖
پېدىلانتۇس	红誉珊瑚
پېدېستال	轴箱导框
پېرازىن	甲哌丙嗪
پېربوراتلار	过硼酸盐
پېرتسېپسىيە	心理印象
پېرتىت	条纹长石
پېرخروماتلار	过铬酸盐
پېرخلوروئېتىلېن	全氯乙烯
پېررادىئۇس	正辐管
پېرسورپسىيە	吸混作用
پېرسون	皮尔孙
پېرسونالىزم	人格主义
پېرسپېكتىۋلىق	透视性
پېرسۇلفات	硫酸高盐
پېرسېئىتول	鳄梨糖醇
پېرفتورلىشىش	全氟化
پېرفېنازىن	奋乃静
پېركرىستاللىزاتسىيە	透析结晶
پېركنوزوما	深染粒
پېركولاتور	渗滤器
پېركولياتسىيە	穿流法
پېرم	彼尔姆
پېرماللوي	透磁核金
پېرمىك	彼尔姆系
پېرمياكلار	彼尔姆人
پېرمۇتوئىد	交换体
پېرمۇتىت	软水砂
پېرمېئازا	透性酶
پېرمېئامېتر	渗漏计
پېرنىت	辉闪岩类
پېروكسىدازا	过氧化酶
پېرولېن	佩洛林
پېرونىزم	庇隆主义
پېروۋسكىت	钙钛矿
پېرىئودونتىكا	牙周病学
پېرىبلاست	表胎层
پېرىتېلىئوما	周皮瘤
پېرىدوتىت	橄榄岩
پېرىستوما	孢蒴齿
پېرىسىكل	中柱鞘
پېرىسىكلون	气旋周环
پېرىفىتونلار	周丛生物
پېرىفېرالىزم	外周论
پېرىكاردىت	心包炎
پېرىكاردىيە	心包络
پېرىكاريون	核周体
پېرىپلازمودىي	周质团
پېرىگلاتسىئولوگىيە	冰缘学
پېرىگونىي	围生殖囊
پېريودىدلار	高碘化物
پېرپېتۇئالىزم	永恒主义
پېرگالىد	全卤化物
پېرگولا	透空廊道
پېرگىدرول	强双氧水
پېرگىنىي	雌器苞
پېرھىدروگېنلاشتۇرۇش	全氢化
پېرۇلۇقلار	秘鲁人
پېرۇگىيىلىكلەر	佩鲁贾人
پېستولوگىيە	瘟疫学
پېسەندە	下等人
پېكتولىت	针钠钙石
پېكتىنازا	果胶酶
پېلتيې	珀耳帖
پېلسپارىت	泥晶灰岩
پېللوتىن	佩落亭
پېللېتىئېرىن	石榴碱
پېلىكوزاۋرلار	盘龙类
پېمولىن	匹吗啉
پېنتائامىنوبېنزېن	苯五胺
پېنتائېرىترىتول	季戊四醇
پېنتابوران	戊硼烷
پېنتاترىئاكونتان	三十五烷
پېنتاخلوروئېتان	五氯乙烷
پېنتاخلوروفېنول	五氯苯酚
پېنتاخلورىد	五氯化物
پېنتاخىن	五喹啉
پېنتادىئېن	戊二烯
پېنتادېتسىل	十五烷基
پېنتادېكان	十五烷
پېنتازوتسىن	镇痛新
پېنتاسۇلفىد	五硫化物
پېنتافلاكس	五列木
پېنتاكاربونىل	五羰基
پېنتاكوسان	二十五烷
پېنتاكونتان	五十烷
پېنتاممىن	五氨络物
پېنتامىدىن	戊双脒
پېنتامېرىد	五房贝
پېنتاندىئون	戊二酮
پېنتاگىدرات	五水合物
پېنتاگىدرىت	五水泻盐
پېنتلاندىت	镍黄铁矿
پېنتوئات	稻丰散
پېنتوتال	喷妥撒
پېنتود	五极管
پېنتوزان	戊聚糖
پېنتوزىد	戊糖苷
پېنتوزۇرىيە	戊糖尿
پېنتوكسىد	五氧化物
پېنتولىت	彭托利特
پېنتىل	戊烷基
پېنتىلىدېن	亚戊基
پېنتۇلوزا	戊酮糖
پېنتېنىل	戊烯基
پېنروزېئىت	硒铜镍矿
پېنسىيە	养恤金
پېنسېس	九便士
پېنفيېلدىت	六氯铅矿
پېننانتىت	锰绿泥石
پېننىنىت	叶绿泥石
پېنولوگىيە	刑罚学
پېنىتسىللامىن	青霉素胺
پېنىتسىللىنازا	青霉素酶
پېنېپلائىن	准平原
پېپتىدوگلىكولىپىد	肽糖脂
پېپسىن	胃蛋白酶
پېپلۇم	薄披联
پېگماتوئىد	伟晶相
پېگماتوفىر	伟斑岩
پېگماتىت	伟晶岩
پېگماتىتلىشىش	伟晶岩化
پەردازلىغۇچ	修整器
پەرقلەنمەسلىك	不相容
پەرمە	钻空器
پەرەڭگۈل	木芙蓉
پەلسەپىلىك	哲学性
پەنجابلىقلار	旁遮普人
پەنجىر	窗格子
پەنجىلىكلەر	有爪类
پەنشۇناسلىق	科学学
پەيقىلتىرىق	三芒草
پەيلاسوپ	哲学家
پەھلەۋى	巴列维
چائىرامىن	切尔明
چائۇلمۇگرا	晁模子
چاتاشماسلىق	不含糊
چادۋىك	查德威克
چاراسلاش	嚓嚓声
چارداق	暗楼子
چارلىغۇچى	巡行者
چارىسىز	不得已
چاسپەك	压缝条
چاغىرچاق	岩白菜
چاقىرتىلغۇچ	被传讯者
چاقىرغۇچ	呼叫器
چاكدار	查克达尔
چالغۇشۇناسلىق	乐器学
چالكوسىدېرىت	磷铜铁矿
چالكوسيانىت	铜靛石
چالكوفىللىت	云母铜矿
چالكومېنىت	蓝硒铜矿
چالچۇئىت	蓝绿松石
چاموزىت	鲕绿泥石
چامپلائىن	占勃兰
چايانئوت	天南星
چايخانىچى	茶博士
چاينىغۇچى	咀嚼式
چاپلىغۇچ	粘贴器
چاپمانىت	硅锑铁矿
چاچالاكا	喳喳雉
چاڭغىش	珊瑚树
چاۋىبېتول	佳味备醇
چكالوۋىت	硅铍钠石
چوئېپىت	柱铀矿
چوتكىلىغۇچى	刷子工
چورۇق	乔洛克
چوسونلار	朝鲜人
چوش	滴水槽
چوغلىنىدىغان	白炽地
چوقۇنغۇچى	崇拜者
چويۇنچى	炼铁工
چىئانا	奇安纳
چىتلاقچى	编离者
چىتلىماق	围起来
چىدامسىز	禁不住
چىدىيالماسلىق	忍耐不住
چىدىيالىماق	能够耐受
چىراتا	奇拉塔
چىراغچى	灯光技师
چىرىتىشچانلىق	腐蚀性
چىرىكلەشكەن	摧枯拉朽
چىرىندىلار	腐殖质
چىرىپا	奇里帕服
چىشسىزلار	无齿类
چىقارغۇچ	输出器
چىقىرغۇچ	蜂鸣器
چىقىرىندىلار	下下脚
چىكاگولۇق	芝加哥人
چىلىلىق	智利人
چىمئوت	灯心草
چىمچىت	乌铂树
چىمچىلىق	草坪业
چىمەنگۈل	锦带花
چىنا	白坯瓷器
چىڭدىغۇچ	压实器
چىگىشلىك	乌七八糟
چىگىك	接头儿
چۆللىشىش	荒漠化
چۆچۈتكۈدەك	触目惊心
چۆچۈتۋەتمەسلىك	鸡犬不惊
چۇرۇقلاشماق	叽叽喳喳
چۇغۇندەكلەر	夜鹰类
چۇلتېنىت	透砷铅矿
چۈجىخانا	孵化厂
چۈشۈك	流产胎
چۈشەندۈرۈلۈشى	说明书
چۈندەيسەي	裙带菜
چۈچۈك	酸味儿
چېتىشىشچانلىق	可交配性
چېدەر	绊马索
چېرېنكوپ	切连柯夫
چېرېپاشكا	象鼻虫
چېككېر	切克尔琴
چېكەتكىشۇناسلىق	蝗虫学
چېلىشقۇچى	摔交者
چېپىشماق	你追我赶
چەتلىشىش	边缘化
چەكسىزلىك	无限性
چەككىلىگۈچ	分馏器
ژابىرسىمان	鳃叶状
ژالمائىت	钽钛铀矿
ژېلاتىنازا	明胶酶
گائۇسمېتر	高斯计
گائۇلتېرىن	白珠树苷
گائېلشۇناس	盖耳学家
گائېللار	盖耳人
گاببرو	辉长岩
گاتورېيد	加多力
گادرومال	木分解酶
گادولىنىت	硅铍钇矿
گادىتلار	卡德人
گارمالول	哈马醇
گارمالىن	哈马灵
گارموتوم	交叠沸石
گارمونىفون	簧管键琴
گارمونىكا	和声学
گازومېتىر	气量计
گازچى	煤气人员
گاستالدو	驻节官
گاستروبلاست	营养胚
گاستروزوئوئىد	营养个员
گاسترولوگىست	胃病学家
گاسترونوم	美食家
گاسترونومىيە	美食学
گاستېروزۇئىد	取食个员
گاستېروسپورا	腹孢子
گاستېرومىتسېتلار	腹菌类
گاستېرېيە	原肠祖
گاسپېئىت	菱镁镍矿
گافنىيە	二氧化铪
گالازون	哈拉宗
گالاكتوئامىن	半乳糖胺
گالاكتوزا	半乳糖
گالاكتوزىد	半乳糖苷
گالاكتوزىل	半乳糖基
گالاكتولىپىد	半乳糖脂
گالاكتوگېن	半乳多糖
گالاكتىت	针钠沸石
گالاكتىتول	半乳糖醇
گالانتېرىيە	装饰乐章
گاللومانىيە	高卢狂
گاللۇسىنوگېن	致幻药
گاللېفلىنتا	长英角岩
گالوبىئونتلار	盐生生物
گالوترىخىت	铁明矾
گالوفورم	三卤甲烷
گالوفىتلار	盐生植物
گالومېتر	量盐计
گالوپروگىن	卤丙炔氧
گالوپېرىدول	氟哌啶醇
گالوگىدرىن	卤代某醇
گالوگېتونلار	盐生草属
گالىكستىن	加里斯丁
گالىپول	尬犁醇
گالىپىن	尬犁频
گالچالار	加尔查人
گالۋانوتروپىزم	向电性
گالۋانوپلاستىكا	电铸学
گالېنشۇناس	盖仑学家
گالېنىت	方铅矿
گالېگىن	山羊豆碱
گامارىتولوگىيە	犯罪说
گامبىر	黑儿茶
گامبېرگىت	硼铍石
گامون	交配素
گامېتوفورا	配子枝
گامېتىسىز	无配子
گان	重冲浪板
گاندالار	干达人
گاندوم	安全套
گاننىستېر	致密硅岩
گانوفىللىت	辉叶石
گانومالىت	硅钙铅矿
گانۇسىت	针镁石
گايدىنگېرىت	砷钙石
گايلۇسسىت	斜钠钙石
گايولار	卡约人
گاپتېن	半抗原
گاپلوئىد	单倍体
گاپلوستېل	单中柱
گاپلوفازا	单倍期
گاگېئىت	锰硅镁石
گاھنىت	锌尖晶石
گاۋشەنلەر	高山族人
گاۋچولار	高丘人
گبارىلار	格巴里人
گدرومېتىر	水速计
گرادىئومېتر	梯度计
گرادۇئاتور	分度器
گرادۇئالىزم	融合论
گرافولوگىيە	笔体学
گرافىكشۇناسلىق	图形学
گرامىتسىدىن	短杆菌肽
گراناتا	枪榴弹
گراناتاميوت	火箭筒
گرانوفىت	花斑岩
گرانىتلىشىش	花岗岩化
گراپتول	正笔石
گراۋىسفېرا	引力层
گراۋىمېتر	重差计
گروب	圣骨盒
گرىزېئوفۇلۋىن	灰黄霉素
گرىففىتىت	水绿皂石
گرىففىن	格里芬
گرىكۋالار	格里夸人
گرىمالدى	格里马第
گرىنالىت	铁蛇纹石
گرىنوۋىت	红榍石
گرۇنېرىت	铁闪石
گرېبولار	格列博人
گرېتسىزم	希腊主义
گرېكلەر	希腊人
گرېنادىن	石榴浆
گرېنلاندىيىلىكلەر	格陵兰人
گرېيسېن	云英岩
گرېگارىنوزىيە	聚居病
گلائۇتسىن	海婴粟碱
گلاتسىئومېتىر	冰川仪
گلادىئاتور	格斗者
گلاۋبېرىت	钙芒硝
گلاۋكوسېرىنىت	锌铜铝矾
گلاۋكونىت	海绿石
گلوبۇلىت	球雏晶
گلوبۇلىن	球蛋白
گلوسسېماتىكا	语符学
گلوككېرىت	纤水绿矾
گلىئوكسال	乙二醛
گلىئوكسالازا	乙二醛酶
گلىئوكسىم	乙二肟
گلىتسىدول	缩水甘油
گلىتسىررىزىن	甘草素
گلىتسېروئالدېگىد	甘油醛
گلىتسېروكىنازا	甘油激酶
گلىتسېرول	丙三醇
گلىتسېروژېلاتىن	甘油明胶
گلىتسېرىد	甘油酯
گلىتسېرىل	丙三基
گلىفوزات	草甘膦
گلىفوزىن	草甘二膦
گلىكوسىئامىن	胍基醋酸
گلىكوكالىكس	腊梅糖
گلىكوللار	二醇类
گلىكولىپىد	糖脂质
گلىپتال	甘酞树脂
گلىپتودون	雕齿兽
گليۇكوفورا	生甜团
گلۇتاتىئون	谷胱甘肽
گلۇتارىل	戊二酰
گلۇتامويل	谷氨酰基
گلۇتامىن	谷酰胺
گلۇتامىنازا	谷酰胺酶
گلۇتسىتول	葡糖醇
گلۇتېلىن	谷蛋白
گلۇتېنىن	麦谷蛋白
گلۇكوزا	葡萄糖
گلۇكوزامىن	葡糖胺
گلۇكوسازون	葡糖脎
گلۇكوسۇلفون	葡糖砜
گلۇكوپىرانوزا	葡吡喃糖
گلېسسىت	圆树脂石
گنوستىلىشىش	诺斯替化
گوئالىقلار	果阿人
گوئېرنېزىت	砷镁石
گوتلار	哥特人
گودوگراف	速矢端迹
گورتسېئىكسىت	磷钡铝石
گورتونچىلار	戈顿教派
گوردونىت	磷镁铝石
گوردېنىن	大麦芽碱
گورنبلېند	角闪石
گورىزون	母岩层
گورگون	戈耳工
گوسسىپول	棉子酚
گوسسىپىن	棉纤维素
گوسسىپېتىن	棉花色素
گوسپورت	通话管
گوشېنىت	透绿柱石
گولالار	戈拉人
گولدىلار	哥尔迪人
گوللاندىت	钡硬锰矿
گوللاندىيىلىكلەر	尼德兰人
گولوزىد	纯苷类
گولوسېلليۇلوزا	全纤维素
گولوكوككولىت	全颗石
گولومېتابولا	全变态类
گولومېتابولىزم	全变态
گولوگامېتا	全配子
گولوگونىيە	全发生
گوماتروپىن	后马托品
گوموئىستېلا	拟箭果核
گوموتىپلىق	同型性
گوموزىگوتا	纯合子体
گوموسفېرا	均质层
گوموسىستىن	高胱氨酸
گوموسپورىيە	孢子同型
گوموسېرىن	高丝氨酸
گوموسېكسۇئالىزم	同性恋
گوموكاريون	同核体
گوموكرىستال	等粒晶体
گومولوگلار	同系物
گومومورفوز	形态同相
گوموپلازىيە	同形质
گوموگامىيە	同质繁殖
گوموگامېتا	配子同型
گوموگونىيە	花蕊同长
گوموگېنتىزىكازا	尿黑酸酶
گوموگېنىيە	形质相同
گومىنىزم	人性主义
گومېئومورف	同形物
گومېرولوگىست	荷马学家
گوندلار	冈德人
گونناردىت	变杆沸石
گونوخېما	性水母体
گونوپلازما	生殖质
گونىئاد	角沙蚕
گونىئومېتىر	测角计
گونىدىي	微生子
گونىموبلاست	产孢丝
گونىمولوب	产孢瓣
گويازىت	磷铝锶石
گوپېئىت	磷锌矿
گوگولار	戈戈人
گوۋۇيۈەن	国务院
گىئاتسىنتىن	苯乙醛
گىئورتداخلىت	片榍石
گىبشىت	水榴石
گىبىتان	洗必太
گىتار	吉他琴
گىتالىن	芰他灵
گىتوكسىن	芰毒素
گىتونىن	芰皂苷
گىتوگېنىن	芰皂配基
گىدراتلار	水合物
گىدراتلاش	补给水分
گىدرازا	水化酶
گىدرازىدىن	酰肼定
گىدراستىن	白毛茛碱
گىدراۋلۇس	木动风琴
گىدروئۇگراندىت	水钙榴石
گىدروئېلاستىكلىق	流动弹性
گىدروبوراتسىت	水硼石
گىدروبىئوتىت	水黑云母
گىدروبېنزوئىن	氢化偶姻
گىدروتالتسىت	水滑石
گىدروتۇنگستىت	水钨化
گىدروخلورلىشىش	氢氯化
گىدروخلورىد	氢氯化物
گىدروخىمىيە	水化学
گىدروخىنىن	氢化奎宁
گىدروزوما	水螅群体
گىدروسىنكىت	水锌矿
گىدروسىيانىد	氢氰化物
گىدروسۇلفىد	氢硫化物
گىدروسېرۇسسىت	水白铅矿
گىدروفان	水蛋白石
گىدروفتورىد	氢氟化物
گىدروفلو	海德洛
گىدروفور	采水样器
گىدروفون	水听器
گىدروفىتون	叶状个员
گىدروكاليۇمىت	水铝钙石
گىدروكاۋچۇك	氢化橡胶
گىدروكراكىنگلىنىش	氢化裂解
گىدروكسوكوبالامىن	羟钴铵
گىدروكسىد	氢氧化物
گىدروكسىسئوكسازول	土菌消
گىدروكسىللاشتۇرۇش	羟基化
گىدروكوللوئىد	水胶体
گىدرولاككولىت	水岩盖
گىدرولىت	水解质
گىدرولىزلىغۇچ	水解器
گىدرولىمفا	水淋巴
گىدرومانگېزىت	水菱镁石
گىدرومېترىيە	水文测验
گىدرومېخانىكا	流体力学
گىدرومېدۇزا	水螅水母
گىدرويودىد	氢碘化物
گىدروپولىپ	水螅芽体
گىدروپونىكا	溶液增养
گىدروپېرىكاردىيە	心包积水
گىدروگارنېت	水榴石族
گىدروگاللوئىزىت	水埃洛石
گىدروگاللىد	氢卤化物
گىدروگرۇسسۇلارىت	水绿榴石
گىدروگېتېرولىت	水锌锰矿
گىدروگېل	水凝胶
گىدروگېماتىت	水赤铁矿
گىدروگېنازا	氢化酶
گىدرىد	氢化物
گىدرۇلا	螅状子
گىرازول	青蛋白石
گىرخانا	过磅房
گىروسكوپىكا	陀螺力学
گىروسېراكون	环角石壳
گىروكومپاس	陀螺罗盘
گىروماگنېتىكا	旋磁学
گىرچى	过磅员
گىرۇدىن	水蛭素
گىزىنگېرىت	硅铁石
گىستازارىن	后茜素
گىستامىنازا	组胺酶
گىسترىئوبدېللار	肌蛭类
گىسترىخوسفېرلار	刺球藻类
گىستوتروپىزم	向组织性
گىستوزىما	马尿酸酶
گىستولىز	组织溶解
گىستون	组蛋白
گىستوگرافىيە	组织图谱
گىستوگېن	组织原
گىستىدازا	组氨酸酶
گىستىدىن	组氨酸
گىستېروتېلىيە	分化滞缓
گىستېروسكوپ	子宫镜
گىسلوپىت	海绿解石
گىسموندىت	水钙沸石
گىللېبراندىت	针硅钙石
گىللېسپىت	硅铁钡矿
گىلىدىڭلاتقۇ	摇头丸
گىلەمچى	地毯工
گىمنوسوفىستلار	裸体哲人
گىمنوسپورا	裸孢子
گىمنوپلاست	裸原浆
گىمنوپېدىيە	体操舞
گىمېنولىخېنلار	层菌衣类
گىمېنوپودىي	子实层基
گىمېنىي	子实属
گىنازا	雌素酶
گىناندرومورف	雌雄嵌体
گىنورىت	水硼钙石
گىنۇرا	土三七属
گىنېكولوگىيە	妇科学
گىپاندرىيە	下生殖板
گىپسوفىل	高出叶
گىپنوزلۇق	催眠术
گىپنوسپورا	静止孢子
گىپنولوگىيە	催眠学
گىپنون	苯乙酮
گىپوبازىدىيە	下担子
گىپوبلاست	下胚叶
گىپوبىئوز	底生活力
گىپوخلورىدرىيە	胃酸过少
گىپوخوندرىيە	疑病症
گىپوزوخروما	浅色团
گىپوستازا	承珠盘
گىپوسىكلوئىد	内摆线
گىپوفامىن	垂体胺
گىپوكسانتىن	次黄嘌呤
گىپوپلوئىد	亚倍体
گىپوۋانادات	次钒酸盐
گىپېرئىنفېكسىيە	过度感染
گىپېربولا	双曲线
گىپېربولوئىد	双曲面
گىپېرسفېرا	多维球
گىپېرسونىك	特超声
گىپېركرىئالگېزىيە	冷觉过敏
گىپېرماستىگوتا	超鞭毛虫
گىپېرىتسىن	金丝桃素
گىپېرپارازىت	重寄生
گىپېرپلوئىد	超倍体
گىپېرپلوئىدلىق	超倍性
گىپېرگاماز	过交配
گىپېرېرگىيە	超反应性
گىپېرېستېزىيە	感觉过敏
گىگانتوستراكا	巨介壳类
گىگروكىنېز	湿动态
گىگرولوگىيە	湿度学
گىگرومىتسىن	潮霉素
گىگرىستور	湿敏电阻
گيۇبا	居巴雨飑
گيۇسيامىن	天仙子胺
گيۇيگېنس	惠更斯
گيېتولوگىيە	降水量学
گۆشچۈرۈك	炸香酥肉
گۇئائىئاكول	愈创木酚
گۇئائىئول	愈创木醇
گۇئاتولار	瓜托人
گۇئاتۇسولار	瓜土索人
گۇئاخىبولار	瓜希波人
گۇئاخىرولار	瓜希罗人
گۇئادالكازارىت	锌黑辰砂
گۇئارانىلار	瓜拉尼人
گۇئارايولار	瓜拉瑶人
گۇئارايۇلار	瓜拉友人
گۇئاساۋېلار	瓜萨维人
گۇئاكسىما	古阿斯麻
گۇئاملىقلار	关岛人
گۇئامولار	瓜莫人
گۇئاناجۇئاتىت	硒铋矿
گۇئانازا	鸟嘌呤酶
گۇئانالار	瓜纳人
گۇئانىن	鸟嘌呤
گۇئانچېلار	瓜恩切人
گۇئانېتىدىن	胍乙啶
گۇئاياكىلار	瓜亚基人
گۇئايتاكالار	圭塔卡人
گۇئايكۇرۇلار	圭库鲁人
گۇئېبنېرىت	钨锰矿
گۇئېتارلار	瓜塔尔人
گۇتتونىت	硅钍石
گۇتى	古梯人
گۇجارلار	古吉尔人
گۇدمۇندىت	硫锑铁矿
گۇدۇڭلاشماق	交头接耳
گۇرخالار	廓尔喀人
گۇرىئانلار	古利亚人
گۇلا	外咽片
گۇللاخلار	格勒人
گۇلوزا	古罗糖
گۇمانچىلىق	怀疑哲学
گۇممىت	脂铅铀矿
گۇمىت	硅镁石
گۇمۇلون	葎草酮
گۇمۇلېن	葎草烯
گۇيتۇزا	绿帽子
گۇپپاڭچى	捧场的人
گۇڭرىماق	咿呀学语
گۈلئەنبەر	飞燕草
گۈلبازات	文殊兰
گۈلجىنەستە	榆叶梅
گۈلدارچىن	肉桂子
گۈلدۈرلەش	嚓嘎声
گۈلقىيار	柳叶菜
گۈلمەريەم	晚香玉
گۈڭگۈرتسىزلەشتۈرگۈچ	脱硫器
گۋاردىيە	近卫军
گۋىئانالىقلار	奎亚那人
گۋىناۋلار	几瑙人
گۋېسدىزم	盖德主义
گېئاركسۇتىت	钙铝氟石
گېئوئېكولوگىيە	地生态学
گېئوتىت	针铁矿
گېئوتىد	地球体
گېئوتېخنولوگىيە	地工学
گېئوتېرمىكا	地热学
گېئوخىمىيە	地球化学
گېئورتولوگىيە	教历学
گېئوسكوپىيە	测地学
گېئوسىستېما	地理系统
گېئوكرىئولوگىيە	冻土学
گېئومورفولوگىست	地貌学家
گېئومېتىرىيە	几何学
گېئومېخانىكا	地质力学
گېئومېدىتسىنا	风土医学
گېئوپوتېنسىئال	地球势
گېئوپوتېنسىئالمېتر	位势米
گېت	有槽导板
گېترازان	海群生
گېتېروئاتوم	杂原子
گېتېروئىئون	杂离子
گېتېروبازىدىيە	异担子
گېتېروتروفىت	异养植物
گېتېروتسىست	异形胞
گېتېروجۇنكسىيە	异质结
گېتېروخروماتىن	异染色质
گېتېروخرونىزم	异时发生
گېتېروداكتىلىزم	单侧多
گېتېروزوئوئىد	异个员
گېتېروزىد	异糖苷
گېتېروزىگوت	杂合子
گېتېروسفېرا	非均质层
گېتېروسپورىيە	孢子异型
گېتېروكارىئون	异核体
گېتېروكاريوز	异核增多
گېتېروكسانتىن	杂黄嘌呤
گېتېروكوككولىت	异颗石
گېتېرولالىيە	异语症
گېتېرولوگىيە	异种性
گېتېرومېتاپلازىيە	异形发育
گېتېرونومىيە	异律性
گېتېرووسكوپ	斜视镜
گېتېروپلوئىد	异倍体
گېتېروپىكنوز	异固缩
گېتېروگونىيە	花蕊异长
گېتېروگېنلىق	异质性
گېتېلار	盖蒂人
گېدانىت	脂光琥珀
گېدرون	晶面体
گېدرىت	铝直闪石
گېدلېيىت	碲铋齐
گېدونومېتر	快乐计
گېدونىزم	快乐说
گېدىفان	钙砷铅矿
گېدېنبېرگىت	钙铁辉石
گېدەيگەن	趾高气扬
گېراردتىت	铜硝石
گېرانئول	牻牛儿醇
گېرانىئال	牻牛儿醛
گېرانىل	牻牛儿基
گېردېرىت	磷铍钙石
گېرزېنبېرگىت	硫锡矿
گېرسدورففىت	辉砷镍矿
گېرسىنىت	铁尖晶石
گېرشېل	赫谢耳
گېرمافرودىت	半阴阳体
گېرمانلاشتۇرۇش	日耳曼化
گېرمانىد	锗化物
گېرمانىيىلىك	日耳曼人
گېرمپلازمىخانا	种质圃
گېرپېتولوگىيە	爬虫学
گېزېۋۇدىت	六硫镍矿
گېسپېرىدىن	橙皮碱
گېشۇرلار	格苏尔人
گېكتورىت	锂蒙脱石
گېكسائاكتىنوزا	六放目
گېكسابرومىد	六溴化物
گېكسابىئوزا	双己糖
گېكساترىكونتان	三十六烷
گېكساخلوران	六六六
گېكساخلوروفېن	六氯芬
گېكساخلوروپروپىلېن	六氯丙烯
گېكسادىئېن	己二烯
گېكسادېتسېن	十六烯
گېكسادېكان	十六烷
گېكسافتورات	六氟盐
گېكسافتورىد	六氟化物
گېكساكونتان	六十烷
گېكساممىن	六氨络物
گېكسامېتىلېن	六亚甲基
گېكسامېر	六聚物
گېكساپلوئىد	六倍体
گېكساگىدرات	六水合物
گېكساگىدرىت	六水泻盐
گېكساگىدرىدلىشىش	六氢化
گېكسوزان	己聚糖
گېكسوكسىد	六氧化物
گېكسوكىنازا	己糖激酶
گېكسوگېن	六素精
گېكسىتول	己糖醇
گېكسېسترول	己雌酚
گېلسېمىن	钩吻碱
گېللاندىت	钙钇饵石
گېلمىنتولوگىيە	蠕虫学
گېلىئانتىن	半日花素
گېلىئودون	日影仪
گېلىئوستات	定日镜
گېلىئوفىللىت	日叶石
گېلىئولىت	日射珊瑚
گېلىئومېتر	量日仪
گېلىئومېتىر	测日计
گېلىكسومېتر	窥膛镜
گېلىكورۇبىن	蜗红质
گېلىكوسپورا	盘孢子
گېلىماگنېت	螺旋磁体
گېلىماگنېتىزم	螺旋磁性
گېلۋىت	日光榴石
گېلېنالىن	堆心菊素
گېلېنىن	核勒宁
گېماتوبرانخىيىلەر	血枝类
گېماتوخروم	血色素
گېماتوخروما	红色素
گېماتوخروموگېن	血色原
گېماتوسكوپ	血分光镜
گېماتوفانىت	红铁铅矿
گېماتوكسىلىن	苏木精
گېماتولوگىيە	血液学
گېماتولىت	红砷锰矿
گېماتوپورفىرىن	血卟啉
گېماتىن	苏木红
گېمافىبرىت	红纤维石
گېمالبۇمىن	血蛋白
گېمانگىئوما	血管瘤
گېموئېرىترىن	血赤藓素
گېموسېنزىتىن	血致敏素
گېموفۇسسىن	血棕色素
گېموكۇپرېئىن	血铜蛋白
گېمولىزىن	溶血素
گېموپىررول	血吡咯
گېموپېرىكاردىيە	心包积血
گېموگلوبىن	血红蛋白
گېمىئائۇكسىن	半茁长素
گېمىتروپىك	半体双晶
گېمىخىنونوئىد	半醌型
گېمىسپورا	半孢子
گېمىفورم	半型锈菌
گېمىمېللىتىن	连三甲
گېمىپتېرولوگىيە	半翅目学
گېمىگېدرون	半面体
گېمېرىترىن	血皱素
گېمېلىنىت	钠菱沸石
گېنتامىتسىن	庆大霉素
گېنترىئاكونتان	三十一烷
گېنتىئانوزا	龙胆糖
گېنتىئانىن	龙胆宁
گېنتىئوبىئوزا	龙胆二糖
گېنتىئوپىكرىن	龙胆苦素
گېنتىزىن	龙胆黄素
گېنتېلۋىت	金瑟矿
گېنىستىن	染料木苷
گېنىستېئىن	染料木因
گېنېسېرىن	金丝碱
گېيكىئېلىت	镁钛矿
گېپاتوتوكسىن	肝毒素
گېپاتوكۇپرېئىن	肝铜蛋白
گېپاتىكولوگىيە	苔类学
گېپارىنلىشىش	肝素化
گېپتادېتسىل	十七烷基
گېپتادېكان	十七烷
گېپتاسۇلفىد	七硫化物
گېپتافىللىت	七叶云母
گېپتاكورد	七声音阶
گېپتاكوسان	二十七烷
گېپتامېر	七聚体
گېپتاپلوئىدلىق	七倍性
گېپتاگون	七边形
گېپتاگىدرات	七水化物
گېپتوكسىد	七氧化物
گېپتىتول	庚七醇
گېگېل	黑格尔
گېگېنىئون	抗衡离子
گېۋېتتىت	针钒钙石
گەسىپلەشتۈرۈش	产业化
گەندىخور	食粪者
ھاجەمىلەر	哈兹米人
ھادروزاۋر	鸭嘴龙属
ھارامخور	小动作癖
ھارامخورلۇق	小动作
ھاربىق	胡黄连
ھاردىستونىت	锌黄长石
ھارلېخ	哈莱克
ھارلېمىتلار	哈莱姆人
ھاشاراتخورلار	原兽类
ھاففىر	海菲尔
ھالقىمىپەنشۇناسلىق	跨学科学
ھاللويسىت	埃洛石
ھالۋا	糖糊糊
ھاماتىتلار	哈玛特人
ھاماقەتلىك	老糊涂
ھانوفېرلىق	汉诺威人
ھاياسىزلىق	荒淫无耻
ھايدالار	海达语族
ھايۋاناتخورلار	食动物类
ھايۋانلاشتۇرۇش	动物化
ھاڭگىت	赤麻鸭
ھاۋالىنامە	委托书
ھورلاندۇرغۇچ	蒸发器
ھورلىغۇچ	蒸煮器
ھورمونولوگىيە	激素学
ھوقۇقدار	当权派
ھوقۇقدارلار	皇亲国戚
ھوقۇقشۇناس	法理学家
ھولولوپ	毛毛腾腾
ھولوگراف	全息照相
ھولوگرامما	全息图
ھىتچىتىلار	希契蒂人
ھىدرالىقلار	希德拉人
ھىدروئاكۇستىكا	水声学
ھىدرودىنامىكا	水动力学
ھىدروگراف	过程线
ھىدروگېنلاشتۇرۇش	氢化处理
ھىستولوگىيە	组织学
ھىستوگرامما	直方图
ھىكاكلار	希卡克人
ھىكسوس	牧人王
ھىمالار	希马人
ھىميارىتلار	希米亚人
ھىندىزم	印度教
ھىپوپۇس	休眠体
ھيۇستونلۇقلار	休斯敦人
ھيېت	宗教节日
ھۆججەتشۇناسلىق	文献学
ھۆججەتلىك	带文件
ھۆددىگەرلىك	大包干
ھۆرمەتلەنمەك	受人尊敬
ھۇتتېل	许特尔
ھۇزۇرسىزلىق	不自在
ھۇمىزم	休谟主义
ھۈجەيرىشۇناسلىق	细胞学
ھۈرپەيگەن	毛蓬蓬
ھېتېرولىت	锌锰矿
ھېساباتشۇناسلىق	簿记学
ھېسابسىز	数不清
ھېسابلىنىشچان	可计算
ھېسابلىنىشچانلىق	可计算性
ھېسىپلىق	面肺子
ھېقىقلىشىش	玛瑙化
ھېكايىلەشتۈرۈش	小说化
ھېكتونيۇتون	百牛顿
ھېلانكا	海兰卡
ھېللېبورىن	铁筷子
ھېلىھىلە	伊里拉
ھېيدېلبېرگلىقلار	海德堡人
ھېيزېنبېرگ	海森堡
ھەبەبلەر	哈巴布人
ھەربىيلەشمەسلىك	非军事化
ھەرىكەتلەندۈرگۈچ	动化器
ھەشتار	艾西塔尔
ھەشىمەتپەرەسلىك	豪华癖
ھەققانىيەتسىز	非正义
ھەققانىيەتچى	正义者
ھەمتاۋاق	臭味相投
ھەمدۇسانا	赞美诗
ھەمراھلاشتۇرۇش	卫星化
ھەيئەت	委员会
ھەيكەلتىراش	雕塑家
ۋائىزخان	说教者
ۋائۇدېۋىل	轻歌舞剧
ۋائېزىت	方硫镍矿
ۋاتتېر	瓦消耗者
ۋاتتېۋىللېئىت	灰芒硝
ۋاتمېتر	瓦特计
ۋاتېرىت	六球解石
ۋاتېرپاس	水准器
ۋاجرايانا	金刚乘
ۋارشاۋالىق	华沙人
ۋارنا	卡斯特
ۋارونكىسىمان	漏斗状
ۋارىئوگراف	变量计
ۋارىسسىت	磷铝石
ۋارىنتور	变感器
ۋارۋىككىت	硼镁钛矿
ۋازودېنتىن	血管齿质
ۋازېلىن	凡士林
ۋاسابى	瓦沙比
ۋاسىتسىن	瓦丝素
ۋاسىتىپەرەسلىك	工具主义
ۋاشىنگتونلۇق	华盛顿人
ۋاشېگىئىت	纤磷铝石
ۋاقىتداشلىق	同时性
ۋاقىتشۇناسلىق	时间学
ۋاكۇئوممېتىر	真空表
ۋاكۇئۇملاشتۇرماق	抽真空
ۋالتېرىت	碳酸铋矿
ۋالكىرىيە	瓦尔基莉
ۋاللېرىت	墨铜矿
ۋالىتىن	凡力丁呢
ۋالىن	缬氨酸
ۋالىنومىتسىن	缬氨霉素
ۋالپۇرگىت	砷铀铋矿
ۋالۋۇلا	产卵瓣
ۋالېرات	戊酸盐
ۋالېرامىد	戊酰胺
ۋالېرولاكتون	戊内酯
ۋالېنسىيە	巴伦西亚
ۋاندېنبراندېئىت	绿铀矿
ۋانكومىتسىن	万古霉素
ۋانكومېتر	光泽度仪
ۋاننانېن	万年能
ۋانوكسىت	复钒矿
ۋانىللا	香草香精
ۋانىللازارلىق	香果兰园
ۋانىللويل	香草酰
ۋانىللىل	香草基
ۋانىللىن	香草醛
ۋايراكىت	斜钙沸石
ۋاپورىمېتر	挥发度计
ۋاگنېرىت	氟磷镁石
ۋاھابى	瓦哈卜派
ۋاھۇ	紫果卫矛
ۋاۋىلوف	瓦维洛夫
ۋاۋېللىت	银星石
ۋاۋېمېتىر	波长计
ۋراتار	守门员
ۋلاكلار	弗拉克人
ۋلاچلار	弗拉其人
ۋوخلېرىت	铌锆钠石
ۋورتىتسىزم	旋涡派
ۋوروبيېۋىت	铯绿柱石
ۋوزبۇدىتېل	励磁机
ۋوكودېر	声码器
ۋولبورتىت	水钒铜矿
ۋولتائىت	绿钾铁矾
ۋولتامېترىيە	伏安法
ۋولتامېتىر	电量计
ۋولتمېتر	伏特计
ۋولتولىز	肝锌矿
ۋولتون	沃尔顿
ۋولف	沃尔夫
ۋولفرامىت	黑钨矿
ۋولففىيە	无根萍
ۋوللاستون	渥拉斯顿
ۋوللاستونىت	硅灰石
ۋومىتسىن	呕吐素
ۋومېنولوگىيە	妇女学
ۋىئوستېرول	紫甾醇
ۋىئولارىت	紫硫镍矿
ۋىئولاكسانتىن	紫黄质
ۋىئولان	紫透辉石
ۋىئولانترون	酮紫蒽
ۋىئولانىن	堇菜苷
ۋىئولوتتا	次中提琴
ۋىئومىتسىن	紫霉素
ۋىبرافون	颤音琴
ۋىبراكۇليۇم	振鞭体
ۋىبرومېتىر	振动计
ۋىتازۇل	维泰素
ۋىتالىزاتسىيىلىشىش	生机化
ۋىتالىزم	生机论
ۋىتامىت	黄红帘石
ۋىتامىن	维生素
ۋىتامىنولوگىيە	维生素学
ۋىتتىخېنىت	硫秘铜矿
ۋىتروفىرې	玻斑岩
ۋىترىنىت	镜煤素质
ۋىترېئودېنتىن	硬牙质
ۋىترېئوزىل	熔凝石英
ۋىتسىئانوزا	野豌豆糖
ۋىتسىئانىن	野豌豆苷
ۋىتسىن	野豌豆碱
ۋىتېرىت	毒重石
ۋىجناناۋادا	唯识论
ۋىدېمان	维德曼
ۋىرولوگىست	病毒学家
ۋىرولوگىيە	病毒学
ۋىرى	均位力积
ۋىرىدىن	绿木霉素
ۋىرۇسلۇق	病毒性
ۋىزانتىيىلىكلەر	拜占庭人
ۋىزىئومېتر	能见度表
ۋىزېئىت	磷沸石
ۋىستسىن	槲寄生素
ۋىكېنو	维克诺族
ۋىلسون	威耳逊
ۋىللانېللا	维拉内拉
ۋىللىئامىت	威廉党人
ۋىللىيامسىت	玉蛇纹石
ۋىللىۋاۋ	威利瓦飑
ۋىللېمىت	硅锌矿
ۋىنتېرگرىنويل	冬绿油
ۋىندل	温特耳
ۋىنكرىستىن	长春新碱
ۋىنىئون	维尼昂
ۋىنىلوگ	插烯物
ۋىنىلىدېن	亚乙烯基
ۋىنىن	葡萄霜
ۋىگنېتتېر	渐晕器
ۋىۋىئانىت	蓝铁矿
ۋيالا	沙尔杜拉
ۋيېتناملاشتۇرۇش	越南化
ۋيېتناملىقلار	越南人
ۋۇدخۇزېئىت	磷钙铝矾
ۋۇدۋاردىت	水铜铝矾
ۋۇرىزىت	纤锌矿
ۋۇستىت	方铁矿
ۋۇلفېنىت	钼铅矿
ۋۇلپىنىت	鳞硬石膏
ۋېئاتخىت	水硼锶石
ۋېبلېن	凡勃伦
ۋېبلېنچىلار	凡勃伦派
ۋېتىۋون	香根草酮
ۋېتىۋېرول	香根草醇
ۋېتىۋېن	香根草烯
ۋېخرلىت	叶碲铋矿
ۋېددوئىدلار	类维达人
ۋېددېللىت	草酸钙石
ۋېراترالدېگىد	藜芦醛
ۋېراترامىن	藜芦胺
ۋېراترول	藜芦醚
ۋېراترويل	藜芦酰
ۋېراترىدىن	藜芦定
ۋېراترىل	藜芦基
ۋېراترىلىدىن	藜芦叉
ۋېرباسكوزا	毛蕊花糖
ۋېربېنالىن	马鞭草灵
ۋېربېنون	马鞭烯酮
ۋېرساتكا	排字盘
ۋېرستاتكا	活版框
ۋېرسېتكا	排字手托
ۋېرسېن	维尔烯
ۋېرمونت	佛蒙特
ۋېرمونتلۇقلار	佛蒙特人
ۋېرمىلىئونېت	赛银珠
ۋېرمىلىنگۋا	虫舌总科
ۋېرمىلىنگۋىيە	虫舌类
ۋېرنولات	灭草猛
ۋېرنونىن	斑鸠菊苷
ۋېرنىئېر	游标尺
ۋېستېت	韦斯泰特
ۋېكتورمېتىر	矢量计
ۋېكتوپلۇۋىئومېتىر	雨向计
ۋېكتوگراف	立体照相
ۋېلسىت	钙交沸石
ۋېلفارىزم	福利主义
ۋېلىگېر	面盘幼体
ۋېلېتا	维列塔舞
ۋېنتىلاگىن	翼核果素
ۋېنتىلياتور	通风机
ۋېنتىليار	通风器
ۋېنىتسىيىلىك	威尼斯人
ۋېنېرېئولوگىيە	性病学
ۋېيسباخىت	钡重晶石
ۋېيسسىت	黑碲铜矿
ۋېگېتارىئانىزم	素食主义
ۋەتەنپەرۋەر	爱国者
ۋەدىلەشكۈچى	立约者
ۋەدىنامە	保证人
ۋەزىنلىك	重甸甸
ۋەسىي	监护人
ۋەقەلىكى	故事性`
  .split("\n")
  .map((line) => line.split("\t"));

export default function randomWord() {
  return wordList[Math.floor(Math.random() * wordList.length)];
}
